webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports) {

module.exports = angular;

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {"app":{"title":"Spike by ike","url":"https://app.ikegps.com"},"package":{"version":"4.0.0"},"parse":{"appid":"gZ0vgr8nq9xS3qfjRySzVDl5lssgp0LXWD6qB7Ym","appkey":"zsxHiymuyKm50yRFWs3rlffOVJ4I3OefMO0cQfzQ","path":"/1"},"map":{"mapLocation":"https://api.mapbox.com/styles","mapId":"v1/mapbox/streets-v11/tiles","apiKey":"pk.eyJ1IjoiZGV2b3BzYXRpa2UiLCJhIjoiY2w0cDNrbHZjMDAwNjNqb2V1NnR4aGdieCJ9.gXMC68M-JsVoHpKY3_KBng"},"logentries":{"client":"5d125549-154b-476d-9469-b484ba6125cc"},"analytics":{"google":"UA-38340019-5"},"stripe":{"key":"pk_live_a39Ejqq84xNAVnT9s8oVYTzY"}}; // eslint-disable-line


/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<layout-container direction=\"row\">\n<layout-content>\n<ike-sidebar sidebar-title=\"{{ capture.getName() || ('COMPONENT.CAPTURE.NEW_MEASUREMENT' | translate )}}\">\n<ike-breadcrumb change-step=\"pmViewCtrl.saveThenChangeStep\" capture=\"capture\"></ike-breadcrumb>\n<div class=\"pages-photo-measure-sidebar-alignmentInstructions\" ng-show=\"pmViewCtrl.isCurrentStep(STEPS.ALIGN)\" ng-bind-html=\"'PHOTO_MEASURE.ALIGNMENT_HELP' | translate | html\"></div>\n<measurements-detail class=\"pages-photo-measure-sidebar-measurements\" ng-show=\"pmViewCtrl.isCurrentStep(STEPS.MEASURE)\" measurements=\"measurements\" active-measurement=\"pmViewCtrl.getActiveMeasurement()\" activate-measurement=\"pmViewCtrl.activateMeasurement\" note=\"note\">\n</measurements-detail>\n</ike-sidebar>\n</layout-content>\n<layout-content grow=\"true\">\n<layout-container direction=\"column\">\n<layout-content>\n<ike-toolbar>\n<ike-button class=\"pages-photo-measure-toolbar-save\" ng-click=\"pmViewCtrl.save()\">\n<i class=\"pages-photo-measure-tool-icon-save\"></i>\n</ike-button>\n<ike-button title=\"{{ 'PHOTO_MEASURE.DELETE_SHAPE' | translate }}\" class=\"pages-photo-measure-toolbar-deleteMeasurement\" ng-show=\"pmViewCtrl.isCurrentStep(STEPS.MEASURE)\" ng-click=\"pmViewCtrl.deleteActiveMeasurement()\">\n<i class=\"pages-photo-measure-tool-icon-deleteshape\"></i>\n</ike-button>\n<ike-button title=\"{{ 'PHOTO_MEASURE.DELETE_HANDLE' | translate }}\" class=\"pages-photo-measure-toolbar-deleteHandle\" ng-show=\"pmViewCtrl.isCurrentStep(STEPS.MEASURE)\" ng-click=\"pmViewCtrl.deleteActiveHandle()\">\n<i class=\"pages-photo-measure-tool-icon-deletepoint\"></i>\n</ike-button>\n<span class=\"pages-photo-measure-toolbar-separator\"></span>\n<ike-button class=\"pages-photo-measure-toolbar-align\" ng-class=\"{active: pmViewCtrl.isLayerActive(LAYERS.ALIGNMENT)}\" ng-show=\"pmViewCtrl.isCurrentStep(STEPS.ALIGN)\" ng-click=\"pmViewCtrl.getAutoAlignmentPolygon()\">\n<i ng-class=\"{'pages-photo-measure-tool-icon-align': !pmViewCtrl.isLayerActive(LAYERS.ALIGNMENT), 'pages-photo-measure-tool-icon-align-active': pmViewCtrl.isLayerActive(LAYERS.ALIGNMENT)}\"></i>\n{{ 'PHOTO_MEASURE.ALIGN' | translate }}\n<div ng-show=\"pmViewCtrl.canCorrectPerspective() === false\" class=\"pages-photo-measure-perspective-correct\" title=\"Spike Pro required to use this feature.\">\n<div class=\"ProBadge ProBadge--TopRight\">pro</div>\n<div class=\"material-icons pro-lock pro-lock-small pro-lock-overlay\">lock_outline</div>\n</div>\n</ike-button>\n<ike-button class=\"pages-photo-measure-toolbar-align\" ng-class=\"{active: pmViewCtrl.isLayerActive(LAYERS.ALIGNMENT)}\" ng-show=\"pmViewCtrl.isCurrentStep(STEPS.ALIGN)\" ng-click=\"pmViewCtrl.resetAlignment()\">\n<i ng-class=\"{'pages-photo-measure-tool-icon-align': !pmViewCtrl.isLayerActive(LAYERS.ALIGNMENT), 'pages-photo-measure-tool-icon-align-active': pmViewCtrl.isLayerActive(LAYERS.ALIGNMENT)}\"></i>\n{{ 'PHOTO_MEASURE.RESET_ALIGN' | translate }}\n<div ng-show=\"pmViewCtrl.canCorrectPerspective() === false\" class=\"pages-photo-measure-perspective-correct\" title=\"Spike Pro required to use this feature.\">\n<div class=\"ProBadge ProBadge--TopRight\">pro</div>\n<div class=\"material-icons pro-lock pro-lock-small pro-lock-overlay\">lock_outline</div>\n</div>\n</ike-button>\n<ike-button class=\"pages-photo-measure-toolbar-area\" ng-class=\"{active: pmViewCtrl.isLayerActive(LAYERS.MAIN)}\" ng-show=\"pmViewCtrl.isCurrentStep(STEPS.MEASURE)\" ng-click=\"pmViewCtrl.activate(LAYERS.MAIN)\">\n<i ng-class=\"{'pages-photo-measure-tool-icon-area': !pmViewCtrl.isLayerActive(LAYERS.MAIN), 'pages-photo-measure-tool-icon-area-active': pmViewCtrl.isLayerActive(LAYERS.MAIN)}\"></i>\n{{ 'PHOTO_MEASURE.AREA' | translate }}\n</ike-button>\n<ike-button class=\"pages-photo-measure-toolbar-cutout\" ng-class=\"{active: pmViewCtrl.isLayerActive(LAYERS.CUTOUT)}\" ng-show=\"pmViewCtrl.isCurrentStep(STEPS.MEASURE)\" ng-click=\"pmViewCtrl.activate(LAYERS.CUTOUT)\">\n<i ng-class=\"{'pages-photo-measure-tool-icon-cutout': !pmViewCtrl.isLayerActive(LAYERS.CUTOUT), 'pages-photo-measure-tool-icon-cutout-active': pmViewCtrl.isLayerActive(LAYERS.CUTOUT)}\"></i>\n{{ 'PHOTO_MEASURE.CUTOUT' | translate }}\n</ike-button>\n<ike-button class=\"pages-photo-measure-toolbar-ruler\" ng-class=\"{active: pmViewCtrl.isLayerActive(LAYERS.LINE)}\" ng-show=\"pmViewCtrl.isCurrentStep(STEPS.MEASURE)\" ng-click=\"pmViewCtrl.activate(LAYERS.LINE)\">\n<i ng-class=\"{'pages-photo-measure-tool-icon-line': !pmViewCtrl.isLayerActive(LAYERS.LINE), 'pages-photo-measure-tool-icon-line-active': pmViewCtrl.isLayerActive(LAYERS.LINE)}\"></i>\n{{ 'PHOTO_MEASURE.LENGTH' | translate }}\n</ike-button>\n<span class=\"pages-photo-measure-toolbar-separator\" ng-show=\"pmViewCtrl.isCurrentStep(STEPS.MEASURE)\"></span>\n<ike-button class=\"pages-photo-measure-copyalignmentbutton\" ng-show=\"pmViewCtrl.isCurrentStep(STEPS.MEASURE)\" ng-click=\"pmViewCtrl.drawAreaFromAlignment()\">\n<i class=\"pages-photo-measure-tool-icon-align\"></i>\n<i class=\"pages-photo-measure-tool-icon-rightarrow\"></i>\n<i class=\"pages-photo-measure-tool-icon-area\"></i>\n{{ 'PHOTO_MEASURE.DRAW_FROM_ALIGNMENT' | translate }}\n</ike-button>\n<ike-button class=\"pages-photo-measure-lockRectangle\" ng-class=\"{active: pmViewCtrl.canLockRectangle() && pmViewCtrl.isRectangleLocked()}\" ng-show=\"pmViewCtrl.isCurrentStep(STEPS.MEASURE)\" ng-disabled=\"!pmViewCtrl.canLockRectangle()\" ng-click=\"pmViewCtrl.toggleRectangleLock()\">\n<i class=\"material-icons\">aspect_ratio</i>\n{{ 'PHOTO_MEASURE.LOCK_RECTANGLE' | translate }}\n</ike-button>\n</ike-toolbar>\n</layout-content>\n<layout-content grow=\"true\" class=\"pages-photo-measure-photoMeasureContent\">\n<layout-container direction=\"row\">\n<layout-content>\n<div class=\"pages-photo-measure-zoomControls\">\n<ike-zoom-control class=\"pages-photo-measure-zoomControl\" on-zoomin-click=\"pmViewCtrl.zoomIn(3)\" on-zoomout-click=\"pmViewCtrl.zoomOut(3)\" set-zoom=\"pmViewCtrl.setZoom(zoom)\" get-zoom=\"pmViewCtrl.getZoom()\">\n</ike-zoom-control>\n<a class=\"pages-photo-measure-panButton\" ng-click=\"pmViewCtrl.togglePanMode()\" title=\"{{ 'PHOTO_MEASURE.TOGGLE_TO_PAN' | translate }}\">\n<span ng-class=\"{'glyphicon-pan-primary': pmViewCtrl.isPanMode(), 'glyphicon-pan-black': !pmViewCtrl.isPanMode()}\"></span>\n</a>\n</div>\n</layout-content>\n<layout-content grow=\"true\">\n<loader ng-hide=\"pmViewCtrl.photoMeasureInstantiated()\"/>\n<zoom-pan class=\"pages-photo-measure-photoMeasureZoomPan\" zoom=\"pmViewCtrl.getZoom()\" zoom-in=\"pmViewCtrl.zoomIn()\" zoom-out=\"pmViewCtrl.zoomOut()\" set-view-port-scale-factor=\"pmViewCtrl.setViewPortScaleFactor(factor)\">\n<photo-measure class=\"pages-photo-measure-photoMeasure\" image-element=\"photoMeasureImage\" photo-measure-builder=\"pmViewCtrl.getPhotoMeasureBuilder()\"></photo-measure>\n</zoom-pan>\n</layout-content>\n<layout-content>\n<accuracy-window class=\"pages-photo-measure-accuracyWindow\" image-element=\"photoMeasureImage\"></accuracy-window>\n</layout-content>\n</layout-container>\n</layout-content>\n</layout-container>\n</layout-content>\n</layout-container>";
var id1="photoMeasure.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"pages-error\">\n<div class=\"pages-error-backgroundBand\">\n<div class=\"logo-black\"></div>\n</div>\n<div class=\"pages-error-content\">\n<h3>{{errorTitle}}</h3>\n<p>{{errorMessage}}</p>\n</div>\n</div>\n";
var id1="error.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 140 */,
/* 141 */
/***/ (function(module, exports) {

module.exports = L;

/***/ }),
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */
/***/ (function(module, exports) {

angular.module('ikeweb.user').service('billingService', [function() {
    // names of test plans, and future non-discount plans
    //var MONTHLY_PLAN = 'SpikeMonthly1999';
    //var YEARLY_PLAN = 'SpikeYearly19900';
    //var YEARLY_PLAN_OBSOLETE = 'SpikeYearly20000';

    var MONTHLY_PLAN_DISCOUNT = 'SpikeMonthly999';
    var YEARLY_PLAN_DISCOUNT = 'SpikeYearly9900';

    function fetchPlan(planId) {
        return Parse.Cloud.run('getPlanDetails', {
            id: planId
        });
    }

    function getMonthlyPlan() {
        return fetchPlan(MONTHLY_PLAN_DISCOUNT);
    }

    function getYearlyPlan() {
        return fetchPlan(YEARLY_PLAN_DISCOUNT);
    }

    function getAvailablePlans() {
        return Parse.Promise.when(getMonthlyPlan(), getYearlyPlan()).then(function(month, year) {
            return [month, year];
        });
    }

    function eligibleForTrial() {
        return Parse.Cloud.run('eligibleForTrial');
    }

    function getActiveSubscription() {
        return Parse.Cloud.run('getActiveSubscription');
    }

    function getUpcomingInvoice() {
        return Parse.Cloud.run('getUpcomingInvoice');
    }

    function getInvoices() {
        return Parse.Cloud.run('getInvoices');
    }

    function subscribe(plan, creditCardToken) {
        return Parse.Cloud.run('subscribe', {
            plan: plan,
            token: creditCardToken,
            trial: false
        });
    }

    function subscribeTrial(plan, creditCardToken) {
        return Parse.Cloud.run('subscribe', {
            plan: plan,
            token: creditCardToken,
            trial: true
        });
    }

    function cancelSubscriptionTrial(subscription) {
        return Parse.Cloud.run('cancelSubscription', {
            subscription: subscription
        });
    }

    function cancelSubscription(subscription) {
        return Parse.Cloud.run('cancelSubscription', {
            subscription: subscription
        });
    }

    function getTrialDaysRemaining() {
        return Parse.Cloud.run('getTrialDaysRemaining');
    }

    function getCurrentCreditCard() {
        return Parse.Cloud.run('getCurrentCreditCard');
    }

    function updateCreditCard(token) {
        return Parse.Cloud.run('updateCreditCard', {
            token: token
        });
    }

    function isOnPremium() {
        return getActiveSubscription()
            .then(function(subscription) {
                return !!subscription;
            });
    }

    function notOnPremiumError() {
        return Parse.Promise.error('NOT_ON_PREMIUM');
    }

    function notOnPremiumErrorIfFalse(value) {
        return value || notOnPremiumError();
    }

    function checkPremium() {
        return isOnPremium().then(notOnPremiumErrorIfFalse, notOnPremiumError);
    }

    return {
        getTrialDaysRemaining: getTrialDaysRemaining,
        getCurrentCreditCard: getCurrentCreditCard,
        updateCreditCard: updateCreditCard,
        cancelSubscription: cancelSubscription,
        cancelSubscriptionTrial: cancelSubscriptionTrial,
        subscribe: subscribe,
        subscribeTrial: subscribeTrial,
        getUpcomingInvoice: getUpcomingInvoice,
        getInvoices: getInvoices,
        getAvailablePlans: getAvailablePlans,
        isOnPremium: isOnPremium,
        checkPremium: checkPremium,
        getActiveSubscription: getActiveSubscription,
        eligibleForTrial: eligibleForTrial
    };
}]).config(['$provide', function($provide) {

    var functionsToCache = [
        'getTrialDaysRemaining',
        'getActiveSubscription',
        'getCurrentCreditCard',
        'getAvailablePlans',
        'getUpcomingInvoice',
        'getInvoices',
        'isOnPremium',
        'checkPremium',
        'eligibleForTrial'
    ];

    var functionsThatFlush = [
        'subscribe',
        'subscribeTrial',
        'updateCreditCard',
        'cancelSubscription',
        'cancelSubscriptionTrial'
    ];

    var functionsToDecorate = functionsToCache.concat(functionsThatFlush);

    $provide.decorator('billingService', ['$delegate', 'qPromiseDecoratorService',
        function($delegate, qPromiseDecoratorService) {
            return qPromiseDecoratorService
                .decorateDelegateWithPromise($delegate, functionsToDecorate);
        }
    ]);

    $provide.decorator('billingService', ['$delegate', 'parseErrorDecoratorService',
        function($delegate, parseErrorDecoratorService) {
            return parseErrorDecoratorService.decorateDelegatePromiseErrors($delegate, functionsToDecorate);
        }
    ]);

    $provide.decorator('billingService', ['$delegate', 'promiseProgressDecoratorService',
        function($delegate, promiseProgressDecoratorService) {
            return promiseProgressDecoratorService
                .decorateDelegateWithProgress($delegate, functionsToDecorate);
        }
    ]);

    $provide.decorator('billingService', ['$delegate', 'cacheDecoratorBuilder', 'userHashService',
        function($delegate, cacheDecoratorBuilder, userHashService) {

            return cacheDecoratorBuilder
                .aCacheDecorator()
                .withTTL(moment.duration(10, 'minutes').asMilliseconds())
                .withHash(userHashService.hash)
                .build()
                .decorateDelegateWithCaching($delegate, functionsToCache, functionsThatFlush);
        }
    ]);

    $provide.decorator('billingService', ['$delegate', 'decoratedPromiseBuilder', 'notificationService',
        function($delegate, decoratedPromiseBuilder, notificationService) {

            return decoratedPromiseBuilder
                .forDelegate($delegate)
                .decorate('subscribe')
                .onSuccess(notificationService.success('NOTIFICATION.BILLING.SUBSCRIPTION.TITLE', 'NOTIFICATION.BILLING.SUBSCRIPTION.CREATE.SUCCESS'))
                .onError(notificationService.error('NOTIFICATION.BILLING.SUBSCRIPTION.TITLE', 'NOTIFICATION.BILLING.SUBSCRIPTION.CREATE.ERROR'))
                .decorate('subscribeTrial')
                .onSuccess(notificationService.success('NOTIFICATION.BILLING.SUBSCRIPTION.TRIAL', 'NOTIFICATION.BILLING.SUBSCRIPTION.CREATE.SUCCESS_TRIAL'))
                .onError(notificationService.error('NOTIFICATION.BILLING.SUBSCRIPTION.TRIAL', 'NOTIFICATION.BILLING.SUBSCRIPTION.CREATE.ERROR'))
                .decorate('cancelSubscription')
                .onSuccess(notificationService.success('NOTIFICATION.BILLING.SUBSCRIPTION.TITLE', 'NOTIFICATION.BILLING.SUBSCRIPTION.CANCEL.SUCCESS'))
                .onError(notificationService.error('NOTIFICATION.BILLING.SUBSCRIPTION.TITLE', 'NOTIFICATION.BILLING.SUBSCRIPTION.CANCEL.ERROR'))
                .decorate('cancelSubscriptionTrial')
                .onSuccess(notificationService.success('NOTIFICATION.BILLING.SUBSCRIPTION.TRIAL', 'NOTIFICATION.BILLING.SUBSCRIPTION.CANCEL.SUCCESS_TRIAL'))
                .onError(notificationService.error('NOTIFICATION.BILLING.SUBSCRIPTION.TRIAL', 'NOTIFICATION.BILLING.SUBSCRIPTION.CANCEL.ERROR'))
                .decorate('updateCreditCard')
                .onSuccess(notificationService.success('NOTIFICATION.BILLING.CARD.TITLE', 'NOTIFICATION.BILLING.CARD.UPDATE.SUCCESS'))
                .onError(notificationService.error('NOTIFICATION.BILLING.CARD.TITLE', 'NOTIFICATION.BILLING.CARD.UPDATE.ERROR'))
                .fork();
        }
    ]);

    $provide.decorator('billingService', ['$delegate', 'loggingDecorator',
        function($delegate, loggingDecorator) {
            return loggingDecorator.decorateDelegateWithLogging($delegate, functionsToDecorate);
        }
    ]);
}]);


/***/ }),
/* 154 */
/***/ (function(module, exports) {

angular.module('ikeweb.user').controller('BillingController', [
    '$scope',
    'billingService',
    '$rootScope',
    'events',
    '$location',
    '$stateParams',
    'promiseFactory',
    '$timeout',
    'pubSubService',
    'userTopics',
    'subscriptionActionService',
    function($scope,
        billingService,
        $rootScope,
        events,
        $location,
        $stateParams,
        promiseFactory,
        $timeout,
        pubSubService,
        userTopics,
        subscriptionActionService) {
        $scope.noCard = true;
        $scope.showError = false;
        $scope.errorMessage = '';
        $scope.showSuccess = false;
        $scope.successMessage = '';
        $scope.loading = true;
        $scope.canTrial = false;

        this.subscriptionWillEnd = function() {
            var subscription = $scope.subscription;
            return (subscription != null && subscription.cancel_at_period_end);
        };

        function openPurchaseModal() {
            if ($scope.canTrial) {
                $scope.openPurchaseTrialModal();
            } else {
                $scope.openPurchasePremiumModal();
            }
            $location.url($location.path());
        }

        function startUpgrade() {
            if (!$scope.subscription && $stateParams.upgrade === true) {
                openPurchaseModal();
            }

            //Watch for future changes and act accordingly.
            $scope.$watch(function() {
                return $location.search();
            }, function(newValue, oldValue) {
                if (newValue.upgrade === true && oldValue.upgrade === undefined && !$scope.subscription) {
                    openPurchaseModal();

                }
            });
        }

        function updateCard() {
            return billingService.getCurrentCreditCard()
                .then(function(creditCard) {
                    $scope.noCard = !creditCard;
                    $scope.currentCard = creditCard;
                });
        }

        function updateTrialDaysRemaining() {
            return billingService.getTrialDaysRemaining().then(function(days) {
                $scope.trialDaysRemaining = days;
            });
        }

        function updateActiveSubscription() {
            return billingService.getActiveSubscription().then(function(subscription) {
                $scope.subscription = subscription;
            });
        }

        function updateUpcomingInvoice() {
            return billingService.getUpcomingInvoice().then(function(invoice) {
                $scope.upcomingInvoice = invoice;
            });
        }

        function updateInvoices() {
            return billingService.getInvoices().then(function(invoices) {
                $scope.invoices = invoices;
            });
        }

        function canTrial() {
            return subscriptionActionService.canTrial().then(function(trial) {
                $scope.canTrial = trial;
            });
        }

        $scope.cancelSubscription = function(subscription) {
            return billingService.cancelSubscription(subscription)
                .then(function() {
                    $rootScope.$broadcast(events.SUBSCRIPTION.CANCELED, subscription);
                });
        };

        $scope.cancelSubscriptionTrial = function(subscription) {
            return billingService.cancelSubscriptionTrial(subscription)
                .then(function() {
                    $rootScope.$broadcast(events.SUBSCRIPTION.CANCELED, subscription);
                });
        };

        $scope.openUpdateCard = function() {
            $scope.$broadcast('DISPLAY_UPDATE_CARD');
        };
        $scope.openPurchaseTrialModal = function() {
            $scope.$broadcast(events.BILLING.PURCHASE_TRIAL.DISPLAY);
        };

        $scope.openPurchasePremiumModal = function() {
            $scope.$broadcast(events.BILLING.PURCHASE_PREMIUM.DISPLAY);
        };

        $scope.hasUpcomingInvoice = function() {
            return ($scope.upcomingInvoice !== undefined && $scope.currentCard !== undefined);
        };

        $scope.hasInvoiceHistory = function() {
            var invoices = $scope.invoices || [];
            return (invoices.filter(function(invoice) {
                return invoice.total > 0;
            }).length > 0);
        };

        $scope.hasBillingDetails = function() {
            return ($scope.hasUpcomingInvoice() || $scope.hasInvoiceHistory());
        };

        function updateSubscriptionState() {
            return promiseFactory.all([
                updateActiveSubscription(),
                updateUpcomingInvoice(),
                updateInvoices(),
                updateTrialDaysRemaining(),
                updateCard(),
                canTrial()
            ]);
        }

        // Register for events
        pubSubService.subscribe(userTopics.CREDITCARD.UPDATED, updateSubscriptionState);
        $scope.$on('$destroy', function() {
            pubSubService.unsubscribe(userTopics.CREDITCARD.UPDATED, updateSubscriptionState);
        });

        Object.keys(events.SUBSCRIPTION).forEach(function(event) {
            $scope.$on(events.SUBSCRIPTION[event], updateSubscriptionState);
        });

        updateSubscriptionState().then(function() {
            $timeout(startUpgrade);
            $scope.loading = false;
        });
    }
]);


/***/ }),
/* 155 */
/***/ (function(module, exports) {

angular.module('ikeweb.user').controller('BillingStatusController', ['$rootScope', '$scope', 'loginService', 'billingService', 'events', '$location', 'subscriptionActionService', 'pubSubService', 'userTopics',
    function($rootScope, $scope, loginService, billingService, events, $location, subscriptionActionService, pubSubService, userTopics) {

        var isOnTrial = false;
        var canTrial = false;
        var shouldSubscribe = false;
        var trialDaysRemaining = -1;
        $scope.canTrial = false;

        function update() {
            if (!loginService.getLoggedInUser()) {
                isOnTrial = false;
                canTrial = false;
                trialDaysRemaining = -1;
                shouldSubscribe = false;
                return;
            }

            subscriptionActionService.isOnTrial().then(function(value) {
                isOnTrial = value;
                if (isOnTrial) {
                    billingService.getTrialDaysRemaining().then(function(value) {
                        trialDaysRemaining = value;
                    });
                }
            });
            subscriptionActionService.shouldSubscribe().then(function(value) {
                shouldSubscribe = value;
            });

            subscriptionActionService.canTrial().then(function(trial) {
                canTrial = trial;
                $scope.canTrial;
            });

        }

        this.navToUpgrade = function() {
            $location.path('billing');
        };

        this.getTrialDaysRemaining = function() {
            return trialDaysRemaining;
        };

        this.showTrialDaysRemaining = function() {
            return isOnTrial && trialDaysRemaining > -1;
        };

        this.shouldSubscribe = function() {
            return shouldSubscribe && !canTrial;
        };
        this.canTrial = function() {
            return canTrial;
        };

        Object.keys(events.SUBSCRIPTION).forEach(function(event) {
            $scope.$on(events.SUBSCRIPTION[event], update);
        });

        pubSubService.subscribe(userTopics.CREDITCARD.UPDATED, update);
        $scope.$on('$destroy', function() {
            pubSubService.unsubscribe(userTopics.CREDITCARD.UPDATED, update);
        });

        $rootScope.$on('$routeChangeSuccess', update);

        update();
    }
]);


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(416);

angular.module('ikeweb.user').directive('billingStatus', [

    function() {

        return {
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            replace: true,
            controller: 'BillingStatusController',
            controllerAs: 'ctrl'
        };
    }
]);


/***/ }),
/* 157 */
/***/ (function(module, exports) {

angular.module('ikeweb.routes').config(['$stateProvider', '$urlRouterProvider', 'routes',

    function($stateProvider, $urlRouterProvider, routes) {

        $urlRouterProvider.otherwise(routes.GALLERY.url);

        $stateProvider
            .state('login', routes.LOG_IN)
            .state('signup', routes.SIGN_UP)
            .state('choose_password', routes.CHOOSE_PASSWORD)
            .state('invalid_link', routes.INVALID_LINK)
            .state('password_reset_success', routes.PASSWORD_RESET_SUCCESS)
            .state('forgotPassword', routes.FORGOT_PASSWORD)
            .state('gallery', routes.GALLERY)
            .state('capture', routes.PHOTOMEASURE)
            .state('align', routes.ALIGN)
            .state('measure', routes.MEASURE)
            .state('report', routes.REPORT)
            .state('billing', routes.BILLING)
            .state('shared', routes.SHARED_REPORT)
            .state('map', routes.MAP)
            .state('error', routes.ERROR);
    }
]);


/***/ }),
/* 158 */
/***/ (function(module, exports) {

angular.module('ikeweb.error').value('cloudCodeErrors', {
    DUPLICATE: 'duplicate',
    USER_EXISTS: 'user_exists',
    FOLDER_NAME_EMPTY: 'folder_name_empty',
    INVALID_SIGNUP_TOKEN: 'invalid_signup_token'
});


/***/ }),
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(165);
__webpack_require__(412);
__webpack_require__(413);
__webpack_require__(417);
__webpack_require__(418);
__webpack_require__(419);
__webpack_require__(420);
__webpack_require__(422);
__webpack_require__(157);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(158);
__webpack_require__(158);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(440);
__webpack_require__(441);
__webpack_require__(442);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(446);
__webpack_require__(447);
__webpack_require__(448);
__webpack_require__(450);
__webpack_require__(451);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(455);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(458);
__webpack_require__(460);
__webpack_require__(462);
__webpack_require__(463);
__webpack_require__(465);
__webpack_require__(467);
__webpack_require__(469);
__webpack_require__(470);
__webpack_require__(471);
__webpack_require__(472);
__webpack_require__(473);
__webpack_require__(474);
__webpack_require__(476);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(482);
__webpack_require__(483);
__webpack_require__(484);
__webpack_require__(485);
__webpack_require__(153);
__webpack_require__(154);
__webpack_require__(156);
__webpack_require__(487);
__webpack_require__(489);
__webpack_require__(490);
__webpack_require__(492);
__webpack_require__(494);
__webpack_require__(495);
__webpack_require__(496);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(501);
__webpack_require__(503);
__webpack_require__(504);
__webpack_require__(506);
__webpack_require__(155);
__webpack_require__(507);
__webpack_require__(509);
__webpack_require__(510);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(516);
__webpack_require__(518);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(523);
__webpack_require__(524);
__webpack_require__(526);
__webpack_require__(527);
__webpack_require__(529);
__webpack_require__(530);
__webpack_require__(568);
__webpack_require__(569);
__webpack_require__(570);
__webpack_require__(571);
__webpack_require__(572);
__webpack_require__(573);
__webpack_require__(575);
__webpack_require__(576);
__webpack_require__(578);
__webpack_require__(579);
__webpack_require__(580);
__webpack_require__(582);
__webpack_require__(583);
__webpack_require__(585);
__webpack_require__(586);
__webpack_require__(588);
__webpack_require__(589);
__webpack_require__(590);
__webpack_require__(591);
__webpack_require__(592);
__webpack_require__(593);
__webpack_require__(594);
__webpack_require__(596);
__webpack_require__(597);
__webpack_require__(598);
__webpack_require__(599);
__webpack_require__(600);
__webpack_require__(601);
__webpack_require__(603);

__webpack_require__(604);


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

window.jQuery = window.$ = __webpack_require__(10);

var angular = __webpack_require__(25);
var config = __webpack_require__(81);
var Parse = window.Parse = __webpack_require__(82);
Parse.initialize(config.parse.appid, config.parse.appkey);
Parse.serverURL = config.parse.path;
Parse.Object.disableSingleInstance();
// uncomment for offline run
//const Stripe = { setPublishableKey: function(){}}
Stripe.setPublishableKey(config.stripe.key);

angular.module('templates', [])
    .constant('error', __webpack_require__(139));

angular.module('ikeweb.templates', []);

__webpack_require__(239);
__webpack_require__(240);
__webpack_require__(241);
__webpack_require__(242);
__webpack_require__(384);
__webpack_require__(385);
__webpack_require__(386);
__webpack_require__(390);
__webpack_require__(398);
__webpack_require__(399);
__webpack_require__(400);
__webpack_require__(401);
__webpack_require__(402);

var app = angular.module('ikeweb', [
    'ikeweb.routes',
    'ikegps.math',
    'templates',
    'ikeweb.templates',
    'angulartics',
    'angulartics.google.analytics',
    'ikeweb.layout',
    'ikeweb.spike',
    'ikeweb.spike.measure',
    'ikeweb.spike.capture',
    'ikeweb.spike.gallery',
    'ikeweb.spike.report',
    'ikeweb.spike.sharing',
    'ikeweb.spike.step',
    'ikeweb.user',
    'ikeweb.locale',
    'ikeweb.folders',
    'ikeweb.notes',
    'ikeweb.map',
    'ikeweb.subscription',
    __webpack_require__(405),
    'ike.services.logging',
    'ikeweb.shared.notification',
    'ikeweb.shared.input',
    'ikeweb.shared.layout',
    'ikeweb.shared.progress',
    'ikeweb.error',
    'ikeweb.shared.i18n',
    'ike.services.translations'
]);


app.config(['localStorageServiceProvider', function(localStorageServiceProvider) {
    localStorageServiceProvider.setPrefix('ikeweb');
}]);

app.config(['photogrammetryToolKitProvider', function(photogrammetryToolKitProvider) {
    photogrammetryToolKitProvider.setStyles({
        GrabHandleStroke: '#FFFFFF',
        GrabHandleActive: '#01FF70',
        MeasurementPolygonFill: '#FF4136',
        AlignmentPolygonFill: '#FFDC00',
        MeasurementCutoutFill: '#A750D3'
    });
}]);

app.run(['translationService', 'localeService', function(translationService, localeService) {
    translationService.translate(localeService.getCurrentLocale().value);
}]);

app.config(['LogEntriesProvider', function(LogEntriesProvider) {
    LogEntriesProvider.init(config.logentries.client);
}]);

app.provider('username', function() {
    return {
        $get: [
            function() {
                return {
                    get: function() {
                        var user = Parse.User.current();
                        return user ? user.getUsername() : 'not logged in';
                    }
                };
            }
        ]
    };
});

app.run(['$rootScope', '$analytics', function($rootScope, $analytics, UserService) {
    function getCurrentUser() {
        return Parse.User.current();
    }

    $rootScope.$watch(getCurrentUser, function(currentUser) {
        if (currentUser) {
            $analytics.setUsername(currentUser.id);
            $analytics.setUserProperties({
                dimension1: currentUser.id
            });
        } else {
            $analytics.setUsername(null);
        }
    });
}]);


app.value('MAP_CONFIG', {
    LOCATION: config.map.mapLocation,
    ID: config.map.mapId,
    API_KEY: config.map.apiKey,
    ATTRIBUTION: '© <a href="https://www.mapbox.com/map-feedback/"">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap contributors</a>',
    iconSize: [43, 38],
    iconAnchor: [14, 38]
});



__webpack_require__(407);


/***/ }),
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */
/***/ (function(module, exports) {

module.exports = angular.module("pascalprecht.translate");

/***/ }),
/* 385 */,
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var angular = __webpack_require__(25);

var loggingModule = angular.module('ike.services.logging', []);
var ErrorStackParser = __webpack_require__(387);

loggingModule.provider('LogEntries', function() {
    var LogEntries = __webpack_require__(389);
    return {
        init: function(key) {
            LogEntries.init({
                token: key,
                trace: false
            });
        },
        $get: function() {
            return LogEntries;
        }
    };

});

// Wrap up stacktrace-js
loggingModule.factory('traceService', function() {
    return ({
        print: ErrorStackParser.parse.bind(ErrorStackParser)
    });
});

// Override angularjs logging service provider
loggingModule.provider('$exceptionHandler', function() {

    return {
        $get: ['exceptionLoggingService',
            function(exceptionLoggingService) {
                return (exceptionLoggingService);
            }
        ]
    };
});

function whatBrowser() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE ' + (tem[1] || '');
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR\/(\d+)/);
        if (tem != null) {
            return 'Opera ' + tem[1];
        }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, tem[1]);
    }
    return M.join(' ');
}

// Replace exception logging service to do the default behaviour but also to our logging repo
loggingModule.factory('exceptionLoggingService', ['$log', 'traceService', 'logRepository',
    function($log, traceService, logRepository) {

        function error(exception, cause) {
            $log.error.apply($log, arguments);
            try {
                // Get a stacktrace from stacktrace-js
                var stackTrace = traceService.print(exception);
                logRepository.put(exception.toString(), 'exception', stackTrace, (cause || ''));

            } catch (loggingError) {
                $log.warn('Error logging to log repository failed');
                $log.log(loggingError);
            }
        }
        return (error);
    }
]);

loggingModule.factory('logRepository', ['$window', '$injector', '$log', 'LogEntries',

    function($window, $injector, $log, LogEntries) {
        var usernameService;

        function getUsernameService() {
            try {
                usernameService = $injector.get('username');
            } catch (e) {
                $log.log('Warning, no username service. Exceptions will be logged with no username');
            }
        };

        function put(message, type, stackTrace, cause) {
            if (!usernameService) {
                getUsernameService();
            }

            LogEntries.log({
                user: usernameService ? usernameService.get() || 'no user' : 'no user',
                browser: whatBrowser(),
                url: $window.location.href,
                message: message,
                type: type,
                stackTrace: stackTrace,
                cause: cause
            });
        }
        return ({
            put: put
        });

    }
]);


/***/ }),
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */
/***/ (function(module, exports) {

module.exports = RGBColor;

/***/ }),
/* 404 */
/***/ (function(module, exports) {

module.exports = stackBlur;

/***/ }),
/* 405 */,
/* 406 */,
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(408);


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var subModule = angular.module('ikeweb.subscription', []);
__webpack_require__(409);
__webpack_require__(410);


var subscriptionStateFactory = __webpack_require__(411);

subModule.factory('subscriptionStateFactory', function() {
    return subscriptionStateFactory;
});


/***/ }),
/* 409 */
/***/ (function(module, exports) {

function subscriptionActionService(subscriptionStateService, billingService, f) {
    var MONTHLY = 'month';
    var YEARLY = 'year';

    function isOnTrial() {
        return subscriptionStateService.getState().then(function(state) {
            return state.isOnTrial;
        });
    }

    function canTrial() {
        return subscriptionStateService.getState().then(function(state) {
            return state.canTrial;
        });
    }

    function shouldSubscribe() {
        return subscriptionStateService.getState().then(function(state) {
            return state.shouldSubscribe;
        });
    }

    function shouldRenew() {
        return subscriptionStateService.getState().then(function(state) {
            return state.shouldRenew;
        });
    }

    function canRenewPlanTo(from, to) {
        return from.interval !== YEARLY || to.interval !== MONTHLY;
    }

    function canChangePlanTo(from, to) {
        return from.interval !== to.interval && canRenewPlanTo(from, to);
    }

    function canChangePlan() {
        return billingService.getActiveSubscription()
            .then(function(subscription) {
                return billingService.getAvailablePlans().then(function(plans) {
                    return !!subscription && !subscription.cancel_at_period_end && plans.filter(f.curry(canChangePlanTo)(subscription.plan)).length > 0;
                });
            });
    }

    return {
        isOnTrial: isOnTrial,
        shouldSubscribe: shouldSubscribe,
        shouldRenew: shouldRenew,
        canRenewPlanTo: canRenewPlanTo,
        canChangePlanTo: canChangePlanTo,
        canChangePlan: canChangePlan,
        canTrial: canTrial
    };
}

angular.module('ikeweb.subscription').factory('subscriptionActionService', ['subscriptionStateService', 'billingService', 'functional', subscriptionActionService]);


/***/ }),
/* 410 */
/***/ (function(module, exports) {

angular.module('ikeweb.subscription').factory('subscriptionStateService', ['billingService', 'promiseFactory', 'subscriptionStateFactory',

    function(billingService, promiseFactory, subscriptionStateFactory) {

        var STATES = subscriptionStateFactory.STATES,
            clientStates = {};

        clientStates[STATES.TRIAL] = {
            isOnTrial: true,
            shouldSubscribe: false,
            shouldRenew: true
        };
        clientStates[STATES.BASIC] = {
            isOnTrial: false,
            shouldSubscribe: true,
            shouldRenew: false
        };
        clientStates[STATES.PREMIUM_YEARLY] = {
            isOnTrial: false,
            shouldSubscribe: false,
            shouldRenew: false
        };
        clientStates[STATES.PREMIUM_MONTHLY] = {
            isOnTrial: false,
            shouldSubscribe: false,
            shouldRenew: false
        };
        clientStates[STATES.CANCELED] = {
            isOnTrial: false,
            shouldSubscribe: false,
            shouldRenew: true
        };
        clientStates[STATES.BASIC_CAN_TRIAL] = {
            isOnTrial: false,
            shouldSubscribe: false,
            shouldRenew: false,
            canTrial: true
        };
        clientStates[STATES.PENDING] = {
            isOnTrial: false,
            shouldSubscribe: false,
            shouldRenew: false
        };

        function getState() {
            return promiseFactory.all([
                billingService.getActiveSubscription(),
                billingService.eligibleForTrial()
            ]).then(function(results) {
                return clientStates[subscriptionStateFactory.create(results[0], results[1])];
            });
        }

        return {
            getState: getState
        };
    }
]);


/***/ }),
/* 411 */
/***/ (function(module, exports) {

var STATES = {
    TRIAL: 'TRIAL', // Trial, has trialled or had pro before
    BASIC: 'BASIC', // Trial Over
    BASIC_CAN_TRIAL: 'BASIC_CAN_TRIAL', // never trialled
    PREMIUM_MONTHLY: 'PRO_MONTHLY',
    PREMIUM_YEARLY: 'PRO_YAERLY',
    CANCELED: 'CANCELED'
};

function create(subscription, canTrial) {
    if (!subscription && canTrial) {
        return STATES.BASIC_CAN_TRIAL;
    }

    if (!subscription && !canTrial) {
        return STATES.BASIC;
    }

    if (subscription.cancel_at_period_end) {
        return STATES.CANCELED;
    }

    if (subscription.status === 'trialing') {
        return STATES.TRIAL;
    }

    if (subscription.plan.interval === 'month') {
        return STATES.PREMIUM_MONTHLY;
    }
    if (subscription.plan.interval === 'year') {
        return STATES.PREMIUM_YEARLY;
    }

}

module.exports = {
    create: create,
    STATES: STATES
};


/***/ }),
/* 412 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike', ['ikeweb.shared.notification', 'ikeweb.shared.promise'])
    .factory('SpikeUtil', ['$window',
        function($window) {

            function detectIE() {
                return ((navigator.appName === 'Microsoft Internet Explorer') || ((navigator.appName === 'Netscape') && (new RegExp('Trident/.*rv:([0-9]{1,}[\.0-9]{0,})|Edge/([0-9]{0,}[\.0-9]{0,})').exec(navigator.userAgent) != null)));
            }

            function sanitize(input, replacement) {
                var illegalRe = /[\/\?<>\\:\*\|":]/g;
                var controlRe = /[\x00-\x1f\x80-\x9f]/g;
                var reservedRe = /^\.+$/;
                var windowsReservedRe = /^(con|prn|aux|nul|com[0-9]|lpt[0-9])(\..*)?$/i;

                var sanitized = input
                    .replace(illegalRe, replacement)
                    .replace(controlRe, replacement)
                    .replace(reservedRe, replacement)
                    .replace(windowsReservedRe, replacement);
                return sanitized;
            }

            function cleanFileName(input, options) {
                var replacement = (options && options.replacement) || '';
                var output = sanitize(input, replacement);
                if (replacement === '') {
                    return output;
                }
                return sanitize(output, '');
            }

            return {
                SVG: {
                    tag: function(tag) {
                        return document.createElementNS('http://www.w3.org/2000/svg', tag);
                    },
                    xlinkHref: function(el, url) {
                        return el.setAttributeNS('http://www.w3.org/1999/xlink', 'href', url);
                    }
                },
                parseSSLImageFix: function(url) {
                    return url.replace('http://', $window.location.protocol + '//' + $window.location.host + '/files/');
                },

                downloadBlob: function(blob, filename) {
                    if (detectIE()) {
                        window.navigator.msSaveBlob(blob, filename);
                    } else {
                        var url = URL.createObjectURL(blob);
                        var link = document.createElement('a');
                        document.body.appendChild(link);
                        link.download = filename;
                        link.href = url;
                        link.click();
                        link.remove();
                    }
                },
                downloadURL: function(url, filename) {
                    var link = document.createElement('a');
                    if (filename != null) {
                        link.download = filename;
                    }
                    link.href = url;
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                },
                cleanFileName: cleanFileName,
                /**
                 * [debounce rate limit a funciton call]
                 * @param  {[funciton]} func     [the function to rate limit]
                 * @param  {[number]} wait       [time between calls]
                 * @param  {[boolean]} immediate [run it now]
                 */
                debounce: function(func, wait, immediate) {
                    var timeout;
                    return function() {
                        var self = this,
                            args = arguments;
                        var later = function() {
                            timeout = null;
                            if (!immediate) {
                                func.apply(self, args);
                            }
                        };
                        var callNow = immediate && !timeout;
                        clearTimeout(timeout);
                        timeout = setTimeout(later, wait);
                        if (callNow) {
                            func.apply(self, args);
                        }
                    };
                }
            };
        }
    ]);
angular.module('ikeweb.spike.capture', ['ikeweb.spike', 'ikeweb.shared.input', 'ikeweb.shared.notification',
    'ikeweb.shared.dialog', 'ikeweb.shared.decoration', 'ikeweb.shared.logging', 'ikeweb.shared.promise',
    'ikeweb.shared.caching', 'ikeweb.user', 'ikeweb.event', 'pascalprecht.translate'
]);

angular.module('ikeweb.spike.gallery', ['ikeweb.spike', 'ikeweb.shared.notification', 'ikeweb.shared.input',
    'ikeweb.shared.layout', 'ikeweb.shared.dialog', 'ikeweb.shared.printing', 'ikeweb.shared.logging',
    'ikeweb.shared.promise', 'ikeweb.spike.measure', 'ikeweb.spike.capture', 'ikeweb.unit', 'ikeweb.event',
    'ikeweb.layout', 'pascalprecht.translate', 'ikeweb.routes'
]);

angular.module('ikeweb.spike.measure', ['ikeweb.spike', 'ikeweb.shared.util', 'ikeweb.shared.input',
    'ikeweb.shared.layout', 'ikeweb.shared.messaging', 'ikeweb.unit', 'ikeweb.event', 'ikeweb.layout',
    'pascalprecht.translate', 'ikeweb.routes'
]);

angular.module('ikeweb.spike.report', ['ikeweb.spike', 'ikeweb.shared.input', 'ikeweb.shared.layout',
    'ikeweb.shared.printing', 'ikeweb.unit', 'ikeweb.spike.sharing', 'ikeweb.event', 'ikeweb.layout',
    'pascalprecht.translate', 'ikeweb.routes'
]);

angular.module('ikeweb.spike.sharing', ['ikeweb.spike', 'ikeweb.shared.notification', 'ikeweb.shared.input',
    'ikeweb.shared.layout', 'ikeweb.shared.dialog', 'ikeweb.shared.printing', 'ikeweb.shared.logging',
    'ikeweb.shared.promise', 'ikeweb.spike.measure', 'ikeweb.spike.capture', 'ikeweb.unit', 'ikeweb.event',
    'ikeweb.layout', 'pascalprecht.translate', 'ikeweb.routes'
]);


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

angular.module('ikeweb.user', [
    'ikeweb.shared.util',
    'ikeweb.shared.validation',
    'ikeweb.shared.notification',
    'ikeweb.shared.promise',
    'ikeweb.shared.caching',
    'ikeweb.shared.hash',
    'ikeweb.shared.filter',
    'ikeweb.shared.input',
    'ikeweb.shared.messaging',
    'ikeweb.shared.dialog',
    'ikeweb.shared.input',
    'ikeweb.shared.logging',
    'ikeweb.shared.repository.parse',
    'ikeweb.subscription',
    'ikeweb.unit',
    'ikeweb.error',
    'ikeweb.event',
    'pascalprecht.translate',
    'ikeweb.routes'
]);


__webpack_require__(414);


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(153);
__webpack_require__(154);
__webpack_require__(415);


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(155);
__webpack_require__(156);


/***/ }),
/* 416 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"BillingStatus\">\n<a class=\"BillingStatus-shouldTrial link-dark\" ng-show=\"ctrl.canTrial()\" ng-click=\"ctrl.navToUpgrade()\">\n<span>\n{{ 'COMPONENT.BILLING_STATUS.START_TRIAL' | translate }}\n</span>\n</a>\n<a class=\"BillingStatus-trialDaysRemaining link-dark\" ng-show=\"ctrl.showTrialDaysRemaining()\" ng-click=\"ctrl.navToUpgrade()\">{{ 'COMPONENT.BILLING_STATUS.TRIAL_DAYS_REMAINING' | translate:{ 'days': ctrl.getTrialDaysRemaining() } }}</a>\n<a class=\"BillingStatus-shouldUpgrade link-dark\" ng-show=\"ctrl.shouldSubscribe()\" ng-click=\"ctrl.navToUpgrade()\">\n<span>{{ 'COMPONENT.BILLING_STATUS.TRIAL_EXPIRED' | translate }}\n<br/>\n<strong>{{ 'COMPONENT.BILLING_STATUS.UPGRADE_NOW' | translate }}</strong>\n</span>\n</a>\n</div>\n";
var id1="billing.status.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 417 */
/***/ (function(module, exports) {

angular.module('ikeweb.layout', [
    'ikeweb.unit',
    'ikeweb.user',
    'pascalprecht.translate'
]);


/***/ }),
/* 418 */
/***/ (function(module, exports) {

angular.module('ikeweb.folders', [
    'ikeweb.shared.notification',
    'ikeweb.shared.promise',
    'ikeweb.shared.repository.parse',
    'ikeweb.repository',
    'ikeweb.shared.logging',
    'ikeweb.error',
    'ikeweb.event',
    'LocalStorageModule',
    'pascalprecht.translate'
]);


/***/ }),
/* 419 */
/***/ (function(module, exports) {

angular.module('ikeweb.notes', [
    'ikeweb.shared.notification',
    'ikeweb.shared.promise',
    'ikeweb.shared.repository.parse',
    'ikeweb.repository',
    'ikeweb.shared.logging',
    'ikeweb.error',
    'ikeweb.event',
    'LocalStorageModule',
    'pascalprecht.translate'
]);


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var ikemath = __webpack_require__(421);
angular.module(
    'ikegps.math', []
).provider('ikemath', function() {
    return {
        $get: function() {
            return ikemath;
        }
    };
});


/***/ }),
/* 421 */,
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var angular = __webpack_require__(25);

__webpack_require__(423);

angular.module('ikeweb.routes', ['ui.router']);

__webpack_require__(157);
__webpack_require__(424);


/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports = angular.module("ui.router");

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

angular.module('ikeweb.routes').constant('routes', {
    LOG_IN: {
        url: '/login',
        views: {
            main: {
                templateUrl: __webpack_require__(425),
                controller: 'LoginController',
                controllerAs: 'ctrl'
            }
        }
    },
    SIGN_UP: {
        url: '/signup?token',
        views: {
            main: {
                templateUrl: __webpack_require__(426),
                controller: 'SignUpController',
                controllerAs: 'ctrl'
            }
        }
    },
    FORGOT_PASSWORD: {
        url: '/forgotPassword',
        views: {
            main: {
                templateUrl: __webpack_require__(427),
                controller: 'ForgotPasswordController'
            }
        }
    },
    GALLERY: {
        url: '/gallery',
        views: {
            main: {
                templateUrl: __webpack_require__(428),
                controller: 'GalleryController'
            }
        }
    },
    PHOTOMEASURE: {
        url: '/photoMeasure/:spikeid',
        views: {
            main: {
                templateUrl: __webpack_require__(108),
                controller: 'PhotoMeasureViewController',
                controllerAs: 'pmViewCtrl'
            }
        }
    },
    ALIGN: {
        url: '/photoMeasure/:spikeid/align',
        views: {
            main: {
                templateUrl: __webpack_require__(108),
                controller: 'PhotoMeasureViewController',
                controllerAs: 'pmViewCtrl'
            }
        }
    },
    MEASURE: {
        url: '/photoMeasure/:spikeid/measure',
        views: {
            main: {
                templateUrl: __webpack_require__(108),
                controller: 'PhotoMeasureViewController',
                controllerAs: 'pmViewCtrl'
            }
        }
    },
    REPORT: {
        url: '/photoMeasure/:spikeid/report',
        views: {
            main: {
                templateUrl: __webpack_require__(429),
                controller: 'ReportController',
                controllerAs: 'ctrl'
            }
        }
    },
    SHARED_REPORT: {
        url: '/measureView/:sharedCaptureId',
        views: {
            main: {
                templateUrl: __webpack_require__(430),
                controller: 'MeasureViewController',
                controllerAs: 'ctrl'
            }
        }
    },
    MAP: {
        url: '/map',
        views: {
            main: {
                templateUrl: __webpack_require__(431),
                controller: 'MapViewController',
                controllerAs: 'mapViewCtrl'
            }
        }
    },
    BILLING: {
        url: '/billing?{upgrade:bool}',
        views: {
            main: {
                templateUrl: __webpack_require__(432),
                controller: 'BillingController',
                controllerAs: 'ctrl'
            }
        },
        reloadOnSearch: false
    },
    CHOOSE_PASSWORD: {
        url: '/choose_password?token&username&error',
        views: {
            main: {
                templateUrl: __webpack_require__(433),
                controller: 'ChoosePasswordController'
            }
        }
    },
    INVALID_LINK: {
        url: '/invalid_link',
        views: {
            main: {
                templateUrl: __webpack_require__(434)
            }
        }
    },
    PASSWORD_RESET_SUCCESS: {
        url: '/password_reset_success',
        views: {
            main: {
                templateUrl: __webpack_require__(435)
            }
        }
    },
    ERROR: {
        url: '/error/:errorKey',
        views: {
            main: {
                templateUrl: __webpack_require__(139),
                controller: 'ErrorController'
            }
        }
    }
});


/***/ }),
/* 425 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"page-login-background\" ng-hide=\"ctrl.loggedIn()\">\n<div class=\"page-login-topbar\">\n<eol-notice class=\"page-login-eol-notice\"></eol-notice>\n<locale-chooser-small class=\"page-login-locale-chooser\"></locale-chooser-small>\n</div>\n<div class=\"page-login-background-band\">\n<div class=\"logo-black\"></div>\n</div>\n<div class=\"page-login-content\">\n<div class=\"page-login-content-headings\">\n<h3>{{ 'LOG_IN.LOG_IN' | translate }}</h3>\n</div>\n<div>\n<ike-form submit=\"ctrl.login()\">\n<ike-input-text class=\"IkeInputText-icon-user\" placeholder=\"{{ 'LOG_IN.TYPE_YOUR_EMAIL' | translate }}\" name=\"username\" ng-model=\"user.username\" type=\"email\" required>\n</ike-input-text>\n<ike-input-validation for=\"username\" when=\"required\" message=\"{{ 'LOG_IN.VALID_EMAIL_REQUIRED' | translate }}\"></ike-input-validation>\n<ike-input-text class=\"IkeInputText-icon-password\" placeholder=\"{{ 'LOG_IN.TYPE_YOUR_PASSWORD' | translate }}\" name=\"password\" ng-model=\"user.password\" type=\"password\" required>\n</ike-input-text>\n<ike-input-validation for=\"password\" when=\"required\" message=\"{{ 'LOG_IN.PASSWORD_REQUIRED' | translate }}\"></ike-input-validation>\n<ike-button type=\"submit\" ng-disabled=\"ctrl.inProgress()\" class=\"page-login-loginButton\">{{ ctrl.inProgress() ? 'LOG_IN.LOGGING_IN' : 'LOG_IN.LOG_IN' | translate }}</ike-button>\n</ike-form>\n<div class=\"page-login-below-links\">\n<span>\n<a class=\"page-login-forgot-password\" href=\"#/forgotPassword\">{{ 'LOG_IN.FORGOT_PASSWORD' | translate }}</a>\n</span>\n</div>\n<p class=\"page-login-error error\" ng-show=\"ctrl.hasError()\">\n<i> </i>\n<span>{{ 'LOG_IN.INCORRECT_USERNAME_OR_PASSWORD' | translate }}</span>\n</p>\n</div>\n</div>\n</div>";
var id1="login.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 426 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"page-signup-background\" ng-hide=\"ctrl.loggedIn()\">\n<div class=\"page-signup-topbar\">\n<eol-notice class=\"page-signup-eol-notice\"></eol-notice>\n<locale-chooser-small class=\"page-signup-locale-chooser\"></locale-chooser-small>\n</div>\n<div class=\"page-signup-background-band\">\n<div class=\"logo-black\"></div>\n</div>\n<div class=\"page-signup-content\">\n<div class=\"page-signup-content-headings\">\n<h3>{{ 'SIGN_UP.SIGN_UP' | translate }}</h3>\n<a href=\"#/login\" class=\"page-signup-login-link\">{{ 'SIGN_UP.LOG_IN' | translate }}</a>\n</div>\n<div>\n<ike-form submit=\"ctrl.signup()\">\n<ike-input-text class=\"IkeInputText-icon-user\" placeholder=\"{{ 'SIGN_UP.TYPE_YOUR_EMAIL' | translate }}\" name=\"email\" ng-model=\"user.email\" type=\"email\" required>\n</ike-input-text>\n<ike-input-validation for=\"email\" when=\"required\" message=\"{{ 'SIGN_UP.VALID_EMAIL_REQUIRED' | translate }}\"></ike-input-validation>\n<ike-input-text class=\"IkeInputText-icon-password\" placeholder=\"{{ 'SIGN_UP.TYPE_YOUR_PASSWORD' | translate }}\" name=\"password\" ng-model=\"user.password\" type=\"password\" required>\n</ike-input-text>\n<ike-input-validation for=\"password\" when=\"required\" message=\"{{ 'SIGN_UP.PASSWORD_REQUIRED' | translate }}\"></ike-input-validation>\n<ike-input-checkbox name=\"terms\" ng-model=\"user.terms\" required pattern=\"true\">\n<span class=\"page-signup-termsAndConditions-link\" ng-bind-html=\"'SIGN_UP.ACCEPT_TERMS_AND_CONDITIONS' | translate | html\"></span>\n</ike-input-checkbox>\n<ike-input-validation for=\"terms\" when=\"required\" message=\"{{ 'SIGN_UP.TERMS_AND_CONDITIONS_REQUIRED' | translate }}\"></ike-input-validation>\n<ike-input-validation for=\"terms\" when=\"pattern\" message=\"{{ 'SIGN_UP.TERMS_AND_CONDITIONS_REQUIRED' | translate }}\"></ike-input-validation>\n<ike-button type=\"submit\" ng-disabled=\"ctrl.inProgress()\" class=\"page-signup-signupButton\">{{ctrl.inProgress() ? 'SIGN_UP.SIGNING_UP' : 'SIGN_UP.SIGN_UP' | translate}}</ike-button>\n</ike-form>\n</div>\n</div>\n</div>";
var id1="signup.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 427 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"page-forgotpassword-background\">\n<div class=\"page-forgotpassword-locale-chooser\">\n<locale-chooser-small></locale-chooser-small>\n</div>\n<div class=\"page-forgotpassword-background-band\">\n<div class=\"logo-black\"></div>\n</div>\n<div class=\"page-forgotpassword-content\">\n<div class=\"page-forgotpassword-content-headings\">\n<h3>{{ 'FORGOT_PASSWORD.FORGOT_PASSWORD' | translate }}</h3>\n<p>{{ 'FORGOT_PASSWORD.TELL_US_YOUR_EMAIL' | translate }}</p>\n</div>\n<div>\n<ike-form name=\"forgotPassword\" submit=\"requestPasswordReset()\">\n<div class=\"page-forgotpassword-emailbox\">\n<ike-input-text class=\"IkeInputText-icon-user\" placeholder=\"{{ 'FORGOT_PASSWORD.TYPE_YOUR_EMAIL' | translate }}\" name=\"email\" ng-model=\"user.email\" type=\"email\" required>\n</ike-input-text>\n<ike-input-validation for=\"email\" when=\"required\" message=\"{{ 'FORGOT_PASSWORD.VALID_EMAIL_REQUIRED' | translate }}\"></ike-input-validation>\n</div>\n<ike-button type=\"submit\" ng-disabled=\"sending\" class=\"page-forgotPassword-sendButton\">\n{{ sending ? 'FORGOT_PASSWORD.SENDING' : 'FORGOT_PASSWORD.SEND' | translate }}\n</ike-button>\n</ike-form>\n</div>\n</div>\n</div>";
var id1="forgotPassword.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 428 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<layout-container direction=\"row\">\n<layout-content class=\"pages-gallery-sidebar-column\">\n<div class=\"pages-gallery-sidebar-wrapper\" ng-controller=\"FolderController\">\n<ike-sidebar class=\"pages-gallery-sidebar\" sidebar-title=\"{{ 'GALLERY.TITLE' | translate }}\">\n<div class=\"pages-gallery-sidebar-actions\">\n<ike-button class=\"pages-gallery-sidebar-newFolder\" ng-click=\"createNew()\">\n<i class=\"gallery-sidebar-create-icon\"></i>\n<span>{{ 'GALLERY.NEW_FOLDER' | translate }}</span>\n</ike-button>\n<ike-button class=\"pages-gallery-sidebar-deletefolder\" ng-click=\"deleteSelectedFolder()\" title=\"{{ 'GALLERY.DELETE_FOLDER' | translate }}\">\n<i class=\"gallery-sidebar-delete-icon\"></i>\n</ike-button>\n</div>\n<scroll class=\"pages-gallery-sidebar-folderlist\">\n<ul>\n<folder-listitem ng-repeat=\"folder in folders\" folder=\"folder\" selected-folder=\"selected\" folders=\"folders\" capture-dropped=\"onDropped(folder, capture)\" select=\"select(folder)\"></folder-listitem>\n</ul>\n</scroll>\n</ike-sidebar>\n</div>\n</layout-content>\n<layout-content grow=\"true\">\n<layout-container direction=\"column\">\n<layout-content>\n<ike-toolbar>\n<ike-button class=\"pages-gallery-toolbar-delete\" ng-click=\"deleteSelectedCaptures()\" title=\"{{ 'GALLERY.DELETE_SELECTED_CAPTURE' | translate }}\">\n<i class=\"pages-gallery-toolbar-delete-icon\"></i><span class=\"pages-gallery-toolbar-link-text\">{{ 'GALLERY.DELETE' | translate }}</span>\n</ike-button>\n<ike-button class=\"pages-gallery-toolbar-select-all\" ng-click=\"selectAll()\">\n<i class=\"pages-gallery-toolbar-select-all-icon\"></i><span class=\"pages-gallery-toolbar-link-text\">{{ 'GALLERY.SELECT_ALL' | translate }}</span>\n</ike-button>\n<ike-button class=\"pages-gallery-toolbar-select-none\" ng-click=\"deselectAll()\">\n<i class=\"pages-gallery-toolbar-select-none-icon\"></i><span class=\"pages-gallery-toolbar-link-text\">{{ 'GALLERY.UNSELECT_ALL' | translate }}</span>\n</ike-button>\n</ike-toolbar>\n</layout-content>\n<layout-content grow=\"true\" class=\"pages-gallery-captures\">\n<span class=\"pages-gallery-captures-empty\" ng-show=\"isEmpty() && !isLoadingCaptures()\">{{ 'GALLERY.EMPTY_FOLDER' | translate }}</span>\n<scroll class=\"pages-gallery-captures-scroll\">\n<div class=\"pages-gallery-captures-padding\">\n<stretch-container class=\"pages-gallery-item-container\" min=\"260\" max=\"300\" collapse=\"true\" ng-repeat=\"capture in shownCaptures | orderBy:'getName() || (\\'COMPONENT.CAPTURE.NEW_MEASUREMENT\\' | translate)'\">\n<gallery-item class=\"pages-gallery-item\" capture=\"capture\" scroll-visibility visible-event=\"SHOULD_LOAD\"></gallery-item>\n</stretch-container>\n</div>\n</scroll>\n</layout-content>\n</layout-container>\n</layout-content>\n</layout-container>\n";
var id1="gallery.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 429 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<layout-container direction=\"row\">\n<layout-content>\n<ike-sidebar sidebar-title=\"{{ ctrl.getCapture().getName()  || ('COMPONENT.CAPTURE.NEW_MEASUREMENT' | translate ) }}\">\n<ike-breadcrumb capture=\"ctrl.getCapture()\"></ike-breadcrumb>\n<div class=\"pages-report-sidebar-helptext\" ng-bind-html=\"'REPORT.HELP' | translate | html\"></div>\n</ike-sidebar>\n</layout-content>\n<layout-content grow=\"true\">\n<layout-container direction=\"column\">\n<layout-content class=\"pages-report-toolbar\">\n<share-url url=\"{{ctrl.getShareURL()}}\"></share-url>\n<capture-export-selector capture=\"ctrl.getCapture()\"></capture-export-selector>\n<ike-toolbar>\n<ike-button class=\"pages-report-print\" ng-click=\"ctrl.print()\">\n<i class=\"glyphicon-print-grey\"></i>\n{{ 'REPORT.PRINT' | translate }}\n</ike-button>\n<ike-button class=\"pages-report-download\" ng-click=\"ctrl.download()\">\n<i class=\"glyphicon-download-grey\"></i>\n{{ 'REPORT.DOWNLOAD' | translate }}\n</ike-button>\n<ike-button class=\"pages-report-share\" ng-click=\"ctrl.shareCaptureURL()\">\n<i class=\"glyphicon-link-grey\"></i>\n{{ 'REPORT.SHARE_URL' | translate }}\n</ike-button>\n</ike-toolbar>\n</layout-content>\n<layout-content grow=\"true\">\n<scroll class=\"pages-report-viewport\" theme=\"light\">\n<layout-container class=\"pages-report-content\">\n<ike-zoom-control on-zoomin-click=\"ctrl.zoomIn(3)\" on-zoomout-click=\"ctrl.zoomOut(3)\" get-zoom=\"ctrl.getZoom()\" set-zoom=\"ctrl.setZoom(zoom)\" class=\"pages-report-capture-zoom-control\">\n</ike-zoom-control>\n<report-page class=\"pages-report-page\" heading=\"ctrl.getCapture().getName()  || ('COMPONENT.CAPTURE.NEW_MEASUREMENT' | translate )\" measurements=\"ctrl.getMeasurements()\" note=\"ctrl.getNote()\">\n<zoom-pan class=\"pages-report-zoomPan\" zoom=\"ctrl.getZoom()\" zoom-in=\"ctrl.zoomIn(3)\" zoom-out=\"ctrl.zoomOut(3)\" set-view-port-scale-factor=\"ctrl.setViewPortScaleFactor(factor)\" set-zoom-area=\"ctrl.setZoomArea(zoomArea)\" no-mouse-scroll=\"true\">\n<composite-image class=\"pages-report-compositeImage\" capture=\"ctrl.getCapture()\"></composite-image>\n</zoom-pan>\n</report-page>\n</layout-container>\n</scroll>\n</layout-content>\n</layout-container>\n</layout-content>\n</layout-container>";
var id1="report.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 430 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<layout-container direction=\"column\" class=\"pages-measureview\" ng-show=\"sharedCapture\">\n<layout-content class=\"pages-measureview-toolbar\">\n<ike-toolbar>\n<ike-button class=\"pages-measureview-print\" ng-click=\"ctrl.print()\">\n<i class=\"glyphicon-print-grey\"></i>\n{{ 'SHARED_CAPTURE.PRINT' | translate }}\n</ike-button>\n<ike-button ng-show=\"ctrl.canImportSharedCapture()\" class=\"pages-measureview-import\" ng-click=\"ctrl.importSharedCapture(sharedCapture)\">\n<i class=\"glyphicon-download-grey\"></i>\n{{ 'SHARED_CAPTURE.IMPORT_TO_GALLERY' | translate }}\n</ike-button>\n</ike-toolbar>\n</layout-content>\n<layout-content grow=\"true\">\n<scroll class=\"pages-measureview-viewport\" theme=\"light\">\n<layout-container class=\"pages-measureview-content\">\n<report-page class=\"pages-measureview-report-page\" heading=\"sharedCapture.getName()  || ('COMPONENT.CAPTURE.NEW_MEASUREMENT' | translate )\" measurements=\"sharedMeasurements\" note=\"sharedNote\" units=\"sharedCapture.getUnits()\">\n<div class=\"pages-measureview-exportImageWrapper\"></div>\n</report-page>\n</layout-container>\n</scroll>\n</layout-content>\n</layout-container>";
var id1="measureView.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 431 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<layout-container direction=\"row\">\n<layout-content grow=\"true\">\n<capture-map center=\"mapViewCtrl.center\" class=\"pages-mapview-map\"></capture-map>\n</layout-content>\n<layout-content class=\"pages-mapview-captures\">\n<scroll class=\"pages-mapview-captures-scroll\">\n<gallery-item class=\"pages-mapview-capture\" notdraggable notselectable ng-repeat=\"capture in mapViewCtrl.getSelectedCaptures()\" capture=\"capture\" scroll-visibility visible-event=\"SHOULD_LOAD\">\n</gallery-item>\n</scroll>\n</layout-content>\n</layout-container>\n";
var id1="map.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 432 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<layout-container direction=\"row\">\n<layout-content class=\"pages-gallery-sidebar-column\">\n<div class=\"pages-gallery-sidebar-wrapper\">\n<ike-sidebar sidebar-title=\"Billing and Subscription\">\n</ike-sidebar>\n</div>\n</layout-content>\n<layout-content grow=\"true\">\n<layout-container direction=\"column\">\n<layout-content class=\"billing-toolbar\">\n<ike-toolbar>\n</ike-toolbar>\n</layout-content>\n<layout-content ng-show=\"!loading\">\n<div class=\"Subscription-section\">\n<div>\n<premium-trial-tile subscription=\"subscription\" current-card=\"currentCard\" trial-days-remaining=\"trialDaysRemaining\" open-update-card=\"openUpdateCard()\" cancel-subscription-trial=\"cancelSubscriptionTrial\">\n</premium-trial-tile>\n<premium-tile subscription=\"subscription\" current-card=\"currentCard\" open-update-card=\"openUpdateCard()\" open-purchase-premium-modal=\"openPurchasePremiumModal()\" cancel-subscription=\"cancelSubscription\">\n</premium-tile>\n<premium-expired-tile subscription=\"subscription\" can-trial=\"canTrial\" current-card=\"currentCard\" open-update-card=\"openUpdateCard()\">\n</premium-expired-tile>\n</div>\n</div>\n</layout-content>\n<layout-content ng-show=\"!loading\">\n<layout-container direction=\"column\">\n<layout-content>\n<div class=\"Billing-billingDetails\" ng-show=\"hasBillingDetails()\">\n<div class=\"Billing-sectionContainer\" ng-show=\"hasUpcomingInvoice()\">\n<div class=\"Billing-section\">\n<div ng-show=\"upcomingInvoice && currentCard\">\n<div class=\"BillingTableHeader\">\n<div class=\"BillingTableHeader-left\">\n<h4>{{ 'BILLING.NEXT_PAYMENT' | translate }}</h4>\n</div>\n<div class=\"BillingTableHeader-right\"></div>\n</div>\n<table class=\"BillingTable\">\n<thead>\n<tr>\n<th>\n<span>{{ 'BILLING.DATE' | translate }}</span>\n</th>\n<th>\n<span>{{ 'BILLING.TOTAL' | translate }}</span> (USD)</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td class=\"BillingTable-dateCell\">{{ upcomingInvoice.next_payment_attempt | fixStripeDate | date: 'shortDate' }}\n</td>\n<td>{{ upcomingInvoice.total / 100 | currency:\"$\" }}</td>\n</tr>\n<tr>\n<td>&nbsp;</td>\n<td>&nbsp;</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n</div>\n</layout-content>\n</layout-container>\n</layout-content>\n<layout-content ng-show=\"!loading\">\n<div class=\"Billing-invoiceDetails\" ng-show=\"hasInvoiceHistory()\">\n<div class=\"Billing-sectionContainer\">\n<div class=\"Billing-section\">\n<div class=\"BillingTableHeader\">\n<div class=\"BillingTableHeader-left\">\n<h4>{{ 'BILLING.INVOICE_HISTORY' | translate }}</h4>\n</div>\n<div class=\"BillingTableHeader-right\"></div>\n</div>\n<table class=\"BillingTable\">\n<thead>\n<tr>\n<th>\n<span>{{ 'BILLING.DATE' | translate }}</span>\n</th>\n<th>\n<span>{{ 'BILLING.TOTAL' | translate }}</span> (USD)\n</th>\n<th>\n<span>{{ 'BILLING.PAYMENT_STATUS' | translate }}</span>\n</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"invoice in invoices | greaterThan:'total':0\">\n<td class=\"BillingTable-dateCell\">{{ invoice.date | fixStripeDate | date: 'shortDate' }}</td>\n<td>{{ invoice.total / 100 | currency:\"$\" }}</td>\n<td>{{ invoice.paid ? 'BILLING.PAYMENT_STATUS_PAID' : 'BILLING.PAYMENT_STATUS_FAILED' | translate }}</td>\n</tr>\n<tr>\n<td>&nbsp;</td>\n<td>&nbsp;</td>\n<td>&nbsp;</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n<update-card display-event=\"DISPLAY_UPDATE_CARD\" dismiss-event=\"DISMISS_UPDATE_CARD\"></update-card>\n<purchase-premium class=\"Billing-PurchasePremium\"></purchase-premium>\n</layout-content>\n</layout-container>\n</layout-content>\n</layout-container>";
var id1="billing.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 433 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"pages-remote-background\">\n<div class=\"page-remote-locale-chooser\">\n<locale-chooser-small></locale-chooser-small>\n</div>\n<div class=\"pages-remote-background-band\">\n<div class=\"logo-black\"></div>\n</div>\n<div class=\"pages-remote-content\">\n<div class=\"pages-remote-content-headings\">\n<h3>{{ 'STATIC_PAGES.CHOOSE_PASSWORD.FORGOT_PASSWORD' | translate }}</h3>\n<p>{{ 'STATIC_PAGES.CHOOSE_PASSWORD.CHOOSE_NEW_PASSWORD' | translate }}\n<span id=\"username_label\"></span>\n</p>\n</div>\n<div>\n<form action=\"{{ formAction }}\" method=\"POST\">\n<div class=\"IkeInputText-icon-password IkeInputText\">\n<i></i>\n<input name=\"new_password\" required type=\"password\" placeholder=\"{{ 'STATIC_PAGES.CHOOSE_PASSWORD.PASSWORD' | translate }}\"/>\n</div>\n<input name=\"utf-8\" type=\"hidden\" value=\"✓\"/>\n<input name=\"username\" type=\"hidden\" value=\"{{ username }}\"/>\n<input name=\"token\" type=\"hidden\" value=\"{{ token }}\"/>\n<button class=\"pages-remote-sendButton IkeButton\">\n<span>{{ 'STATIC_PAGES.CHOOSE_PASSWORD.CHANGE_MY_PASSWORD' | translate }}</span>\n</button>\n<div class=\"error\" ng-class=\"{'alert alert-danger': error}\">{{ error }}</div>\n</form>\n</div>\n</div>\n</div>\n";
var id1="choose_password.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 434 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"pages-remote-background\">\n<div class=\"page-remote-locale-chooser\">\n<locale-chooser-small></locale-chooser-small>\n</div>\n<div class=\"pages-remote-background-band\">\n<div class=\"logo-black\"></div>\n</div>\n<div class=\"pages-remote-content\">\n<div class=\"pages-remote-content-headings\">\n<h3>Oops!</h3>\n<p ng-bind-html=\"'STATIC_PAGES.INVALID_LINK.ALREADY_USED' | translate | html\"></p>\n</div>\n</div>\n</div>\n";
var id1="invalid_link.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 435 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"pages-remote-background\">\n<div class=\"page-remote-locale-chooser\">\n<locale-chooser-small></locale-chooser-small>\n</div>\n<div class=\"pages-remote-background-band\">\n<div class=\"logo-black\"></div>\n</div>\n<div class=\"pages-remote-content\">\n<div class=\"pages-remote-content-headings\">\n<h3>{{ 'STATIC_PAGES.PASSWORD_UPDATED.GREAT' | translate }}</h3>\n<p ng-bind-html=\"'STATIC_PAGES.PASSWORD_UPDATED.PASSWORD_UPDATED_CLICK_HERE' | translate | html\"></p>\n</div>\n</div>\n</div>\n";
var id1="password_reset_success.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 436 */
/***/ (function(module, exports) {

angular.module('ikeweb').run(['$location', '$rootScope', 'loginService',
    function($location, $rootScope, $loginService) {

        var unsecurePaths = [
            '/login',
            '/forgotPassword',
            '/signup',
            '/measureView/.*',
            '/error',
            '/choose_password',
            '/invalid_link',
            '/password_reset_success'
        ];

        function isUnsecurePath(path) {
            return unsecurePaths.reduce(function(result, unsecurePath) {
                return result || new RegExp(unsecurePath).test(path);
            }, false);
        }

        function checkLogin() {
            if ($loginService.getLoggedInUser() === null && !isUnsecurePath($location.path())) {
                $location.path('login');
            }
        }

        $rootScope.$on('$locationChangeStart', function() {
            checkLogin();
        });

        checkLogin();
    }
]);


/***/ }),
/* 437 */
/***/ (function(module, exports) {

angular.module('ikeweb.error', ['ikeweb.routes']);


/***/ }),
/* 438 */
/***/ (function(module, exports) {

angular.module('ikeweb.error').controller('ErrorController', ['$scope', '$stateParams',

    function($scope, $stateParams) {

        var Errors = {
            sharedCaptureNotFound: {
                title: 'Shared capture not found',
                message: 'The shared capture you\'re trying to view cannot be found. It may no longer exist.'
            },
            unknown: {
                title: 'Unknown Error',
                message: 'An unknown error has occurred.'
            }
        };

        var key = $stateParams.errorKey;

        $scope.errorTitle = Errors[key] ? Errors[key].title : Errors.unknown.title;
        $scope.errorMessage = Errors[key] ? Errors[key].message : Errors.unknown.message;
    }
]);


/***/ }),
/* 439 */
/***/ (function(module, exports) {

angular.module('ikeweb.event', []);


/***/ }),
/* 440 */
/***/ (function(module, exports) {

angular.module('ikeweb.event').value('events', {
    SUBSCRIPTION: {
        CREATED: 'subscription.created',
        CANCELED: 'subscription.canceled'
    },
    FOLDER: {
        SELECTED: 'folder.selected',
        FOCUS: 'folder.focus',
        UPDATED: 'folder.updated',
        DROPPED: 'folder.droppped',
        NEW_FOCUS: 'folder.newfocus',
        CAPTURE: {
            DROPPED: 'folder.capture.dropped'
        }
    },
    NOTE: {
        SELECTED: 'note.selected',
        FOCUS: 'note.focus'
    },
    BILLING: {
        PURCHASE_PREMIUM: {
            DISPLAY: 'billing.purchase_premium.display',
            DISMISS: 'billing.purchase_premium.dismiss',
            SELECT_CURRENT_PLAN: 'billing.purchase_premium.select_current_plan'
        },
        PURCHASE_TRIAL: {
            DISPLAY: 'billing.purchase_trial.display'
        },
        PURCHASE: {
            DISPLAY_MODAL: 'billing.purchase.display_modal',
            DISMISS_MODAL: 'billing.purchase.dismiss_modal'
        }
    },
    SHARING: {
        DISPLAY_SHARE_URL: 'display.share.url',
        DISMISS_SHARE_URL: 'dismiss.share.url'
    },
    EXPORT: {
        DISMISS_EXPORT_SELECTOR: 'export.dismiss.export.selector',
        DISPLAY_EXPORT_SELECTOR: 'export.display.export.selector',
        DOWNLOAD: {
            COMPOSITE: 'export.download.composite',
            DESKEWED: 'export.download.deskewed',
            IMAGEONLY: 'export.download.imageonly'
        }
    }
});


/***/ }),
/* 441 */
/***/ (function(module, exports) {

angular.module('ikeweb.unit', [
    'ikeweb.user',
    'ikegps.math',
    'ikeweb.shared.decoration',
    'ikeweb.shared.notification',
    'ikeweb.spike.measure'
]);


/***/ }),
/* 442 */
/***/ (function(module, exports) {

angular.module('ikeweb.unit').filter('area', ['measurementFormatterService',
    function(measurementFormatterService) {

        function area(value) {
            return measurementFormatterService.formatArea((value || 0));
        }
        area.$stateful = true;

        return area;
    }
]);


/***/ }),
/* 443 */
/***/ (function(module, exports) {

angular.module('ikeweb.unit').filter('length', ['measurementFormatterService',
    function(measurementFormatterService) {

        function length(value) {
            return measurementFormatterService.format((value || 0));
        }
        length.$stateful = true;

        return length;
    }
]);


/***/ }),
/* 444 */
/***/ (function(module, exports) {

angular.module('ikeweb.unit').filter('dimensions', ['measurementFormatterService',
    function(measurementFormatterService) {

        function dimensions(value) {
            return (value || [])
                .map(measurementFormatterService.format)
                .join(' x ');
        }
        dimensions.$stateful = true;

        return dimensions;
    }
]);


/***/ }),
/* 445 */
/***/ (function(module, exports) {

angular.module('ikeweb.unit').service('unitService', ['loginService', 'ikemath',

    function(loginService, ikemath) {

        var Units = ikemath.Units;

        function getUnitList() {
            return Units.LIST;
        }

        function getDefaultUnit() {
            return Units.FEET;
        }

        function getUnit() {
            var user = loginService.getLoggedInUser();
            return user && user.getUnit() || getDefaultUnit();
        }

        function setUnit(unit) {
            return loginService.save(loginService.getLoggedInUser().setUnit(unit));
        }

        return {
            getUnit: getUnit,
            setUnit: setUnit,
            getUnitList: getUnitList
        };
    }
]).config(['$provide',
    function($provide) {

        $provide.decorator('unitService', ['$delegate', 'decoratedPromiseBuilder', 'notificationService', '$translate', 'functional',
            function($delegate, decoratedPromiseBuilder, notificationService, $translate, f) {

                var getUnitList = $delegate.getUnitList;
                $delegate.getUnitList = function() {
                    return getUnitList().map(function(unit) {
                        var clonedUnit = f.cloneMap(unit);
                        clonedUnit.label = $translate.instant('COMPONENT.UNIT.' + unit.value.toUpperCase());
                        return clonedUnit;
                    });
                };

                return decoratedPromiseBuilder
                    .forDelegate($delegate)
                    .decorate('setUnit')
                    .onSuccess(notificationService.success('NOTIFICATION.UNIT.CHANGE_PREFERENCES', 'NOTIFICATION.UNIT.PREFERENCES_CHANGED'))
                    .onError(notificationService.error('NOTIFICATION.UNIT.CHANGE_PREFERENCES', 'NOTIFICATION.UNIT.CHANGE_PREFERENCES_PROBLEM'))
                    .fork();
            }
        ]);
    }
]);


/***/ }),
/* 446 */
/***/ (function(module, exports) {

angular.module('ikeweb.repository', [
    'ikeweb.shared.repository.parse',
    'ikeweb.shared.progress',
    'ikeweb.shared.caching',
    'ikeweb.user',
    'ikeweb.shared.promise'
]);


/***/ }),
/* 447 */
/***/ (function(module, exports) {

angular.module('ikeweb.repository').service('repositoryFactory', ['ParseRepository', 'qPromiseDecoratorService', 'promiseProgressDecoratorService', 'cacheDecoratorBuilder', 'userHashService', 'parseErrorDecoratorService',
    function(ParseRepository, qPromiseDecoratorService, promiseProgressDecoratorService, cacheDecoratorBuilder, userHashService, parseErrorDecoratorService) {

        var functionsToCache = ['get', 'list'];
        var functionsThatFlush = ['create', 'save', 'destroy'];
        var functionsToDecorate = functionsToCache.concat(functionsThatFlush);

        function addProgress(repository) {
            return promiseProgressDecoratorService.decorateDelegateWithProgress(repository, functionsToDecorate);
        }

        function addCaching(repository) {
            return cacheDecoratorBuilder
                .aCacheDecorator()
                .withTTL(moment.duration(1, 'minutes').asMilliseconds())
                .withHash(userHashService.hash)
                .build()
                .decorateDelegateWithCaching(repository, functionsToCache, functionsThatFlush);
        }

        function translateToQPromises(repository) {
            return qPromiseDecoratorService.decorateDelegateWithPromise(repository, functionsToDecorate);
        }

        function translateParseErrors(repository, overrides) {
            return parseErrorDecoratorService.decorateDelegatePromiseErrors(repository, functionsToDecorate, overrides);
        }

        function createRepository(className, objectFactory) {
            return new ParseRepository(className, objectFactory);
        }

        function create(className, objectFactory, errorOverrides) {
            return addProgress(addCaching(translateParseErrors(translateToQPromises(createRepository(className, objectFactory)), errorOverrides)));
        }

        return {
            create: create
        };
    }
]);


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(449);

angular.module('ikeweb.layout').directive('eolNotice', [
    function() {
        return {
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            replace: true,
            scope: {},
            controllerAs: 'ctrl',
            controller: function() {
                this.eolTermsUrl = 'https://spike.ikegps.com/eol-notice/';
            }
        };
    }
]);


/***/ }),
/* 449 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<a class=\"EolNotice\" href=\"{{ ctrl.eolTermsUrl }}\" target=\"_blank\" rel=\"noopener noreferrer\">\n{{ 'COMPONENT.EOL_NOTICE.MESSAGE' | translate }}\n</a>";
var id1="eol-notice.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 450 */
/***/ (function(module, exports) {

angular.module('ikeweb.folders').controller('FolderListitemController', ['$scope', 'folderService', 'events', '$translate', 'orderByFilter',
    function($scope, folderService, EVENTS, $translate, orderByFilter) {

        $scope.shownFolders = function() {
            var shownFolderIds = folderService.getVisibleFolders();
            return shownFolderIds.indexOf($scope.folder.getId()) > -1;
        };

        function isSelected() {
            return $scope.folder.isSameAs($scope.selected);
        }

        $scope.activeIfSelected = function() {
            var selected = isSelected();
            return selected ? 'FolderListitem--selected' : '';
        };

        $scope.ordinalClass = function() {
            if ($scope.folder.ordinal == null) {
                return '';
            }
            return 'FolderListitem-ordinal-' + $scope.folder.ordinal;
        };

        $scope.selectMe = function() {
            if (!isSelected()) {
                $scope.select({
                    folder: $scope.folder
                });
            }
        };

        $scope.editIfSelected = function() {
            if (!$scope.inEditMode) {
                $scope.inEditMode = isSelected();
                if ($scope.inEditMode) {
                    $scope.selectText();
                }
            }
        };

        function setFolderName(folder) {
            $scope.folderName = folder.getName();
        }

        function setSubFolders(folder) {
            $scope.subFolders = folder.subFolders;
            $scope.ordinal = folder.ordinal;
        }

        function sameName(name) {
            return function(folder) {
                return folder.getName() === name;
            };
        }

        function folderNameExists(name) {
            return $scope.folders.filter(sameName(name)).length > 0;
        }

        function notifyFolderUpdated(newFolder) {
            $scope.$emit(EVENTS.FOLDER.UPDATED, newFolder);
            return Promise.resolve();
        }

        $scope.newSubfolder = function(folder) {
            if (!$scope.canMakeSubFolder) {
                return;
            }
            var folderName = $translate.instant('COMPONENT.FOLDER.UNTITLED_FOLDER');

            while (folderNameExists(folderName)) {
                if (/\d$/.test(folderName)) {
                    folderName = folderName.replace(/\d$/, parseInt(folderName.slice(-1), 10) + 1);
                } else {
                    folderName = folderName + ' 2';
                }
            }

            return folderService.newSubfolder(folderName, folder.getId())
                .then(function(newFolder) {
                    return notifyFolderUpdated(newFolder);
                });
        };

        $scope.renameIfNecessary = function() {
            if ($scope.inEditMode && $scope.folder.getName() !== $scope.folderName) {
                folderService.rename($scope.folder, $scope.folderName)
                    .then(setFolderName, function() {
                        setFolderName($scope.folder);
                    });
            }
            $scope.inEditMode = false;
        };

        $scope.$watch('selected', function() {
            if (!isSelected()) {
                $scope.inEditMode = false;
            }
        });

        setFolderName($scope.folder);
        setSubFolders($scope.folder);
        $scope.inEditMode = false;
        $scope.$on(EVENTS.FOLDER.FOCUS, function(evt, folder) {
            if ($scope.folder.isSameAs(folder)) {
                $scope.selectMe();
                $scope.inEditMode = true;
                $scope.focus();
                $scope.selectText();
            }
        });
    }
]);


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(452);
angular.module('ikeweb.folders').directive('folderListitem', ['$timeout', 'billingService',
    function($timeout, billingService) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: TEMPLATE_URL,
            transclude: true,
            scope: {
                folder: '=',
                selected: '=selectedFolder',
                select: '&',
                captureDropped: '&',
                folders: '='
            },
            controller: 'FolderListitemController',
            link: function(scope, element, attrs) {
                var input = element.find('.FolderListitem-name');
                scope.focus = function() {
                    $timeout(function() {
                        input[0].focus();
                    });
                };

                scope.canMakeSubFolder = false;
                billingService.isOnPremium().then(function(isPro) {
                    scope.canMakeSubFolder = isPro;
                });

                scope.selectText = function() {
                    input[0].select();
                };

                input.bind('keypress', function(event) {
                    if (event.which === 13) {
                        input.blur();
                    }
                });

                function acceptCapture($draggable) {
                    var capture = $draggable.data('capture');
                    return capture && !capture.isInFolder(scope.folder);
                }

                element.droppable({
                    addClasses: false,
                    accept: acceptCapture,
                    hoverClass: 'FolderListitem-dragover',
                    tolerance: 'pointer'
                });


                element.on('drop', function(evt, ui) {
                    ui.helper.data('dropped', true);
                    scope.captureDropped({
                        folder: scope.folder,
                        capture: ui.draggable.data('capture')
                    });
                });

            }
        };
    }
]);


/***/ }),
/* 452 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<li class=\"FolderListitem\" ng-class=\"activeIfSelected() + ' ' + ordinalClass()\" ng-click=\"selectMe()\" ng-show=\"ordinal==0 || shownFolders()\">\n<div class=\"ProBadgeContainer\">\n<a title=\"{{ 'COMPONENT.FOLDER_LISTITEM.DOUBLE_CLICK_TO_RENAME' | translate }}\">\n<i class=\"FolderListitem-icon\"></i>\n<input class=\"FolderListitem-name\" type=\"text\" ng-model=\"folderName\" ng-class=\"{'read-only': !inEditMode}\" ng-readonly=\"!inEditMode\" ng-class=\"{'FolderListitem-name-readonly' : !inEditMode}\" ng-blur=\"renameIfNecessary()\" ng-dblclick=\"editIfSelected()\">\n\n</a>\n<a ng-show=\"ordinal<2\">\n<i class=\"FolderListitem-subfolder-new\" ng-class=\"{'FolderListitem-subfolder-new-enabled': canMakeSubFolder, 'FolderListitem-subfolder-new-disabled': !canMakeSubFolder }\" ng-click=\"newSubfolder(folder)\">\n<div class=\"FolderListitem-disabled-tooltip\">\n<div class=\"material-icons pro-lock pro-lock-small\">lock_outline</div>\n<div>{{ 'COMPONENT.FOLDER_LISTITEM.NOTE_PRO_MESSAGE' | translate }}</div>\n</div>\n</i>\n</a>\n<div ng-show=\"ordinal<2 && !canMakeSubFolder\" class=\"ProBadge ProBadge--Folder\">pro</div>\n</div>\n</li>";
var id1="folder.listitem.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 453 */
/***/ (function(module, exports) {

angular.module('ikeweb.folders').service('folderRepository', ['repositoryFactory', 'folderFactory',
    function(repositoryFactory, folderFactory) {
        return repositoryFactory.create('Folder', folderFactory, {
            101: 'FOLDER_NOT_FOUND'
        });
    }
]);


/***/ }),
/* 454 */
/***/ (function(module, exports) {

angular.module('ikeweb.folders').factory('folderFactory', ['ObjectFactory',
    function(ObjectFactory) {
        return new ObjectFactory(['name', 'parentId']);
    }
]);


/***/ }),
/* 455 */
/***/ (function(module, exports) {

angular.module('ikeweb.folders').controller('FolderController', ['$scope', 'folderService', 'events', 'confirmationService', 'orderByFilter', '$translate',
    function($scope, folderService, EVENTS, confirmationService, orderByFilter, $translate) {

        function select(folder) {
            folderService.setCurrent(folder);
            $scope.selected = folder;
            $scope.$emit(EVENTS.FOLDER.SELECTED, folder);
        }

        function firstIfExist(folders) {
            return folders.length ?
                folders[0] :
                undefined;
        }

        function isSame(folder) {
            return function(anotherFolder) {
                return folder && anotherFolder && folder.getId() === anotherFolder.getId();
            };
        }

        function sameName(name) {
            return function(folder) {
                return folder.getName() === name;
            };
        }

        function folderNameExists(name) {
            return $scope.folders.filter(sameName(name)).length > 0;
        }

        function folderExistsIn(folder, folders) {
            return folders.filter(isSame(folder)).length > 0;
        }

        function getFolderToSelect(folders) {
            return folderService.current()
                .then(function(currentFolder) {
                    return folderExistsIn(currentFolder, folders) ?
                        currentFolder :
                        firstIfExist(folders);
                }, function(error) {
                    return firstIfExist(folders);
                });
        }

        function setFolders(folders) {
            $scope.folders = folders;
            return getFolderToSelect(folders).then(select);
        }

        function listFolders() {
            return folderService.list()
                .then(folderService.orderByName)
                .then(setFolders);
        }

        function createNew() {
            var folderName = $translate.instant('COMPONENT.FOLDER.UNTITLED_FOLDER');

            while (folderNameExists(folderName)) {
                if (/\d$/.test(folderName)) {
                    folderName = folderName.replace(/\d$/, parseInt(folderName.slice(-1), 10) + 1);
                } else {
                    folderName = folderName + ' 2';
                }
            }
            return folderService.createNew(folderName)
                .then(function(newFolder) {
                    return listFolders()
                        .then(function() {
                            $scope.$broadcast(EVENTS.FOLDER.FOCUS, newFolder);
                        });
                });

        }

        function deleteSelectedFolder() {
            return confirmationService
                .confirm($translate.instant('NOTIFICATION.FOLDER.DELETE_FOLDER_TITLE'),
                    $translate.instant('NOTIFICATION.DELETE.CONFIRMATION'),
                    $translate.instant('NOTIFICATION.DELETE.CONFIRM'),
                    $translate.instant('NOTIFICATION.DELETE.CANCEL'))
                .then(function() {
                    return folderService.deleteFolder($scope.selected)
                        .then(listFolders);
                });
        }

        function captureDropped(folder, capture) {
            $scope.$emit(EVENTS.FOLDER.CAPTURE.DROPPED, {
                capture: capture,
                folder: folder
            });
        }

        $scope.$on(EVENTS.FOLDER.UPDATED, function(evt, newFolder) {
            listFolders().then(function() {
                $scope.$broadcast(EVENTS.FOLDER.FOCUS, newFolder);
            });

        });

        $scope.onDropped = captureDropped;
        $scope.select = select;
        $scope.createNew = createNew;
        $scope.deleteSelectedFolder = deleteSelectedFolder;

        listFolders();

    }
]);


/***/ }),
/* 456 */
/***/ (function(module, exports) {

angular.module('ikeweb.folders').factory('folderService', ['folderRepository', 'promiseFactory', 'localStorageService', 'folderFactory', 'orderByFilter',

        function(folderRepository, promiseFactory, localStorageService, folderFactory, orderByFilter) {

            var shown = [];
            var topLevelFolders = [];
            var firstLevelSubfolders = [];
            var flattenedList = [];

            function list() {
                return folderRepository.list();
            }

            function current() {
                return localStorageService.get('folder.current') ?
                    folderRepository.get(localStorageService.get('folder.current')) :
                    promiseFactory.promise();
            }

            function getVisibleFolders(folder) {
                return shown;
            }

            function getTopLevelFolder(folderId) {
                var topLevelFolder = null;
                if (flattenedList == null || flattenedList.length < 1) {
                    return;
                }
                //flattened list contains the folder with the tree data
                var folder = flattenedList.find(function(element) {
                    return folderId === element.getId();
                });

                if (folder.ordinal === 0) {
                    topLevelFolder = topLevelFolders.find(function(element) {
                        return folder.getId() === element.getId();
                    });
                } else if (folder.ordinal === 1) {
                    topLevelFolder = topLevelFolders.find(function(element) {
                        return folder.getParentId() === element.getId();
                    });
                } else if (folder.ordinal === 2) {
                    var firstLevelSubfolder = firstLevelSubfolders.find(function(element) {
                        return folder.getParentId() === element.getId();
                    });
                    topLevelFolder = topLevelFolders.find(function(element) {
                        return firstLevelSubfolder.getParentId() === element.getId();
                    });
                }
                return topLevelFolder;
            }

            function setVisibleFolders(folder) {
                shown = [];
                var topLevelFolder = getTopLevelFolder(folder.getId());
                if (topLevelFolder == null) {
                    return;
                }
                shown.push(topLevelFolder.getId());
                if (topLevelFolder.subFolders == null) {
                    return shown;
                }
                topLevelFolder.subFolders.forEach(function(subFolder) {
                    shown.push(subFolder.getId());
                    subFolder.subFolders.forEach(function(subSubFolder) {
                        shown.push(subSubFolder.getId());
                    });
                });

                return shown;
            }

            function setCurrent(folder) {
                if (folder == null) {
                    return undefined;
                }
                setVisibleFolders(folder);
                localStorageService.set('folder.current', folder.getId());
            }

            function rename(folder, newName) {
                if (folder.getName() === newName) {
                    return promiseFactory.resolvedPromise(folder);
                }

                var previousName = folder.getName();

                folder.setName(newName);

                return folderRepository.save(folder)
                    .catch(function(error) {
                        folder.setName(previousName);
                        return promiseFactory.rejectedPromise(error);
                    });
            }

            function createNew(name, parentId) {
                return folderRepository.create(folderFactory.fromAttributeMap({
                    name: name,
                    parentId: parentId
                }));
            }

            function deleteFolder(folder) {
                localStorageService.remove('folder.current');
                return folderRepository.destroy(folder);
            }

            function newSubfolder(folderName, parentId) {
                return createNew(folderName, parentId);
            }

            function sortFolderByParentAndName(x, y) {
                var xKey = '' + x.getParentId() + x.getName();
                var yKey = '' + y.getParentId() + y.getName();
                return xKey.localeCompare(yKey);
            }

            function orderByName(folders) {
                folders.sort(sortFolderByParentAndName);
                topLevelFolders = folders.filter(function(folder) {
                    return folder.getParentId() == null;
                });
                topLevelFolders = topLevelFolders.map(function(obj) {
                    obj.subFolders = [];
                    return obj;
                });

                firstLevelSubfolders = folders.filter(function(subFolder) {
                    return topLevelFolders.find(function(topFolder) {
                        var isChild = topFolder.getId() === subFolder.getParentId();
                        if (isChild) {
                            subFolder.subFolders = [];
                            topFolder.subFolders.push(subFolder);
                        }
                        return isChild;
                    });
                });

                folders.forEach(function(secondSubFolder) {
                    return firstLevelSubfolders.find(function(firstSubFolder) {
                        var isChild = firstSubFolder.getId() === secondSubFolder.getParentId();
                        if (isChild) {
                            firstSubFolder.subFolders.push(secondSubFolder);
                        }
                        return isChild;
                    });
                });

                flattenedList = [];
                // Ordinal levels are used for the ui to expand and collapse subfolders
                // also to indent each level as the data structure for the UI is the
                // flattened one.
                topLevelFolders.forEach(function(element, index) {
                    element.ordinal = 0;
                    flattenedList.push(element);
                    element.subFolders.forEach(function(element2, index) {
                        element2.ordinal = 1;
                        flattenedList.push(element2);
                        element2.subFolders.forEach(function(element3, index) {
                            element3.ordinal = 2;
                            flattenedList.push(element3);
                        });
                    });
                });

                return flattenedList;
            }

            return {
                list: list,
                current: current,
                setCurrent: setCurrent,
                rename: rename,
                createNew: createNew,
                deleteFolder: deleteFolder,
                newSubfolder: newSubfolder,
                orderByName: orderByName,
                getVisibleFolders: getVisibleFolders

            };
        }
    ])
    .config(['$provide', function($provide) {

        var functionsToDecorate = [
            'list',
            'current',
            'rename',
            'createNew',
            'deleteFolder'
        ];

        $provide.decorator('folderService', ['$delegate', 'decoratedPromiseBuilder', 'notificationService', 'cloudCodeErrors', 'loggingDecorator',
            function($delegate, decoratedPromiseBuilder, notificationService, CLOUD_ERRORS, loggingDecorator) {

                function errorIs(code) {
                    return function(error) {
                        return code === error.message;
                    };
                }

                var builder = decoratedPromiseBuilder.forDelegate($delegate);

                builder
                    .decorate('rename')
                    .onSuccess(notificationService.success('NOTIFICATION.FOLDER.RENAME_FOLDER', 'NOTIFICATION.FOLDER.FOLDER_RENAMED'))
                    .onErrorIf(errorIs(CLOUD_ERRORS.DUPLICATE), notificationService.error('NOTIFICATION.FOLDER.RENAME_FOLDER', 'NOTIFICATION.FOLDER.FOLDER_ALREADY_EXISTS'))
                    .onErrorIf(errorIs(CLOUD_ERRORS.FOLDER_NAME_EMPTY), notificationService.error('NOTIFICATION.FOLDER.RENAME_FOLDER', 'NOTIFICATION.FOLDER.EMPTY_FOLDER_NAME'))
                    .onError(notificationService.error('NOTIFICATION.FOLDER.RENAME_FOLDER', 'NOTIFICATION.FOLDER.RENAME_PROBLEM'));

                loggingDecorator.addLoggingWithBuilder(builder, functionsToDecorate);

                return builder.fork();
            }
        ]);
    }]);


/***/ }),
/* 457 */
/***/ (function(module, exports) {

angular.module('ikeweb.notes').controller('NotesListitemController', ['$scope', 'events',
    function($scope, EVENTS) {}
]);


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(459);
angular.module('ikeweb.notes').directive('notesListitem', ['$timeout', 'billingService',
    function($timeout, billingService) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: TEMPLATE_URL,
            scope: {
                note: '='
            },
            controller: 'NotesListitemController',
            controllerAs: 'ctrl',
            link: function($scope, $element, attrs, ctrl) {
                var input = $element.find('.NoteListitem-content');

                $scope.focus = function() {
                    $timeout(function() {
                        input[0].focus();
                    });
                };

                $scope.canMakeNote = false;
                billingService.isOnPremium().then(function(isPro) {
                    $scope.canMakeNote = isPro;
                });
            }
        };
    }
]);


/***/ }),
/* 459 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<li class=\"NotesListitem MeasurementsDetail-measurementValue\" ng-class=\"activeIfSelected()\" ng-click=\"selectMe()\">\n<div class=\"ProBadgeContainer\">\n<div ng-show=\"!canMakeNote\" class=\"material-icons pro-lock pro-lock-small pro-lock-overlay\">lock_outline</div>\n<a title=\"{{ 'COMPONENT.NOTES_LISTITEM.CLICK_TO_EDIT' | translate }}\">\n<textarea class=\"NoteListitem-content\" placeholder=\"{{ (canMakeNote ? 'COMPONENT.NOTES_LISTITEM.ENTER_NOTES_HERE' : 'COMPONENT.NOTES_LISTITEM.GET_SPIKE_PRO_FOR_NOTES') | translate }}\" ng-model=\"note\" ng-readonly=\"!canMakeNote\" maxlength=\"1000\"></textarea>\n</a>\n<div ng-show=\"!canMakeNote\" class=\"ProBadge ProBadge--TopRight\">pro</div>\n</div>\n</li>";
var id1="notes.listitem.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(461);

angular.module('ikeweb.layout').directive('headerNav',
    function() {
        return {
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            replace: true,
            controller: 'PageHeaderController',
            controllerAs: 'ctrl',
            link: function($scope) {
                $scope.showAccountDropdown = false;

                $scope.toggleDropdown = function($evt) {
                    $evt.stopPropagation();
                    $scope.showAccountDropdown = !$scope.showAccountDropdown;

                    if ($scope.showAccountDropdown) {
                        $('body').on('click.dropdown', function() {
                            $scope.$apply(function() {
                                $scope.showAccountDropdown = false;
                                $('body').off('click.dropdown');
                            });
                        });
                    }
                };
            }
        };
    }
);


/***/ }),
/* 461 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div ng-show=\"showHeader()\" class=\"HeaderNav-wrapper\">\n<nav role=\"navigation\" class=\"HeaderNav {{ getPathHeaderClass() }}\">\n<div class=\"HeaderNav-logoWrapper\">\n<a class=\"HeaderNav-logo\" href=\"#/\"></a>\n</div>\n<ul class=\"HeaderNav-navList\" ng-if=\"showNav\">\n<li class=\"HeaderNav-navListItem\" ng-class=\"{'HeaderNav-navListItem-active': isMeasurementLocation()}\">\n<a class=\"HeaderNav-navListItemLink\" href=\"#/gallery\">{{ 'COMPONENT.HEADER_NAV.GALLERY' | translate }}</a>\n</li>\n<li class=\"HeaderNav-navListItem\" ng-class=\"{'HeaderNav-navListItem-active': location == '/map'}\">\n<a class=\"HeaderNav-navListItemLink\" href=\"#/map\">{{ 'COMPONENT.HEADER_NAV.MAP' | translate }}</a>\n</li>\n</ul>\n<div class=\"HeaderNav-accountPanel\" ng-show=\"showNav\">\n<ul class=\"HeaderNav-accountList\">\n<li class=\"EolNotice-container\">\n<eol-notice class=\"EolNotice\"></eol-notice>\n</li>\n<li class=\"HeaderNav-accountDropdownToggle\" ng-click=\"toggleDropdown($event)\">\n<a class=\"HeaderNav-accountName\">{{username}}</a>\n<span class=\"HeaderNav-accountDropdownIcon\"/>\n<span class=\"ProBadge ProBadge--TopNav\" ng-if=\"showNav\" ng-show=\"isPro()\">PRO</span>\n<ul class=\"HeaderNav-accountDropdownList ng-hide\" ng-show=\"showAccountDropdown\">\n<li class=\"HeaderNav-accountDropdownListItem\">\n<a id=\"change-password\" ng-click=\"$broadcast('DISPLAY_CHANGE_PASSWORD')\" class=\"HeaderNav-accountDropdownListItemLink\">\n{{ 'COMPONENT.HEADER_NAV.CHANGE_PASSWORD' | translate }}\n</a>\n</li>\n<li class=\"HeaderNav-accountDropdownListItem\">\n<a id=\"change-preferences\" ng-click=\"$broadcast('DISPLAY_USER_PREFERENCES')\" class=\"HeaderNav-accountDropdownListItemLink\">\n{{ 'COMPONENT.HEADER_NAV.PREFERENCES' | translate }}\n</a>\n</li>\n<li class=\"HeaderNav-accountDropdownListItem\">\n<a id=\"change-locale\" ng-click=\"$broadcast('DISPLAY_USER_LANGUAGE')\" class=\"HeaderNav-accountDropdownListItemLink\">\n{{ 'COMPONENT.HEADER_NAV.LANGUAGE' | translate }}\n<i class=\"HeaderNav-accountDropdownListItemLanguageIcon\"></i>\n</a>\n</li>\n<li class=\"HeaderNav-accountDropdownListItem\">\n<a id=\"billing-status\" href=\"#/billing\" class=\"HeaderNav-accountDropdownListItemLink\">\n{{ 'COMPONENT.HEADER_NAV.BILLING' | translate }}\n</a>\n</li>\n<li class=\"HeaderNav-accountDropdownListItem\">\n<a id=\"logout\" ng-click=\"logout()\" class=\"HeaderNav-accountDropdownListItemLink\">\n{{ 'COMPONENT.HEADER_NAV.LOG_OUT' | translate }}\n</a>\n</li>\n</ul>\n</li>\n</ul>\n</div>\n<locale-chooser-small class=\"HeaderNav-localeChooser\" ng-hide=\"showNav\"></locale-chooser-small>\n</nav>\n<change-password display-event=\"DISPLAY_CHANGE_PASSWORD\" dismiss-event=\"DISMISS_CHANGE_PASSWORD\"></change-password>\n<user-preferences display-event=\"DISPLAY_USER_PREFERENCES\" dismiss-event=\"DISMISS_USER_PREFERENCES\"></user-preferences>\n<locale-chooser display-event=\"DISPLAY_USER_LANGUAGE\" dismiss-event=\"DISMISS_USER_LANGUAGE\"></locale-chooser>\n</div>\n";
var id1="header-nav.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 462 */
/***/ (function(module, exports) {

angular.module('ikeweb.layout').controller('PageHeaderController', ['$scope', '$rootScope', 'loginService', '$location', 'billingService',
    function($scope, $rootScope, $loginService, $location, billingService) {

        var pathsWithoutHeader = [
            '/login',
            '/signup',
            '/forgotPassword',
            '/choose_password',
            '/invalid_link',
            '/password_reset_success',
            '/error/.*'
        ];

        var isPro = false;

        function pathRequiresHeader(path) {
            return !pathsWithoutHeader.reduce(function(result, pathWithoutHeader) {
                return result || new RegExp(pathWithoutHeader).test(path);
            }, false);
        }

        $scope.showHeader = function() {
            return pathRequiresHeader($location.path());
        };

        function update() {
            var user = $loginService.getLoggedInUser();
            if (user) {
                $scope.username = user.getUsername();
                $scope.showNav = true;
                billingService.isOnPremium().then(function(isPremium) {
                    isPro = isPremium;
                });
            } else {
                $scope.showNav = false;
            }

            $scope.location = $location.path();
        };

        $scope.isPro = function() {
            return isPro;
        };

        $scope.isMeasurementLocation = function() {
            return $location.path().indexOf('gallery') > -1;
        };

        $scope.getPathHeaderClass = function() {
            var location = $location.path();
            return 'HeaderNav-route-' + location.replace(/^\/([^\/]*).*$/, '$1');
        };

        $scope.logout = function() {
            $loginService.logout();
        };

        $rootScope.$on('$locationChangeSuccess', update);
        update();
    }
]);


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(464);

angular.module('ikeweb.layout').directive('footerNav', function() {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: TEMPLATE_URL,
        link: function($scope) {
            $scope.applicationVersion = __webpack_require__(81).package.version;
            $scope.copyrightDate = 2026;
        }
    };
});


/***/ }),
/* 464 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<footer class=\"FooterNav\">\n<nav>\n<ul>\n<li>\n{{ 'COMPONENT.FOOTER_NAV.COPYRIGHT' | translate:{ copyrightDate: copyrightDate } }}\n</li>\n<li>\n{{ 'COMPONENT.FOOTER_NAV.ALL_RIGHTS_RESERVED' | translate }}\n</li>\n<li>\n<a href=\"https://spike.ikegps.com/last-time-buy-tc/\" target=\"_blank\">{{ 'COMPONENT.FOOTER_NAV.TERMS_CONDITIONS' | translate }}</a>\n</li>\n<li>\n<a href=\"https://www.ikegps.com/privacy-policy/\" target=\"_blank\">{{ 'COMPONENT.FOOTER_NAV.PRIVACY' | translate }}</a>\n</li>\n<li>\nVersion: {{ applicationVersion }}\n</li>\n</ul>\n</nav>\n<div class=\"FooterNav-logo\"></div>\n</footer>\n";
var id1="footer.nav.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(466);
angular.module('ikeweb.layout').directive('ikeSidebar',
    function() {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: TEMPLATE_URL,
            scope: {
                sidebarTitle: '@'
            }
        };
    }
);


/***/ }),
/* 466 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"IkeSidebar\">\n<div class=\"IkeSidebar-titleBlock\">\n<h3 class=\"IkeSidebar-titleText\">{{ sidebarTitle }}</h3>\n</div>\n<div class=\"IkeSidebar-content\" ng-transclude></div>\n</div>";
var id1="ike.sidebar.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(468);
angular.module('ikeweb.layout').directive('ikeToolbar',
    function() {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: TEMPLATE_URL
        };
    }
);


/***/ }),
/* 468 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"IkeToolbar\" ng-transclude>\n</div>";
var id1="ike.toolbar.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var angular = __webpack_require__(25);
angular.module('ikeweb.user').controller('LoginController', ['$scope', '$location', 'loginService',
    function login($scope, $location, loginService) {

        if (loginService.getLoggedInUser()) {
            $location.path('gallery');
        }

        $scope.user = {};
        var loginInProgress,
            error;

        function login() {
            $scope.user.username = $scope.user.username.toLowerCase();
            loginInProgress = true;
            error = false;

            return loginService.login($scope.user)
                .then(function() {
                    loginInProgress = false;
                    $location.path('gallery');
                }, function() {
                    loginInProgress = false;
                    error = true;
                });
        }

        this.hasError = function() {
            return error;
        };

        this.inProgress = function() {
            return loginInProgress;
        };

        this.login = login;
        this.loggedIn = loginService.isLoggedIn;
    }
]);


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var Parse = __webpack_require__(82).Parse;
angular.module('ikeweb.user').factory('loginService', ['loginTopics', 'pubSubService',

    function login(loginTopics, pubSubService) {

        var User = Parse.User.extend({
            getUnit: function() {
                return this.get('unit');
            },
            setUnit: function(unit) {
                this.set('unit', unit);
                return this;
            },
            getLocale: function() {
                return this.get('locale');
            },
            setLocale: function(locale) {
                this.set('locale', locale);
                return this;
            }
        });

        function login(userObj) {
            var username = userObj.username;
            var password = userObj.password;
            return User.logIn(username, password)
                .then(function(user) {
                    pubSubService.publish(loginTopics.LOGIN.COMPLETED.SUCCESS);
                    return user;
                });
        }

        function logout() {
            User.logOut();
            window.location = '/';
        }

        function getLoggedInUser() {
            return User.current();
        }

        function getLoggedInUserName() {
            return User.current() ? User.current().get('username') : undefined;
        }

        function isLoggedIn() {
            return !!getLoggedInUser();
        }

        function save(user) {
            return user.save();
        }

        function requestPasswordReset(email) {
            return User.requestPasswordReset(email);
        }

        function changePassword(currentPassword, newPassword) {
            var currentUser = User.current();
            var username = currentUser.get('username');
            currentUser.set('password', currentPassword);

            return currentUser.logIn()
                .then(function(user) {
                    user.setPassword(newPassword);
                    return user.save();
                })
                .then(User.logOut)
                .then(function() {
                    return User.logIn(username, newPassword);
                });
        }

        return {
            login: login,
            logout: logout,
            getLoggedInUser: getLoggedInUser,
            isLoggedIn: isLoggedIn,
            save: save,
            requestPasswordReset: requestPasswordReset,
            changePassword: changePassword,
            getLoggedInUserName: getLoggedInUserName
        };
    }
]).config(['$provide',
    function($provide) {

        var functionsToDecorate = [
            'login',
            'changePassword',
            'requestPasswordReset',
            'save'
        ];

        $provide.decorator('loginService', ['$delegate', 'qPromiseDecoratorService',
            function($delegate, qPromiseDecoratorService) {
                return qPromiseDecoratorService.decorateDelegateWithPromise($delegate, functionsToDecorate);
            }
        ]);

        $provide.decorator('loginService', ['$delegate', 'parseErrorDecoratorService',
            function($delegate, parseErrorDecoratorService) {
                return parseErrorDecoratorService.decorateDelegatePromiseErrors($delegate, functionsToDecorate, {
                    101: 'USER_NOT_FOUND'
                });
            }
        ]);

        $provide.decorator('loginService', ['$delegate', 'promiseProgressDecoratorService',
            function($delegate, promiseProgressDecoratorService) {
                return promiseProgressDecoratorService.decorateDelegateWithProgress($delegate, functionsToDecorate);
            }
        ]);

        $provide.decorator('loginService', ['$delegate', 'decoratedPromiseBuilder', 'notificationService',
            function($delegate, decoratedPromiseBuilder, notificationService) {

                return decoratedPromiseBuilder
                    .forDelegate($delegate)
                    .decorate('changePassword')
                    .onSuccess(notificationService.success('NOTIFICATION.LOGIN.CHANGE_PASSWORD', 'NOTIFICATION.LOGIN.PASSWORD_CHANGED'))
                    .onError(notificationService.error('NOTIFICATION.LOGIN.CHANGE_PASSWORD', 'NOTIFICATION.LOGIN.CHANGE_PASSWORD_PROBLEM'))
                    .decorate('requestPasswordReset')
                    .onSuccess(notificationService.success('NOTIFICATION.LOGIN.FORGOT_PASSWORD', 'NOTIFICATION.LOGIN.FORGOT_PASSWORD_EMAIL_SENT'))
                    .fork();
            }
        ]);

        $provide.decorator('loginService', ['$delegate', 'loggingDecorator',
            function($delegate, loggingDecorator) {
                return loggingDecorator.decorateDelegateWithLogging($delegate, functionsToDecorate);
            }
        ]);
    }
]);


/***/ }),
/* 471 */
/***/ (function(module, exports) {

angular.module('ikeweb.user').factory('loginTopics',

    function() {

        return {
            LOGIN: {
                COMPLETED: {
                    SUCCESS: {
                        name: 'login.completed.success'
                    }
                }
            }
        };
    });


/***/ }),
/* 472 */
/***/ (function(module, exports) {

angular.module('ikeweb.user').controller('SignUpController', ['$scope', '$location', '$stateParams', 'signupService', 'loginService',

    function signup($scope, $location, $stateParams, signupService, loginService) {

        if (loginService.getLoggedInUser()) {
            $location.path('gallery');
        }

        var inProgress = false;
        $scope.user = {};

        function signup() {

            $scope.user.email = $scope.user.email.toLowerCase();

            var user = {
                email: $scope.user.email,
                password: $scope.user.password,
                token: $stateParams.token
            };

            inProgress = true;

            return signupService.signup(user)
                .then(function() {
                    $location.path('gallery');
                    inProgress = false;
                }, function() {
                    inProgress = false;
                });
        }

        this.inProgress = function() {
            return inProgress;
        };

        this.signup = signup;
        this.loggedIn = loginService.isLoggedIn;
    }
]);


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var angular = __webpack_require__(25),
    Parse = __webpack_require__(82).Parse;

angular.module('ikeweb.user').factory('signupService', ['loginService',

    function(loginService) {

        function signup(userObj) {
            var email = userObj.email.toLowerCase();
            var password = userObj.password;

            return Parse.Cloud.run('signUpUser', {
                    username: email,
                    password: password,
                    token: userObj.token
                })
                .then(function() {
                    return loginService.login({
                        username: email,
                        password: password
                    });
                });
        }

        return {
            signup: signup
        };
    }

]).config(['$provide',
    function($provide) {

        var functionsToDecorate = [
            'signup'
        ];

        $provide.decorator('signupService', ['$delegate', 'qPromiseDecoratorService',
            function($delegate, qPromiseDecoratorService) {
                return qPromiseDecoratorService.decorateDelegateWithPromise($delegate, functionsToDecorate);
            }
        ]);

        $provide.decorator('signupService', ['$delegate', 'parseErrorDecoratorService',
            function($delegate, parseErrorDecoratorService) {
                return parseErrorDecoratorService.decorateDelegatePromiseErrors($delegate, functionsToDecorate);
            }
        ]);

        $provide.decorator('signupService', ['$delegate', 'promiseProgressDecoratorService',
            function($delegate, promiseProgressDecoratorService) {
                return promiseProgressDecoratorService.decorateDelegateWithProgress($delegate, functionsToDecorate);
            }
        ]);

        $provide.decorator('signupService', ['$delegate', 'loggingDecorator',
            function($delegate, loggingDecorator) {
                return loggingDecorator.decorateDelegateWithLogging($delegate, functionsToDecorate);
            }
        ]);

        $provide.decorator('signupService', ['$delegate', 'decoratedPromiseBuilder', 'notificationService', 'cloudCodeErrors',
            function($delegate, decoratedPromiseBuilder, notificationService, CLOUD_ERRORS) {

                function errorIs(code) {
                    return function(error) {
                        return code === error.message;
                    };
                }

                return decoratedPromiseBuilder
                    .forDelegate($delegate)
                    .decorate('signup')
                    .onSuccess(notificationService.success('NOTIFICATION.SIGNUP.SIGN_UP', 'NOTIFICATION.SIGNUP.SIGNED_UP'))
                    .onErrorIf(errorIs(CLOUD_ERRORS.USER_EXISTS), notificationService.error('NOTIFICATION.SIGNUP.SIGN_UP', 'NOTIFICATION.SIGNUP.EMAIL_ALREADY_TAKEN'))
                    .onErrorIf(errorIs(CLOUD_ERRORS.INVALID_SIGNUP_TOKEN), notificationService.error('NOTIFICATION.SIGNUP.SIGN_UP', 'NOTIFICATION.SIGNUP.INVALID_LINK'))
                    .onError(notificationService.error('NOTIFICATION.SIGNUP.SIGN_UP', 'NOTIFICATION.SIGNUP.SIGN_UP_PROBLEM'))
                    .fork();
            }
        ]);
    }
]);


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(475);
angular.module('ikeweb.user').controller('ChangePasswordController', ['$scope', 'loginService',
    function($scope, loginService) {

        $scope.password = {};

        var loading = false;

        function isLoading() {
            return loading;
        }

        function done() {
            loading = false;
        }

        function updatePassword() {

            loading = true;
            loginService.changePassword($scope.password.current, $scope.password.new)
                .then(function() {
                    done();
                    $scope.$broadcast($scope.dismissEvent);
                }, done);
        }

        function reset() {
            $scope.password = {};
        }

        this.update = updatePassword;
        this.isLoading = isLoading;
        this.reset = reset;
    }
]);

angular.module('ikeweb.user').directive('changePassword', [

    function() {

        return {
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            replace: true,
            scope: {
                displayEvent: '@',
                dismissEvent: '@'
            },
            link: function($scope, $element, attrs, ctrl) {
                $scope.$on($scope.displayEvent, ctrl.reset);
            },
            controller: 'ChangePasswordController',
            controllerAs: 'ctrl'
        };
    }
]);


/***/ }),
/* 475 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"ChangePassword\">\n<ike-form submit=\"ctrl.update()\" reset-event=\"{{ displayEvent }}\">\n<ike-modal title-text=\"{{ 'COMPONENT.CHANGE_PASSWORD.CHANGE_YOUR_PASSWORD' | translate }}\" display-event=\"{{ displayEvent }}\" dismiss-event=\"{{ dismissEvent }}\">\n<ike-modal-content>\n<div class=\"ChangePassword-content\">\n<div class=\"ChangePassword-form\">\n<div class=\"ChangePassword-fieldset\">\n<label for=\"currentPassword\">{{ 'COMPONENT.CHANGE_PASSWORD.CURRENT_PASSWORD' | translate }}</label>\n<ike-input-text class=\"ChangePassword-textbox\" name=\"currentPassword\" ng-model=\"password.current\" type=\"password\" required>\n</ike-input-text>\n</div>\n<ike-input-validation for=\"currentPassword\" when=\"required\" message=\"{{ 'COMPONENT.CHANGE_PASSWORD.CHANGE_PASSWORD_REQUIRED' | translate }}\"></ike-input-validation>\n<div class=\"ChangePassword-fieldset\">\n<label for=\"newPassword\">{{ 'COMPONENT.CHANGE_PASSWORD.NEW_PASSWORD' | translate }}</label>\n<ike-input-text class=\"ChangePassword-textbox\" name=\"newPassword\" ng-model=\"password.new\" type=\"password\" required>\n</ike-input-text>\n</div>\n<ike-input-validation for=\"newPassword\" when=\"required\" message=\"{{ 'COMPONENT.CHANGE_PASSWORD.NEW_PASSWORD_REQUIRED' | translate }}\"></ike-input-validation>\n<div class=\"ChangePassword-fieldset\">\n<label for=\"confirmPassword\">{{ 'COMPONENT.CHANGE_PASSWORD.CONFIRM_PASSWORD' | translate }}</label>\n<ike-input-text class=\"ChangePassword-textbox\" name=\"confirmPassword\" ng-model=\"password.confirm\" type=\"password\" required ike-match=\"password.new\">\n</ike-input-text>\n</div>\n<ike-input-validation for=\"confirmPassword\" when=\"required\" message=\"{{ 'COMPONENT.CHANGE_PASSWORD.CONFIRM_PASSWORD_REQUIRED' | translate }}\"></ike-input-validation>\n<ike-input-validation for=\"confirmPassword\" when=\"match\" message=\"{{ 'COMPONENT.CHANGE_PASSWORD.CONFIRM_PASSWORD_MATCH' | translate }}\"></ike-input-validation>\n</div>\n</div>\n</ike-modal-content>\n<ike-modal-footer>\n<div class=\"ChangePassword-buttons\">\n<ike-button type=\"submit\" ng-disabled=\"ctrl.isLoading()\" class=\"ChangePassword-buttons-change\">\n{{ctrl.isLoading() ? 'COMPONENT.CHANGE_PASSWORD.CHANGING_PASSWORD' : 'COMPONENT.CHANGE_PASSWORD.CHANGE_PASSWORD' | translate}}\n</ike-button>\n<ike-button type=\"button\" class=\"ChangePassword-buttons-cancel\" ng-click=\"$emit(dismissEvent)\">{{ 'COMPONENT.CHANGE_PASSWORD.CONFIRM_PASSWORD_CANCEL' | translate }}</ike-button>\n</div>\n</ike-modal-footer>\n</ike-modal>\n</ike-form>\n</div>";
var id1="change.password.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 476 */
/***/ (function(module, exports) {

angular.module('ikeweb.user').controller('ForgotPasswordController', ['$scope', 'loginService',
    function($scope, loginService) {

        $scope.user = {};
        $scope.sending = false;

        $scope.requestPasswordReset = function() {

            $scope.sending = true;
            loginService.requestPasswordReset($scope.user.email)
                .finally(function() {
                    $scope.sending = false;
                });
        };
    }
]);


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var config = __webpack_require__(81);
angular.module('ikeweb.user').controller('ChoosePasswordController', ['$scope', '$stateParams',
    function($scope, $stateParams) {
        $scope.formAction = config.parse.path + '/apps/' + config.parse.appid + '/request_password_reset';
        $scope.error = $stateParams.error;
        $scope.username = $stateParams.username;
        $scope.token = $stateParams.token;
    }
]);


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(479);
var angular = __webpack_require__(25);
angular.module('ikeweb.user').controller('PreferencesController', ['$scope', 'unitService', 'pubSubService', 'userTopics',

    function($scope, unitService, pubSubService, userTopics) {

        function success() {
            $scope.loading = false;
            pubSubService.publish(userTopics.PREFERENCES.UPDATED);
            $scope.$broadcast($scope.dismissEvent);
        }

        function error() {
            $scope.loading = false;
        }

        $scope.update = function() {
            if ($scope.formHolder.userPreferencesForm.$valid) {
                $scope.loading = true;
                unitService.setUnit($scope.formData.unit).then(success, error);
            }
        };
    }
]);

angular.module('ikeweb.user').directive('userPreferences', ['unitService',
    function(unitService) {

        return {
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            replace: true,
            scope: {
                displayEvent: '@',
                dismissEvent: '@'
            },
            link: function($scope, $element) {

                $scope.formHolder = {};
                $scope.formData = {};
                $scope.notifications = {};
                $scope.loading = false;
                $scope.units = unitService.getUnitList();

                function setUserUnit() {
                    $scope.units = unitService.getUnitList();
                    $scope.formData.unit = unitService.getUnit();
                }
                $scope.formData.unit = unitService.getUnit();

                $scope.$on($scope.displayEvent, setUserUnit);

                $scope.submit = function() {
                    setTimeout(function() {
                        $element.find('.UserPreferences-formSubmit').click();
                    });
                };

            },
            controller: 'PreferencesController'
        };
    }
]);


/***/ }),
/* 479 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"UserPreferences\">\n<ike-modal title-text=\"{{ 'COMPONENT.PREFERENCES.CHANGE_PREFERENCES' | translate }}\" display-event=\"{{displayEvent}}\" dismiss-event=\"{{dismissEvent}}\">\n<ike-modal-content>\n<div class=\"UserPreferences-content\">\n<form novalidate class=\"UserPreferences-form\" id=\"userPreferencesForm\" name=\"formHolder.userPreferencesForm\" ng-submit=\"update()\">\n<div class=\"UserPreferences-fieldset\">\n<label for=\"UserPreferences-unit\">{{ 'COMPONENT.PREFERENCES.CURRENT_UNITS' | translate }}</label>\n<ike-input-select class=\"UserPreferences-fieldsetSelect\" id=\"UserPreferences-unit\" ng-model=\"formData.unit\" options=\"units\" placeholder=\"{{ 'COMPONENT.PREFERENCES.CHOOSE_UNIT' | translate }}\">\n</ike-input-select>\n</div>\n<button type=\"submit\" class=\"UserPreferences-formSubmit\" style=\"display:none;\"></button>\n</form>\n</div>\n</ike-modal-content>\n<ike-modal-footer class=\"UserPreferences-buttons\">\n<ike-button ng-click=\"submit()\" ng-disabled=\"loading\" class=\"UserPreferences-submitButton\">{{loading ? 'COMPONENT.PREFERENCES.UPDATING_PREFERENCES' : 'COMPONENT.PREFERENCES.UPDATE_PREFERENCES' | translate}}</ike-button>\n<ike-button class=\"UserPreferences-cancelButton\" ng-click=\"$emit(dismissEvent)\">{{ 'COMPONENT.PREFERENCES.CANCEL' | translate }}</ike-button>\n</ike-modal-footer>\n</ike-modal>\n</div>\n";
var id1="preferences.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 480 */
/***/ (function(module, exports) {

angular.module('ikeweb.locale', ['ikeweb.shared.input', 'ikeweb.user', 'ikeweb.shared.messaging', 'ikeweb.shared.i18n', 'LocalStorageModule']);


/***/ }),
/* 481 */
/***/ (function(module, exports) {

angular.module('ikeweb.locale').factory('localeTopics',

    function() {

        return {
            LOCALE: {
                CHANGED: {
                    name: 'locale.changed'
                }
            }
        };
    });


/***/ }),
/* 482 */
/***/ (function(module, exports) {

angular.module('ikeweb.locale').factory('localeService', [
    'functional',
    'localStorageService',
    'loginService',
    'pubSubService',
    'localeTopics',
    'loginTopics',
    'localeConstants',
    'translationService',
    'promiseFactory',
    function(f,
        localStorageService,
        loginService,
        pubSubService,
        localeTopics,
        loginTopics,
        LOCALES,
        translationService,
        promiseFactory) {

        var LOCALE_LOCAL_STORAGE_KEY = 'locale.current';
        var DEFAULT_LOCALE = 'en-US';

        function getAvailableLocales() {
            return LOCALES;
        }

        function gerUserLocale() {
            var user = loginService.getLoggedInUser();
            return user && user.getLocale();
        }

        function setUserLocale(locale) {
            var user = loginService.getLoggedInUser();
            return user ?
                loginService.save(user.setLocale(locale)) :
                promiseFactory.resolvedPromise();
        }

        function gerLocaleStorageLocale() {
            return localStorageService.get(LOCALE_LOCAL_STORAGE_KEY);
        }

        function setLocaleStorageLocale(locale) {
            localStorageService.set(LOCALE_LOCAL_STORAGE_KEY, locale);
        }

        var containsRight = f.curryRight(f.contains);

        var lessSpecific = f.comparator(function(locale, otherLocale) {
            return locale.value.length < otherLocale.value.length;
        });

        function getLanguageFromLocale(locale) {
            return locale.split('-')[0];
        }

        function findLocale(locales, locale) {
            return locale && f.find(locales, f.propIs('value', f.equal(locale)));
        }

        function findFallbackLocale(locales, locale) {
            return locale && f.find(f.sort(locales, lessSpecific), f.propIs('value', containsRight(getLanguageFromLocale(locale))));
        }

        function getCurrentLocale() {
            var locales = getAvailableLocales();
            var locale = gerUserLocale() || gerLocaleStorageLocale();

            return findLocale(locales, locale) ||
                findFallbackLocale(locales, locale) ||
                findLocale(locales, DEFAULT_LOCALE);
        }

        function publishLocaleChange() {
            pubSubService.publish(localeTopics.LOCALE.CHANGED);
        }

        function translate() {
            return translationService.translate(getCurrentLocale().value);
        }

        function setCurrentLocale(locale) {
            return setUserLocale(locale)
                .then(setLocaleStorageLocale.bind(null, locale))
                .then(translate)
                .then(publishLocaleChange);
        }

        pubSubService.subscribe(loginTopics.LOGIN.COMPLETED.SUCCESS, translate);

        return {
            getAvailableLocales: getAvailableLocales,
            getCurrentLocale: getCurrentLocale,
            setCurrentLocale: setCurrentLocale
        };
    }
]);


/***/ }),
/* 483 */
/***/ (function(module, exports) {

angular.module('ikeweb.locale').constant('localeConstants', [{
    value: 'da-DK',
    label: 'Dansk'
}, {
    value: 'de-DE',
    label: '‪Deutsch‬'
}, {
    value: 'el-GR',
    label: 'Ελληνικά'
}, {
    value: 'en-US',
    label: 'English'
}, {
    value: 'es-ES',
    label: '‪Español'
}, {
    value: 'fi-FI',
    label: 'Suomi‬'
}, {
    value: 'fr-FR',
    label: 'Français'
}, {
    value: 'it-IT',
    label: '‪Italiano‬'
}, {
    value: 'nl-NL',
    label: 'Nederlands'
}, {
    value: 'nb-NO',
    label: '‪norsk‬'
}, {
    value: 'pl-PL',
    label: '‪polski'
}, {
    value: 'pt-PT',
    label: '‪português'
}, {
    value: 'ru-RU',
    label: '‪Русский‬'
}, {
    value: 'sv-SE',
    label: 'Svenska'
}, {
    value: 'tr-TR',
    label: '‪Türkçe‬'
}]);


/***/ }),
/* 484 */
/***/ (function(module, exports) {

angular.module('ikeweb.locale').controller('LocaleChooserController', ['$scope', 'localeService',

    function($scope, localeService) {

        function getCurrentLocaleValue() {
            return localeService.getCurrentLocale().value;
        }

        function isCurrent(locale) {
            return getCurrentLocaleValue() === locale;
        }

        this.getAvailableLocales = localeService.getAvailableLocales;
        this.getCurrentLocale = getCurrentLocaleValue;
        this.setCurrentLocale = localeService.setCurrentLocale;
        this.isCurrent = isCurrent;
    }
]);


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(486);
angular.module('ikeweb.locale').directive('localeChooser', [

    function() {
        return {
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            replace: true,
            scope: {
                displayEvent: '@',
                dismissEvent: '@'
            },
            controller: 'LocaleChooserController',
            controllerAs: 'ctrl',
            link: function($scope, $element, attrs, ctrl) {
                $scope.selected = {};
                $scope.$watch(ctrl.getCurrentLocale, function(locale) {
                    $scope.selected.locale = locale;
                });
            }
        };
    }
]);


/***/ }),
/* 486 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"UserLocaleChooser\">\n<ike-form submit=\"ctrl.setCurrentLocale(selected.locale)\">\n<ike-modal title-text=\"{{ 'COMPONENT.LOCALE_CHOOSER.CHANGE_LANGUAGE' | translate }}\" display-event=\"{{displayEvent}}\" dismiss-event=\"{{dismissEvent}}\">\n<ike-modal-content>\n<div class=\"UserLocaleChooser-fieldset\">\n<label class=\"UserLocaleChooser-fieldsetLabel\">{{ 'COMPONENT.LOCALE_CHOOSER.SELECT_LANGUAGE' | translate }}</label>\n<ike-input-select class=\"UserLocaleChooser-fieldsetSelect\" id=\"LocaleChooser\" ng-model=\"selected.locale\" options=\"ctrl.getAvailableLocales()\" placeholder=\"{{ 'COMPONENT.LOCALE_CHOOSER.CHOOSE_LANGUAGE' | translate }}\">\n</ike-input-select>\n</div>\n</ike-modal-content>\n<ike-modal-footer>\n<ike-button type=\"submit\" class=\"UserLocaleChooser-submitButton\" ng-click=\"$emit(dismissEvent)\">{{ 'COMPONENT.LOCALE_CHOOSER.UPDATE' | translate }}</ike-button>\n<ike-button type=\"button\" class=\"UserLocaleChooser-cancelButton\" ng-click=\"$emit(dismissEvent)\">{{ 'COMPONENT.LOCALE_CHOOSER.CANCEL' | translate }}</ike-button>\n</ike-modal-footer>\n</ike-modal>\n</ike-form>\n</div>\n";
var id1="chooser.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(488);

angular.module('ikeweb.user').directive('creditCardView', [

    function() {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: TEMPLATE_URL,
            scope: {
                card: '=card',
                showUpdate: '=',
                openUpdate: '&',
                toggle: '='
            }
        };
    }
]);


/***/ }),
/* 488 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"CreditCardView\">\n<div class=\"CreditCardView-details\" ng-show=\"card\">\n<table class=\"CreditCardView-detailsTable\">\n<tr>\n<th>{{ 'COMPONENT.CREDIT_CARD_VIEW.CARD_TYPE' | translate }}</th>\n<td>{{card.brand}}</td>\n</tr>\n<tr>\n<th>{{ 'COMPONENT.CREDIT_CARD_VIEW.CARD_NUMBER' | translate }}</th>\n<td>XXXX XXXX XXXX {{card.last4}}</td>\n</tr>\n<tr>\n<th>{{ 'COMPONENT.CREDIT_CARD_VIEW.EXPIRY' | translate }}</th>\n<td>{{card.exp_month}}/{{card.exp_year}}</td>\n</tr>\n</table>\n</div>\n<div ng-show=\"showUpdate\" class=\"CreditCardView-actionsContainer\">\n<ike-button ng-click=\"toggle()\">{{ 'COMPONENT.CREDIT_CARD_VIEW.CLOSE' | translate }}</ike-button>\n<ike-button class=\"CreditCardView-updateButton\" ng-click=\"openUpdate()\">{{ 'COMPONENT.CREDIT_CARD_VIEW.UPDATE' | translate }}</ike-button>\n</div>\n</div>\n";
var id1="credit.card.view.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 489 */
/***/ (function(module, exports) {

angular.module('ikeweb.user').controller('CreditCardUpdateController', ['creditCardService', 'billingService', 'pubSubService', 'userTopics',
    function(creditCardService, billingService, pubSubService, userTopics) {

        var card;

        var setLoading = function(loading) {
            return this.setLoading(loading);
        }.bind(this);

        var fireDismissEvent = function() {
            return this.fireDismissEvent();
        }.bind(this);

        function setCard(value) {
            card = value;
        }

        function resetCard() {
            Object.keys(card).forEach(function(key) {
                card[key] = '';
            });
        }

        function updateComplete() {
            resetCard();
            setLoading(false);
            fireDismissEvent();
        }

        function updateCard() {
            this.setLoading(true);

            creditCardService
                .loadCard(card)
                .then(billingService.updateCreditCard)
                .then(function() {
                    pubSubService.publish(userTopics.CREDITCARD.UPDATED);
                })
                .then(updateComplete, updateComplete);
        }

        this.setCard = setCard;
        this.updateCard = updateCard;
        this.resetCard = resetCard;
    }
]);


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(491);

angular.module('ikeweb.user').directive('updateCard',
    function() {

        return {
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            replace: true,
            scope: {
                displayEvent: '@',
                dismissEvent: '@'
            },
            controller: 'CreditCardUpdateController',
            controllerAs: 'ctrl',
            link: function($scope, $element, attrs, ctrl) {

                $scope.card = {};
                $scope.loading = false;
                $scope.$on($scope.displayEvent, ctrl.resetCard);

                ctrl.setCard($scope.card);

                ctrl.setLoading = function(loading) {
                    $scope.loading = loading;
                };

                ctrl.fireDismissEvent = function() {
                    $scope.$broadcast($scope.dismissEvent);
                };
            }
        };
    }
);


/***/ }),
/* 491 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"UpdateCard\">\n<ike-form name=\"updateCreditCardForm\" submit=\"ctrl.updateCard()\">\n<ike-modal title-text=\"{{ 'COMPONENT.CREDIT_CARD_UPDATE.UPDATE_CREDIT_CARD' | translate }}\" display-event=\"{{displayEvent}}\" dismiss-event=\"{{dismissEvent}}\">\n<ike-modal-content>\n<div class=\"UpdateCard-content\">\n<div class=\"UpdateCard-cardform\">\n<credit-card-form></credit-card-form>\n</div>\n</div>\n</ike-modal-content>\n<ike-modal-footer>\n<div class=\"UpdateCard-buttons\">\n<ike-button type=\"submit\" ng-disabled=\"loading\" class=\"UpdateCard-buttons-add\">\n{{loading ? 'COMPONENT.CREDIT_CARD_UPDATE.ADDING_YOUR_CARD' : 'COMPONENT.CREDIT_CARD_UPDATE.ADD' | translate}}\n</ike-button>\n<ike-button type=\"button\" ng-disabled=\"loading\" class=\"UpdateCard-buttons-cancel\" ng-click=\"$emit(dismissEvent)\">\n{{ 'COMPONENT.CREDIT_CARD_UPDATE.CANCEL' | translate }}\n</ike-button>\n</div>\n</ike-modal-footer>\n</ike-modal>\n</ike-form>\n</div>\n";
var id1="credit.card.update.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(493);

angular.module('ikeweb.user').directive('creditCardForm',

    function() {

        return {
            restrict: 'E',
            replace: true,
            templateUrl: TEMPLATE_URL,
            controller: 'CreditCardController',
            controllerAs: 'ctrl'
        };
    }
);


/***/ }),
/* 493 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"CreditCardForm\">\n<div class=\"CreditCardForm-fieldset\">\n<label for=\"card-holder-name\">{{ 'COMPONENT.CREDIT_CARD.NAME_ON_CARD' | translate }}</label>\n<ike-input-text class=\"CreditCardForm-textbox\" name=\"card-holder-name\" ng-model=\"card.cardHolderName\" required>\n</ike-input-text>\n</div>\n<ike-input-validation for=\"card-holder-name\" when=\"required\" message=\"{{ 'COMPONENT.CREDIT_CARD.NAME_REQUIRED' | translate }}\"></ike-input-validation>\n<div class=\"CreditCardForm-fieldset\">\n<label for=\"card-number\">{{ 'COMPONENT.CREDIT_CARD.CARD_NUMBER' | translate }}</label>\n<ike-input-text class=\"CreditCardForm-textbox\" name=\"card-number\" ng-model=\"card.cardNumber\" required ike-is-valid=\"ctrl.isValidCardNumber(card.cardNumber)\">\n</ike-input-text>\n</div>\n<ike-input-validation for=\"card-number\" when=\"required\" message=\"{{ 'COMPONENT.CREDIT_CARD.CARD_NUMBER_REQUIRED' | translate }}\"></ike-input-validation>\n<ike-input-validation for=\"card-number\" when=\"isValid\" message=\"{{ 'COMPONENT.CREDIT_CARD.CARD_NUMBER_INVALID' | translate:{ 'pattern': ctrl.getCardNumberPattern(card.cardNumber) } }}\"></ike-input-validation>\n<div class=\"CreditCardForm-fieldset\">\n<label for=\"expiry-month\">{{ 'COMPONENT.CREDIT_CARD.EXPIRATION_DATE' | translate }}</label>\n<ike-input-select name=\"expiry-month\" ng-model=\"card.expiryMonth\" options=\"ctrl.getMonths()\" placeholder=\"{{ 'COMPONENT.CREDIT_CARD.MONTH' | translate }}\" class=\"CreditCardForm-select\" required>\n</ike-input-select>\n<ike-input-select name=\"expiry-year\" ng-model=\"card.expiryYear\" options=\"ctrl.getYears()\" placeholder=\"{{ 'COMPONENT.CREDIT_CARD.YEAR' | translate }}\" class=\"CreditCardForm-select\" required>\n</ike-input-select>\n</div>\n<ike-input-validation for=\"expiry-month\" when=\"required\" message=\"{{ 'COMPONENT.CREDIT_CARD.MONTH_REQUIRED' | translate }}\"></ike-input-validation>\n<ike-input-validation for=\"expiry-year\" when=\"required\" message=\"{{ 'COMPONENT.CREDIT_CARD.YEAR_REQUIRED' | translate }}\"></ike-input-validation>\n<div class=\"CreditCardForm-fieldset\">\n<label for=\"cvv\">{{ 'COMPONENT.CREDIT_CARD.CARD_CVV' | translate }}</label>\n<ike-input-text class=\"CreditCardForm-cvv\" name=\"cvv\" ng-model=\"card.cvv\" required>\n</ike-input-text>\n</div>\n<ike-input-validation for=\"cvv\" when=\"required\" message=\"{{ 'COMPONENT.CREDIT_CARD.CARD_CVV_REQUIRED' | translate }}\"></ike-input-validation>\n<div class=\"CreditCardForm-fieldset\">\n<label for=\"zip\">{{ 'COMPONENT.CREDIT_CARD.ZIP_CODE' | translate }}</label>\n<ike-input-text class=\"CreditCardForm-cvv\" name=\"zip\" ng-model=\"card.zip\" required>\n</ike-input-text>\n</div>\n</div>\n";
var id1="credit.card.form.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 494 */
/***/ (function(module, exports) {

angular.module('ikeweb.user').controller('CreditCardController', ['functional', '$filter', '$locale', 'creditCardService',

    function(f, $filter, $locale, CreditCardService) {

        function pad(s, p) {

            if (p - s.length <= 0) {
                return s;
            }

            return pad('0' + s, p);
        }


        function yearsFromNow() {
            var thisYear = moment().year();
            return function(additionalYears) {
                var year = thisYear + additionalYears + '';
                return {
                    label: year,
                    value: year
                };
            };
        }

        function monthsFromNow() {
            var now = moment();
            return function(additionalMonths) {
                var month = now.months(additionalMonths).toISOString();
                var n = pad(additionalMonths + 1 + '', 2);
                return {
                    label: $filter('date')(month, 'MMM') + ' (' + n + ')',
                    value: n
                };
            };
        }

        var monthsPerLocale = {};

        function getMonths() {
            if (!monthsPerLocale[$locale.id]) {
                monthsPerLocale[$locale.id] = f.range(12).map(monthsFromNow());
            }
            return monthsPerLocale[$locale.id];
        }

        var years = f.range(10).map(yearsFromNow());

        function getYears() {
            return years;
        }

        this.getMonths = getMonths;
        this.getYears = getYears;
        this.isValidCardNumber = CreditCardService.isValidCardNumber;
        this.getCardNumberPattern = CreditCardService.getCardNumberPattern;
    }
]);


/***/ }),
/* 495 */
/***/ (function(module, exports) {

angular.module('ikeweb.user').service('creditCardService', ['promiseFactory',
        function(promiseFactory) {

            var CARD_NUMBER_DELIMITERS = /\s+|-/g;
            var CardNumberType = {
                'Diners Club': {
                    pattern: 'xxxx xxxx xxxx xx',
                    match: /^\d{14}$/
                },
                'American Express': {
                    pattern: 'xxxx xxxxxx xxxxx',
                    match: /^\d{15}$/
                },
                DEFAULT: {
                    pattern: 'xxxx xxxx xxxx xxxx',
                    match: /^\d{16}$/
                }
            };

            function loadCard(card) {
                var deferred = promiseFactory.deferredValue();
                Stripe.card.createToken({
                    name: card.cardHolderName,
                    number: card.cardNumber,
                    cvc: card.cvv,
                    /*eslint-disable camelcase */
                    exp_month: card.expiryMonth,
                    exp_year: card.expiryYear,
                    address_zip: card.zip
                    /*eslint-enable camelcase */
                }, function(errorCode, response) {
                    if (response.error) {
                        deferred.reject(response.error);
                        return;
                    }
                    deferred.resolve(response.id);
                });
                return deferred.promise;
            }

            function getCardNumberType(cardNumber) {
                var cardType = Stripe.card.cardType(cardNumber || '');
                return CardNumberType[cardType] || CardNumberType.DEFAULT;
            }

            function isValidCardNumber(cardNumber) {
                if (cardNumber == null) {
                    return false;
                }

                var numbers = cardNumber.replace(CARD_NUMBER_DELIMITERS, '');
                var match = getCardNumberType(cardNumber).match;
                return match.test(numbers);
            }

            function getCardNumberPattern(cardNumber) {
                return getCardNumberType(cardNumber).pattern;
            }

            return {
                loadCard: loadCard,
                isValidCardNumber: isValidCardNumber,
                getCardNumberPattern: getCardNumberPattern
            };
        }
    ])
    .config(['$provide', function($provide) {

        var functionsToDecorate = [
            'loadCard'
        ];

        $provide.decorator('creditCardService', ['$delegate', 'promiseProgressDecoratorService',
            function($delegate, promiseProgressDecoratorService) {
                return promiseProgressDecoratorService
                    .decorateDelegateWithProgress($delegate, functionsToDecorate);
            }
        ]);

        $provide.decorator('creditCardService', ['$delegate', 'decoratedPromiseBuilder', 'notificationService',
            function($delegate, decoratedPromiseBuilder, notificationService) {

                return decoratedPromiseBuilder
                    .forDelegate($delegate)
                    .decorate('loadCard')
                    .onError(notificationService.error('NOTIFICATION.BILLING.CARD.TITLE', 'NOTIFICATION.BILLING.CARD.LOAD.ERROR'))
                    .fork();
            }
        ]);
    }]);


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(497);

angular.module('ikeweb.user').directive('premiumTile', [

    function() {
        return {
            replace: true,
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            scope: {
                currentCard: '=',
                subscription: '=',
                openPurchasePremiumModal: '&',
                openPurchaseTrialModal: '&',
                cancelSubscription: '=',
                openUpdateCard: '&'
            },
            link: function($scope, $element) {

                var ccView = $element.find('.Subscription-creditCardView');
                var cancelDialog = $element.find('.Subscription-cancelConfirmDialog');

                function closeCreditCardView() {
                    ccView.addClass('Subscription-creditCardView--closed')
                        .removeClass('Subscription-creditCardView--open');
                }

                function closeCancelDialog() {
                    cancelDialog.addClass('Subscription-cancelConfirmDialog--closed')
                        .removeClass('Subscription-cancelConfirmDialog--open');
                }

                $scope.toggleCreditCardView = function() {
                    closeCancelDialog();
                    ccView.toggleClass('Subscription-creditCardView--closed')
                        .toggleClass('Subscription-creditCardView--open');
                };

                $scope.openCancelDialog = function() {
                    closeCreditCardView();
                    cancelDialog.addClass('Subscription-cancelConfirmDialog--open')
                        .removeClass('Subscription-cancelConfirmDialog--closed');
                };

                $scope.closeCancelDialog = closeCancelDialog;
            },
            controller: 'PremiumTileController'
        };
    }
]);


/***/ }),
/* 497 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"Subscription-container\" ng-show=\"subscription && subscription.status === 'active'\">\n<div class=\"Subscription\">\n<div class=\"Subscription-background\"></div>\n<div class=\"Subscription-actions-background\"></div>\n<div class=\"Subscription-backgroundCorner\"></div>\n<layout-container class=\"Subscription-container\" direction=\"row\">\n<layout-content>\n<div class=\"Subscription-badge\">\n<span class=\"Subscription-badgeName\">{{ 'COMPONENT.PREMIUM_TILE.PREMIUM' | translate }}</span>\n<span ng-show=\"subscription.cancel_at_period_end\" class=\"Subscription-badgeDaysRemaining\">\n<small>{{ 'COMPONENT.PREMIUM_TILE.ENDING_ON' | translate:{ date: subscription.current_period_end * 1000 } }}</small>\n</span>\n<span ng-show=\"!subscription.cancel_at_period_end\" class=\"Subscription-badgeDaysRemaining\">\n{{ subscription.plan.amount / 100 | currency:\"$\" }}\n<small>/{{ 'COMPONENT.PREMIUM_TILE.PLAN_INTERVAL_' + subscription.plan.interval | uppercase | translate }}\n</small>\n</span>\n</div>\n</layout-content>\n<layout-content shrink=\"true\">\n<div class=\"Subscription-detailsContainer\">\n<div ng-show=\"subscription.cancel_at_period_end\" class=\"Subscription-details\">\n<h4 class=\"Subscription-name\">{{ 'COMPONENT.PREMIUM_TILE.PREMIUM_PLAN_PAY_' + subscription.plan.interval + 'LY' | uppercase | translate }}\n</h4>\n<p class=\"Subscription-description\">{{ 'COMPONENT.PREMIUM_TILE.AUTO_RENEW_OFF' | translate }}</p>\n<p>\n{{ 'COMPONENT.PREMIUM_TRIAL_TILE.CURRENCY_NOTICE' | translate }}\n</p>\n</div>\n<div ng-show=\"!subscription.cancel_at_period_end && currentCard\" class=\"Subscription-details\">\n<h4 class=\"Subscription-name\">{{ 'COMPONENT.PREMIUM_TILE.PREMIUM_PLAN_PAY_' + subscription.plan.interval + 'LY' | uppercase | translate }}\n</h4>\n<p class=\"Subscription-description\">{{ 'COMPONENT.PLAN_COMPARISION.PRO_DESCRIPTION' | translate }}</p>\n<p>\n{{ 'COMPONENT.PREMIUM_TRIAL_TILE.CURRENCY_NOTICE' | translate }}\n</p>\n</div>\n</div>\n</layout-content>\n</layout-container>\n<div class=\"Subscription-actions\">\n<ike-button class=\"Subscription-action Subscription-action-normal\" ng-show=\"currentCard\" ng-click=\"toggleCreditCardView()\">{{ 'COMPONENT.PREMIUM_TRIAL_TILE.CREDIT_CARD_DETAILS' | translate }}</ike-button>\n<ike-button class=\"Subscription-action Subscription-action-normal\" ng-show=\"!subscription.cancel_at_period_end\" ng-click=\"openCancelDialog()\">{{ 'COMPONENT.PREMIUM_TILE.CANCEL_PLAN' | translate }}</ike-button>\n</div>\n</div>\n<div class=\"Subscription-creditCardView Subscription-creditCardView--closed\">\n<credit-card-view toggle=\"toggleCreditCardView\" card=\"currentCard\" show-update=\"true\" open-update=\"openUpdateCard()\"></credit-card-view>\n</div>\n<div class=\"Subscription-cancelConfirmDialog Subscription-cancelConfirmDialog--closed\">\n<div class=\"Subscription-cancelConfirmDialogContent\">\n<p>{{ 'COMPONENT.PREMIUM_TILE.CANCEL_CONFIRMATION' | translate }}</p>\n<div class=\"Subscription-cancelConfirmDialogActions\">\n<ike-button ng-click=\"closeCancelDialog()\">{{ 'COMPONENT.PREMIUM_TILE.BACK' | translate }}</ike-button>\n<ike-button class=\"Subscription-cancelConfirmDialogActionCancel\" ng-click=\"cancelSubscription(subscription.id)\">{{ 'COMPONENT.PREMIUM_TILE.CANCEL_PLAN' | translate }}</ike-button>\n</div>\n</div>\n</div>\n</div>";
var id1="premium.tile.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 498 */
/***/ (function(module, exports) {

angular.module('ikeweb.user').controller('PremiumTileController', ['$scope', 'subscriptionActionService', 'events',
    function($scope, subscriptionActionService, events) {

        function update() {
            subscriptionActionService.canChangePlan().then(function(canChangePlan) {
                $scope.canChangePlan = canChangePlan;
            });
        }

        $scope.$on(events.SUBSCRIPTION.CANCELED, function() {
            $scope.closeCancelDialog();
        });

        Object.keys(events.SUBSCRIPTION).forEach(function(event) {
            $scope.$on(events.SUBSCRIPTION[event], update);
        });

        update();
    }
]);


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(500);

angular.module('ikeweb.user').directive('premiumExpiredTile', [

    function() {
        return {
            replace: true,
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            scope: {
                currentCard: '=',
                subscription: '=',
                openPurchasePremiumModal: '&',
                openPurchaseTrialModal: '&',
                canTrial: '=',
                openUpdateCard: '&'

            },
            link: function($scope, $element, attrs) {
                var ccView = $element.find('.Subscription-creditCardView');
                $scope.toggleCreditCardView = function() {

                    ccView.toggleClass('Subscription-creditCardView--closed')
                        .toggleClass('Subscription-creditCardView--open');
                };
            }
        };
    }
]);


/***/ }),
/* 500 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"Subscription-container\" ng-show=\"!subscription\">\n<div class=\"Subscription Subscription-benefits-bg\">\n<div class=\"Subscription-background\"></div>\n<div class=\"Subscription-actions-background-top\">\n<span class=\"Subscription-actions-background-title\">\n{{ 'COMPONENT.PLAN_COMPARISION.CHOOSE_PLAN' | translate}}\n</span>\n</div>\n<div class=\"Subscription-actions-background\"></div>\n<layout-container class=\"Subscription-container\" direction=\"row\" grow=\"true\">\n<div class=\"Subscription-flex-container Subscription-flex-container-style\">\n<div class=\"Subscription-flex-item\">\n<div class=\"Subscription-item-current-plan\"> {{ 'COMPONENT.PLAN_COMPARISION.CURRENT_PLAN' | translate }} </div>\n<div class=\"Subscription-item Subscription-item-title Subscription-item-title-basic\"> {{ 'COMPONENT.PLAN_COMPARISION.BASIC_TITLE' | translate }} </div>\n<div class=\"Subscription-item Subscription-item-price\"> {{ 'COMPONENT.PLAN_COMPARISION.BASIC_PRICE' | translate }} </div>\n<div class=\"Subscription-item Subscription-item-description\"> {{ 'COMPONENT.PLAN_COMPARISION.BASIC_DESCRIPTION' | translate }} </div>\n<div class=\"Subscription-item Subscription-item-benefit\">\n<div class=\"Subscription-benefit-main\"> {{ 'COMPONENT.PLAN_COMPARISION.BASIC_BENEFITS_1' | translate}}</div>\n</div>\n<div class=\"Subscription-item Subscription-item-benefit\">\n<div class=\"Subscription-benefit-main\"> {{ 'COMPONENT.PLAN_COMPARISION.BASIC_BENEFITS_2' | translate}}</div>\n</div>\n<div class=\"Subscription-item Subscription-item-benefit\">\n<div class=\"Subscription-benefit-main\"> {{ 'COMPONENT.PLAN_COMPARISION.BASIC_BENEFITS_3' | translate}}</div>\n</div>\n<div class=\"Subscription-item Subscription-item-benefit\">\n<div class=\"Subscription-benefit-main\"> {{ 'COMPONENT.PLAN_COMPARISION.BASIC_BENEFITS_4' | translate}}</div>\n</div>\n<div class=\"Subscription-item Subscription-item-benefit\">\n<div class=\"Subscription-benefit-main\"> {{ 'COMPONENT.PLAN_COMPARISION.BASIC_BENEFITS_5' | translate}}</div>\n</div>\n</div>\n</div>\n</layout-container>\n</div>\n</div>\n";
var id1="premium.expired.tile.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(502);

angular.module('ikeweb.user').directive('premiumTrialTile', [

    function() {
        return {
            replace: true,
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            scope: {
                currentCard: '=',
                subscription: '=',
                trialDaysRemaining: '=',
                openPurchasePremiumModal: '&',
                openUpdateCard: '&',
                cancelSubscriptionTrial: '='
            },
            link: function($scope, $element) {

                var ccView = $element.find('.Subscription-creditCardView');
                var cancelDialog = $element.find('.Subscription-cancelConfirmDialog');

                function closeCreditCardView() {
                    ccView.addClass('Subscription-creditCardView--closed')
                        .removeClass('Subscription-creditCardView--open');
                }

                function closeCancelDialog() {
                    cancelDialog.addClass('Subscription-cancelConfirmDialog--closed')
                        .removeClass('Subscription-cancelConfirmDialog--open');
                }

                $scope.toggleCreditCardView = function() {
                    closeCancelDialog();
                    ccView.toggleClass('Subscription-creditCardView--closed')
                        .toggleClass('Subscription-creditCardView--open');
                };

                $scope.openCancelDialog = function() {
                    closeCreditCardView();
                    cancelDialog.addClass('Subscription-cancelConfirmDialog--open')
                        .removeClass('Subscription-cancelConfirmDialog--closed');
                };

                $scope.closeCancelDialog = closeCancelDialog;
            },
            controller: 'PremiumTrialTileController'
        };
    }
]);


/***/ }),
/* 502 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"Subscription-container\" ng-show=\"subscription && subscription.status === 'trialing'\">\n<div class=\"Subscription\">\n<div class=\"Subscription-background\"></div>\n<div class=\"Subscription-actions-background\"></div>\n<div class=\"Subscription-backgroundCorner\"></div>\n<layout-container class=\"Subscription-container\" direction=\"row\">\n<layout-content shrink=\"true\">\n<div class=\"Subscription-detailsContainer\">\n<div ng-show=\"subscription.cancel_at_period_end\" class=\"Subscription-details\">\n<h4 class=\"Subscription-name\">{{ 'COMPONENT.PREMIUM_TRIAL_TILE.PREMIUM_TRIAL_CANCELLED' | translate }}</h4>\n<p class=\"Subscription-description\">{{ 'COMPONENT.PREMIUM_TRIAL_TILE.TRIAL_DESCRIPTION_CANCELLED' | translate:{ date: subscription.current_period_end * 1000}}}</p>\n</div>\n<div ng-show=\"!subscription.cancel_at_period_end && currentCard\" class=\"Subscription-details\">\n<h4 class=\"Subscription-name\">{{ 'COMPONENT.PREMIUM_TRIAL_TILE.PREMIUM_TRIAL' | uppercase | translate }}</h4>\n<p class=\"Subscription-description\">{{ 'COMPONENT.PREMIUM_TRIAL_TILE.TRIAL_DESCRIPTION' | translate }}</p>\n</div>\n</div>\n</layout-content>\n</layout-container>\n<div class=\"Subscription-actions\">\n<ike-button class=\"Subscription-action Subscription-action-normal\" ng-show=\"currentCard\" ng-click=\"toggleCreditCardView()\">{{ 'COMPONENT.PREMIUM_TRIAL_TILE.CREDIT_CARD_DETAILS' | translate }}</ike-button>\n<ike-button class=\"Subscription-action Subscription-action-normal\" ng-show=\"!subscription.cancel_at_period_end\" ng-click=\"openCancelDialog()\">{{ 'COMPONENT.PREMIUM_TILE.CANCEL_PLAN' | translate }}</ike-button>\n</div>\n</div>\n<div class=\"Subscription-creditCardView Subscription-creditCardView--closed\">\n<credit-card-view toggle=\"toggleCreditCardView\" card=\"currentCard\" show-update=\"true\" open-update=\"openUpdateCard()\"></credit-card-view>\n</div>\n<div class=\"Subscription-cancelConfirmDialog Subscription-cancelConfirmDialog--closed\">\n<div class=\"Subscription-cancelConfirmDialogContent\">\n<p>{{ 'COMPONENT.PREMIUM_TILE.CANCEL_CONFIRMATION' | translate }}</p>\n<div class=\"Subscription-cancelConfirmDialogActions\">\n<ike-button ng-click=\"closeCancelDialog()\">{{ 'COMPONENT.PREMIUM_TILE.BACK' | translate }}</ike-button>\n<ike-button class=\"Subscription-cancelConfirmDialogActionCancel\" ng-click=\"cancelSubscriptionTrial(subscription.id)\">{{ 'COMPONENT.PREMIUM_TILE.CANCEL_PLAN' | translate }}</ike-button>\n</div>\n</div>\n</div>\n</div>";
var id1="premium.trial.tile.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 503 */
/***/ (function(module, exports) {

angular.module('ikeweb.user').controller('PremiumTrialTileController', ['$scope', 'subscriptionActionService', 'events',
    function($scope, subscriptionActionService, events) {

        function update() {
            subscriptionActionService.canChangePlan().then(function(canChangePlan) {
                $scope.canChangePlan = canChangePlan;
            });
        }

        $scope.$on(events.SUBSCRIPTION.CANCELED, function() {
            $scope.closeCancelDialog();
        });

        Object.keys(events.SUBSCRIPTION).forEach(function(event) {
            $scope.$on(events.SUBSCRIPTION[event], update);
        });

        update();
    }
]);


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(505);

angular.module('ikeweb.user').directive('purchasePremium',
    function() {

        return {
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            replace: true,
            scope: {},
            controller: 'PurchasePremiumController',
            controllerAs: 'ctrl'
        };
    }
);


/***/ }),
/* 505 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"PurchasePremium\">\n<ike-form submit=\"purchase()\" ignore-validation=\"!!currentCard\">\n<ike-modal title-text=\"{{ selectedTrial ? 'COMPONENT.PURCHASE_PREMIUM.PREMIUM_PLAN_TRIAL' : 'COMPONENT.PURCHASE_PREMIUM.PREMIUM_PLAN'\n        | translate }}\" display-event=\"{{displayEvent}}\" dismiss-event=\"{{dismissEvent}}\">\n<ike-modal-content>\n<div class=\"PurchasePremium-modal-container\" ng-hide=\"loading\">\n<div class=\"PurchasePremium-subscription\">\n<p class=\"PurchasePremium-description\">\n{{ selectedTrial ? 'COMPONENT.PURCHASE_PREMIUM.TRIAL_DESCRIPTION' : 'COMPONENT.PURCHASE_PREMIUM.DESCRIPTION' | translate }}\n</p>\n</div>\n<div class=\"PurchasePremium-planSelector\">\n<div class=\"PurchasePremium-choose-plan\" ng-show=\"!selectedTrial\"> {{ 'COMPONENT.PURCHASE_PREMIUM.CHOOSE_PLAN' | translate }} </div>\n<plan-selector plans=\"selectablePlans\" selected-trial=\"selectedTrial\" current-plan=\"subscription.plan\" selected-plan=\"selectedPlan\" onselected=\"selectPlan\" can-trial=\"canTrial\">\n</plan-selector>\n</div>\n<div class=\"PurchasePremium-infomessage\" ng-show=\"subscriptionWillEnd() && subscription.plan.interval === 'year'\">\n<i ng-class=\"{'glyphicon-warning-white' : cannotSelectMonthlyError, 'glyphicon-warning-black' : !cannotSelectMonthlyError}\"></i>\n<span ng-class=\"{'error' : cannotSelectMonthlyError}\">{{ 'COMPONENT.PURCHASE_PREMIUM.CANNOT_SELECT_MONTHLY' | translate }}</span>\n</div>\n<div ng-show=\"planNotSelected\" class=\"PurchasePremium-infomessage\">\n<span class=\"error\">\n{{ 'COMPONENT.PURCHASE_PREMIUM.PLAN_REQUIRED' | translate }}</span>\n</div>\n<br/>\n<div class=\"PurchasePremium-cardformwrap\" ng-show=\"!currentCard\">\n<div class=\"PurchasePremium-cardformtitle\">\n<h3>{{ 'COMPONENT.PURCHASE_PREMIUM.ENTER_CARD_DETAILS' | translate }}</h3>\n</div>\n<div class=\"PurchasePremium-cardform\">\n<credit-card-form></credit-card-form>\n</div>\n</div>\n<div ng-show=\"currentCard\" class=\"PurchasePremium-cardview\">\n<h3>{{ 'COMPONENT.PURCHASE_PREMIUM.PAYMENT_FROM_CARD' | translate }}</h3>\n<credit-card-view card=\"currentCard\"></credit-card-view>\n</div>\n</div>\n</ike-modal-content>\n<ike-modal-footer class=\"PurchasePremium-modal-footer\">\n<div ng-show=\"!selectedTrial\" class=\"PurchasePremium-modal-buttons\">\n<div class=\"PurchasePremium-infomessage PurchasePremium-endingSubscription\">\n<span>{{ 'COMPONENT.PURCHASE_PREMIUM.THIS_WILL_RENEW' | translate }}</span>\n</div>\n<div class=\"PurchasePremium-infomessage PurchasePremium-infomessage-bold PurchasePremium-endingSubscription\">\n<span ng-bind-html=\"'COMPONENT.PURCHASE_PREMIUM.AGREE' | translate | html\"></span>\n</div>\n<ike-button ng-disabled=\"purchasing\" type=\"submit\" class=\"PurchasePremium-modal-buy\">{{ purchasing ? 'COMPONENT.PURCHASE_PREMIUM.BUYING' : 'COMPONENT.PURCHASE_PREMIUM.BUY' | translate}}</ike-button>\n<ike-button ng-disabled=\"purchasing\" type=\"button\" class=\"PurchasePremium-modal-cancel\" ng-click=\"closePurchasePremiumModal()\">{{ 'COMPONENT.PURCHASE_PREMIUM.CANCEL' | translate }}</ike-button>\n</div>\n<div ng-show=\"selectedTrial\" class=\"PurchasePremium-modal-buttons\">\n<div class=\"PurchasePremium-infomessage PurchasePremium-endingSubscription\">\n<span>{{ 'COMPONENT.PURCHASE_PREMIUM.THIS_WILL_RENEW_TRIAL' | translate }}</span>\n</div>\n<div class=\"PurchasePremium-infomessage PurchasePremium-infomessage-bold PurchasePremium-endingSubscription\">\n<span ng-bind-html=\"'COMPONENT.PURCHASE_PREMIUM.TRIAL_AGREE' | translate | html\"></span>\n</div>\n<ike-button ng-disabled=\"purchasing\" type=\"submit\" class=\"PurchasePremium-modal-buy\">{{ purchasing ? 'COMPONENT.PURCHASE_PREMIUM.BUYING' : 'COMPONENT.PURCHASE_PREMIUM.START_TRIAL' | translate}}</ike-button>\n<ike-button ng-disabled=\"purchasing\" type=\"button\" class=\"PurchasePremium-modal-cancel\" ng-click=\"closePurchasePremiumModal()\">{{ 'COMPONENT.PURCHASE_PREMIUM.CANCEL' | translate }}</ike-button>\n</div>\n</ike-modal-footer>\n</ike-modal>\n</ike-form>\n</div>";
var id1="purchase.premium.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 506 */
/***/ (function(module, exports) {

angular.module('ikeweb.user').controller('PurchasePremiumController', ['$scope', 'billingService', 'creditCardService', 'events', '$rootScope', 'promiseFactory', 'subscriptionActionService', 'functional',
    function($scope, billingService, creditCardService, events, $rootScope, promiseFactory, subscriptionActionService, f) {

        $scope.displayEvent = events.BILLING.PURCHASE.DISPLAY_MODAL;
        $scope.dismissEvent = events.BILLING.PURCHASE.DISMISS_MODAL;
        $scope.notifications = {};
        $scope.card = {};
        $scope.planNotSelected = false;
        $scope.selectedTrial = false;

        $scope.subscriptionWillEnd = function() {
            var subscription = $scope.subscription;
            return (subscription != null && subscription.cancel_at_period_end);
        };

        function canSelectPlan(plan) {
            if ($scope.isOnTrial || !plan || !$scope.subscription) {
                return true;
            }
            if ($scope.shouldRenew) {
                return subscriptionActionService.canRenewPlanTo($scope.subscription.plan, plan);
            }
            return subscriptionActionService.canChangePlanTo($scope.subscription.plan, plan);
        }

        function initSelectedPlan(plan) {
            if ($scope.isOnTrial || !plan) {
                return undefined;
            }
            if ($scope.shouldRenew) {
                return plan;
            }
            return $scope.selectablePlans.filter(f.not(f.propertyEquals('interval', plan.interval)))[0];
        }

        $scope.selectPlan = function(plan) {
            if (!canSelectPlan(plan)) {
                $scope.cannotSelectMonthlyError = true;
                return;
            }
            $scope.selectedPlan = plan;
            $scope.planNotSelected = false;
            $scope.cannotSelectMonthlyError = false;
        };

        function loadCreditCard() {
            return creditCardService.loadCard({
                cardHolderName: $scope.card.cardHolderName,
                cardNumber: $scope.card.cardNumber,
                cvv: $scope.card.cvv,
                expiryMonth: $scope.card.expiryMonth,
                expiryYear: $scope.card.expiryYear,
                zip: $scope.card.zip
            });
        }

        function subscribe(token) {
            var subscribePromise;
            if ($scope.selectedTrial) {
                subscribePromise = billingService.subscribeTrial($scope.selectedPlan.id, token);
            } else {
                subscribePromise = billingService.subscribe($scope.selectedPlan.id, token);
            }
            return subscribePromise.then(function(subscription) {
                $rootScope.$broadcast(events.SUBSCRIPTION.CREATED, subscription);
                return subscription;
            });
        }

        $scope.closePurchasePremiumModal = function() {
            $rootScope.$broadcast($scope.dismissEvent);
        };

        $scope.closeThankYouModal = function() {
            $rootScope.$broadcast($scope.dismissThankYouEvent);
        };

        $scope.purchase = function() {
            if (!$scope.selectedPlan) {
                $scope.planNotSelected = true;
                return;
            }

            $scope.purchasing = true;

            ($scope.currentCard ? promiseFactory.resolvedPromise() : loadCreditCard())
            .then(subscribe)
                .then(function() {
                    $scope.closePurchasePremiumModal();
                    $scope.purchasing = false;
                }, function() {
                    $scope.purchasing = false;
                });

        };

        function refresh(trial) {
            $scope.cannotSelectMonthlyError = false;
            $scope.loading = true;
            $scope.selectedTrial = trial ? trial : false;
            promiseFactory.all([
                billingService.getCurrentCreditCard(),
                billingService.getActiveSubscription(),
                billingService.getAvailablePlans(),
                billingService.eligibleForTrial(),
                subscriptionActionService.shouldRenew(),
                subscriptionActionService.isOnTrial()

            ]).then(function(values) {
                $scope.loading = false;
                $scope.currentCard = values.shift();
                $scope.subscription = values.shift();
                $scope.selectablePlans = values.shift();
                $scope.canTrial = values.shift();
                $scope.shouldRenew = values.shift();
                $scope.isOnTrial = values.shift();
                $scope.selectedPlan = initSelectedPlan($scope.subscription ? $scope.subscription.plan : undefined);
                if ($scope.selectedTrial) {
                    $scope.selectablePlans = $scope.selectablePlans.filter(function(obj) {
                        if (obj.interval === 'month') {
                            return true;
                        }
                        return false;

                    });
                    $scope.selectedPlan = $scope.selectablePlans[0]; //should contain just the monthly plan
                }
                if (trial != null) {
                    // display modal when refresh is called from a UI event
                    $scope.$broadcast(events.BILLING.PURCHASE.DISPLAY_MODAL);
                }
            });
        }

        refresh();
        $scope.$on(events.BILLING.PURCHASE_PREMIUM.DISPLAY, refresh.bind(null, false));
        $scope.$on(events.BILLING.PURCHASE_TRIAL.DISPLAY, refresh.bind(null, true));
    }
]);


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(508);

angular.module('ikeweb.user').directive('planSelector', [

    function() {

        return {
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            replace: true,
            scope: {
                plans: '=',
                currentPlan: '=',
                selectedPlan: '=',
                onselected: '=',
                selectedTrial: '='
            },
            controller: 'planSelectorController'
        };
    }
]);


/***/ }),
/* 508 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"PlanSelector\" ng-show=\"!selectedTrial\">\n<div ng-repeat=\"plan in plans\" ng-click=\"onselected(plan)\" class=\"PlanSelector-planBadge\">\n<div class=\"PlanSelector-planBadge-radio\" ng-class=\"{true: 'PlanSelector-planBadge-selected', false: 'PlanSelector-planBadge-unselected'}[isSelected(plan.interval)]\"></div>\n<span class=\"PlanSelector-planBadgeAmount\">{{ plan.amount / 100 | currency:\"$\" }} {{ 'COMPONENT.PLAN_SELECTOR.PER_' + plan.interval | uppercase | translate }}\n</span>\n<span class=\"PlanSelector-planBadgeInterval\">{{ 'COMPONENT.PLAN_SELECTOR.' + plan.interval + 'ly' | uppercase | translate }}</span>\n</div>\n</div>\n";
var id1="plan.selector.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 509 */
/***/ (function(module, exports) {

angular.module('ikeweb.user').controller('planSelectorController', ['$scope',
    function($scope) {
        $scope.isSelected = function(planName) {
            if ($scope.selectedPlan == null) {
                return false;
            }
            return $scope.selectedPlan.interval === planName;
        };
    }
]);


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(511);
angular.module('ikeweb.locale').directive('localeChooserSmall', [

    function() {
        return {
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            replace: true,
            controller: 'LocaleChooserController',
            controllerAs: 'ctrl',
            scope: {},
            link: function($scope) {
                $scope.showDropdown = false;

                $scope.toggleDropdown = function($evt) {
                    $evt.stopPropagation();
                    $scope.showDropdown = !$scope.showDropdown;

                    if ($scope.showDropdown) {
                        $('body').on('click.dropdown', function() {
                            $scope.$apply(function() {
                                $scope.showDropdown = false;
                                $('body').off('click.dropdown');
                            });
                        });
                    }
                };
            }
        };
    }
]);


/***/ }),
/* 511 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"UserLocaleChooserSmall\">\n<i class=\"UserLocaleChooserSmall-icon\" ng-click=\"toggleDropdown($event)\"></i>\n<ul class=\"UserLocaleChooserSmall-dropdownList ng-hide\" ng-show=\"showDropdown\">\n<li class=\"UserLocaleChooserSmall-dropdownListItem\" ng-repeat=\"locale in ctrl.getAvailableLocales()\">\n<a class=\"UserLocaleChooserSmall-dropdownListItemLink\" ng-class=\"{'UserLocaleChooserSmall-dropdownListItemLink-selected' : ctrl.isCurrent(locale.value)}\" ng-click=\"ctrl.setCurrentLocale(locale.value)\">\n{{ locale.label }}\n</a>\n</li>\n</ul>\n</div>";
var id1="chooser.small.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 512 */
/***/ (function(module, exports) {

angular.module('ikeweb.user').factory('userTopics',

    function() {

        return {
            PREFERENCES: {
                UPDATED: {
                    name: 'preferences.updated'
                }
            },
            CREDITCARD: {
                UPDATED: {
                    name: 'creditcard.updated'
                }
            }
        };
    });


/***/ }),
/* 513 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.capture').factory('captureFactory', ['SpikeUtil', '$translate', 'folderService',
    function(SpikeUtil, $translate, folderService) {
        var PARSE_CAPTURE_CLASS_NAME = 'SpikeCapture';
        var PARSE_SHAREDCAPTURE_CLASS_NAME = 'SharedCapture';

        function createPolygon(measurement) {
            return {
                type: measurement.type,
                shape: measurement.svg,
                dimensions: measurement.dimensions,
                area: measurement.area,
                totalDimension: measurement.circumference,
                id: measurement.id
            };
        }

        function filterBy(type) {
            return function(measurement) {
                return measurement.type === type;
            };
        }

        function createMeasurement(type) {
            return function(polygon) {
                return {
                    type: type,
                    svg: polygon.shape,
                    dimensions: polygon.dimensions,
                    area: polygon.area,
                    circumference: polygon.totalDimension,
                    id: polygon.id
                };
            };
        }

        function populateImageResolution(context) {
            var captureData = context.get('capture');
            context.resolution = captureData.steps[0].camera.resolution;
        }

        function findLocation(captureData, type) {
            var locations = captureData.steps[0].location;
            var location = locations.filter(function(location) {
                return location.type === type;
            });
            if (location.length > 0 && location[0].latitude !== 0 && location[0].longitude !== 0) {
                return location[0];
            }
            return null;
        }

        function populateMeasurements(context) {
            var captureData = context.get('capture');
            /* eslint-disable */
            context.measurements = {
                alignment_polygons: captureData.measurements.filter(filterBy('alignment')).map(createPolygon),
                cutout_polygons: captureData.measurements.filter(filterBy('cutout')).map(createPolygon),
                main_polygons: captureData.measurements.filter(filterBy('main')).map(createPolygon),
                polylines: captureData.measurements.filter(filterBy('line')).map(createPolygon)
            };
            /* eslint-enable */
        }

        function populateNote(context) {
            var note = context.get('note');
            context.note = note ? note : '';
        }

        function getAlignedImage() {
            var alignedImage = this.get('alignedImage');
            return alignedImage ? alignedImage.url() : '';
        }

        function getScaledImage() {
            var scaledImage = this.get('scaledImage');
            return scaledImage ? scaledImage.url() : '';
        }

        function getThumbnailImage() {
            var thumbnailImage = this.get('thumbnailImage');
            return thumbnailImage ? thumbnailImage.url() : '';
        }

        function getMeasurementsSVGString() {
            var measurements = this.get('capture').measurements;
            var resolution = this.resolution;
            var innerSVG = ['<svg xmlns=\'http://www.w3.org/2000/svg\' width="' + resolution.width + '" height="' + resolution.height + '">'];

            measurements.forEach(function(m) {
                innerSVG.push(m.svg);
            });

            innerSVG.push('</svg>');

            return innerSVG.join('');
        }

        function getMeasurementsSVG() {
            var resolution = this.resolution;
            var svg = SpikeUtil.SVG.tag('svg');
            svg.setAttribute('preserveAspectRatio', 'xMinYMin');
            svg.setAttribute('viewBox', '0 0 ' + resolution.width + ' ' + resolution.height);

            var parser = new DOMParser();

            var dom = parser.parseFromString(getMeasurementsSVGString.call(this), 'image/svg+xml');
            var el = svg.ownerDocument.importNode(dom.documentElement, true);
            svg.appendChild(el);
            return svg;
        }

        function getName() {
            return this.get('name');
        }

        var SharedCapture = Parse.Object.extend(PARSE_SHAREDCAPTURE_CLASS_NAME, {
            populate: function() {
                populateMeasurements(this);
                populateImageResolution(this);
                populateNote(this);
            },
            getAlignedImage: getAlignedImage,
            getScaledImage: getScaledImage,
            getThumbnailImage: getThumbnailImage,
            getMeasurementsSVG: getMeasurementsSVG,
            getUnits: function() {
                return this.get('units');
            },
            getZoomArea: function() {
                return this.get('zoomArea');
            },
            getName: getName,
            getMeasurementsSVGString: getMeasurementsSVGString
        });

        var Capture = Parse.Object.extend(PARSE_CAPTURE_CLASS_NAME, {

            populate: function() {
                var captureData = this.get('capture');
                this.hva = captureData.steps[0].camera.calibration.basic.horizontal;
                this.vva = captureData.steps[0].camera.calibration.basic.vertical;
                this.distance = captureData.steps[0].range.distance;
                populateMeasurements(this);
                populateImageResolution(this);
                populateNote(this);
            },

            serialize: function() {
                this.get('capture').measurements = [].concat(
                    this.measurements.alignment_polygons.map(createMeasurement('alignment')),
                    this.measurements.main_polygons.map(createMeasurement('main')),
                    this.measurements.cutout_polygons.map(createMeasurement('cutout')),
                    this.measurements.polylines.map(createMeasurement('line')));
            },

            isAlignmentDone: function() {
                if (!this.get('capture')) {
                    return false;
                }

                var measurements = this.get('capture').measurements;
                for (var i = 0; i < measurements.length; i++) {
                    if (measurements[i].type === 'alignment') {
                        return true;
                    }
                }

                return false;
            },

            getExportFilename: function() {
                var timestamp = this.get('timestamp');
                var folder = this.get('folder');
                var foldername = folder ? folder.get('name') || ' ' : '';
                var filename = foldername + ' ' + this.getName() + ' ' + moment(timestamp).format('YYYY-MM-DD_HH:mm:ssZ');
                return SpikeUtil.cleanFileName(filename, {
                    replacement: ' '
                });
            },

            isInFolder: function(folder) {
                return this.get('folder') && this.get('folder').id && this.get('folder').id === folder.getId();
            },

            getTargetLocation: function() {
                return findLocation(this.get('capture'), 'target');
            },
            hasPosition: function() {
                return !!findLocation(this.get('capture'), 'local');
            },
            getTimeStamp: function() {
                return this.get('timestamp');
            },
            getCaptureUuid: function() {
                return this.get('captureuuid');
            },
            setName: function(value) {
                this.set('name', value);
            },
            setNote: function(value) {
                this.set('note', value);
            },
            getId: function() {
                return this.id;
            },
            getNote: function() {
                return this.get('note');
            },
            getName: getName,
            getMeasurementsSVGString: getMeasurementsSVGString,
            getMeasurementsSVG: getMeasurementsSVG,
            getAlignedImage: getAlignedImage,
            getScaledImage: getScaledImage,
            getThumbnailImage: getThumbnailImage
        });

        function create() {
            return new Capture();
        }

        return {
            Capture: Capture,
            SharedCapture: SharedCapture,
            create: create
        };
    }
]);


/***/ }),
/* 514 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.capture')
    .factory('spikeCaptureService', ['SpikeUtil', 'captureFactory', 'spikeImageService', 'promiseFactory',

        function spikeCaptureService(SpikeUtil, captureFactory, spikeImageService, promiseFactory) {

            var GENERATE_THUMBNAIL_FUNCTION = 'generateThumbnail';
            var DESKEW_CAPTURE_FUNCTION = 'deskewCapture';
            var ALIGN_CAPTURE_FUNCTION = 'alignCapture';

            var Capture = captureFactory.Capture;

            function populateCapture(capture) {
                capture.captureDate = moment(capture.get('timestamp'));
                capture.populate();
                return capture;
            }

            function populateCaptures(captures) {
                return captures.map(populateCapture);
            }

            function query() {
                return new Parse.Query(Capture)
                    .include('folder')
                    .addDescending('createdAt')
                    .limit(1000); // set a large upper limit to results
            }

            function loadImage(url) {
                if (!url) {
                    return Parse.Promise.error('Image does not exist');
                }

                var image = new Image();
                return spikeImageService.setImageSrc(image, url);
            }

            function generateThumbnail(capture) {
                return Parse.Cloud.run(GENERATE_THUMBNAIL_FUNCTION, {
                    captureuuid: capture.getCaptureUuid()
                });
            }

            function generateDeskewedImage(capture) {
                return Parse.Cloud.run(DESKEW_CAPTURE_FUNCTION, {
                    captureuuid: capture.getCaptureUuid()
                });
            }

            function generateAlignmentPoints(capture) {
                return Parse.Cloud.run(ALIGN_CAPTURE_FUNCTION, {
                    captureuuid: capture.getCaptureUuid()
                });
            }

            return {
                listCaptures: function(folderId) {
                    var listQuery = query();
                    if (folderId) {
                        listQuery.equalTo('folder', new Parse.Object('Folder', {
                            id: folderId
                        }));
                    }

                    return listQuery
                        .find()
                        .then(populateCaptures);
                },

                getCapture: function(captureid) {
                    return query().get(captureid).then(populateCapture);
                },

                getCaptureImage: function(capture, scaled) {
                    if (scaled) {
                        return loadImage(capture.getScaledImage())
                            .catch(function() {
                                return generateThumbnail(capture)
                                    .then(function(capture) {
                                        return loadImage(capture.getScaledImage());
                                    });
                            });
                    }
                    return loadImage(capture.getAlignedImage());
                },

                getCaptureImageDeskewed: function(capture, scaled) {
                    return generateDeskewedImage(capture)
                        .then(function(urlMap) {
                            return scaled ? urlMap.thumbnail : urlMap.full;
                        });
                },
                getAutoAlignmentPolygon: function(capture) {
                    return generateAlignmentPoints(capture);
                },

                putCapturesInFolder: function(captures, folder) {
                    captures.map(function(capture) {
                        capture.set('folderName', folder.getName());
                    });
                    return Parse.Object.saveAll(captures);
                },

                saveMeasurementsForCapture: function(capture, measurements) {
                    capture.measurements = measurements;
                    capture.serialize();
                    return promiseFactory.resolvedPromise();
                },
                saveNoteForCapture: function(capture, note) {
                    if (capture.getNote() !== note) {
                        capture.setNote(note);
                    }
                    return promiseFactory.resolvedPromise();
                },
                renameCapture: function(capture, name) {
                    if (capture.getName() !== name) {
                        capture.setName(name);
                        return capture.save();
                    }
                    return Parse.Promise.as(capture);
                },

                deleteCaptures: function(captures) {
                    return captures.length > 0 ?
                        Parse.Object.destroyAll(captures, {
                            wait: true
                        }) :
                        Parse.Promise.as();
                }
            };
        }
    ])
    .config(['$provide',
        function($provide) {

            var functionsToCache = ['listCaptures', 'getCapture'];
            var functionsThatFlush = ['putCapturesInFolder', 'saveMeasurementsForCapture', 'deleteCaptures', 'renameCapture', 'saveNoteForCapture'];
            var functionsToDecorate = functionsToCache.concat(functionsThatFlush, 'getCaptureImage');

            $provide.decorator('spikeCaptureService', ['$delegate', 'qPromiseDecoratorService',
                function($delegate, qPromiseDecoratorService) {
                    return qPromiseDecoratorService.decorateDelegateWithPromise($delegate, functionsToDecorate);
                }
            ]);

            $provide.decorator('spikeCaptureService', ['$delegate', 'parseErrorDecoratorService',
                function($delegate, parseErrorDecoratorService) {
                    return parseErrorDecoratorService.decorateDelegatePromiseErrors($delegate, functionsToDecorate, {
                        101: 'CAPTURE_NOT_FOUND'
                    });
                }
            ]);

            $provide.decorator('spikeCaptureService', ['$delegate', 'cacheDecoratorBuilder', 'userHashService',
                function($delegate, cacheDecoratorBuilder, userHashService) {
                    return cacheDecoratorBuilder
                        .aCacheDecorator()
                        .withTTL(moment.duration(1, 'minutes').asMilliseconds())
                        .withHash(userHashService.hash)
                        .build()
                        .decorateDelegateWithCaching($delegate, functionsToCache, functionsThatFlush);
                }
            ]);

            $provide.decorator('spikeCaptureService', ['$delegate', 'promiseProgressDecoratorService',
                function($delegate, promiseProgressDecoratorService) {
                    return promiseProgressDecoratorService.decorateDelegateWithProgress($delegate, functionsToDecorate);
                }
            ]);

            $provide.decorator('spikeCaptureService', ['$delegate', 'decoratedPromiseBuilder', 'notificationService',
                function($delegate, decoratedPromiseBuilder, notificationService) {

                    return decoratedPromiseBuilder
                        .forDelegate($delegate)
                        .decorate('renameCapture')
                        .onSuccess(notificationService.success('NOTIFICATION.CAPTURE.RENAME_CAPTURE', 'NOTIFICATION.CAPTURE.CAPTURE_RENAMED'))
                        .onError(notificationService.error('NOTIFICATION.CAPTURE.RENAME_CAPTURE', 'NOTIFICATION.CAPTURE.RENAME_PROBLEM'))
                        .decorate('getCapture')
                        .onError(notificationService.error('NOTIFICATION.CAPTURE.FETCH_CAPTURE', 'NOTIFICATION.CAPTURE.FETCH_PROBLEM'))
                        .fork();
                }
            ]);

            $provide.decorator('spikeCaptureService', ['$delegate', 'loggingDecorator',
                function($delegate, loggingDecorator) {
                    return loggingDecorator.decorateDelegateWithLogging($delegate, functionsToDecorate);
                }
            ]);
        }
    ]);


/***/ }),
/* 515 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.capture').service('captureExportService', [
    'CaptureImageExport', 'BasicImageExport', 'spikeCaptureService', 'SpikeUtil', '$analytics',
    function(CaptureImageExport, BasicImageExport, spikeCaptureService, SpikeUtil, $analytics) {

        function newExport(fromCapture, offset) {
            return new CaptureImageExport(fromCapture, offset);
        }

        function newBasicExport(fromCapture) {
            return new BasicImageExport(fromCapture);
        }

        function trackExport(exportType, capture) {

            var event = {
                category: 'Export',
                action: exportType,
                label: capture && capture.id,
                value: 1
            };
            $analytics.eventTrack(exportType, event);
        }

        function download(captureExport) {
            var data = captureExport.getData();
            if (data != null) {
                SpikeUtil.downloadBlob(captureExport.getData(), captureExport.getFilename());
            } else {
                SpikeUtil.downloadURL(captureExport.getURL(), captureExport.getFilename());
            }
        }

        function exportImageOnly(fromCapture, offset) {
            var imageExport = newExport(fromCapture, offset);
            trackExport('IMAGE_ONLY', fromCapture);
            return spikeCaptureService.getCaptureImage(fromCapture)
                .then(imageExport.addImage);
        }

        function exportDeskewed(fromCapture, offset) {
            var imageExport = newBasicExport(fromCapture);
            trackExport('DESKEWED', fromCapture);
            return spikeCaptureService.getCaptureImageDeskewed(fromCapture)
                .then(imageExport.addImage);
        }

        function exportImageWithMeasurements(fromCapture, offset) {
            var imageExport = newExport(fromCapture, offset);
            trackExport('COMPOSITE', fromCapture);
            return spikeCaptureService.getCaptureImage(fromCapture)
                .then(imageExport.addImage)
                .then(imageExport.addMeasurements);
        }

        return {
            imageOnly: exportImageOnly,
            deskewed: exportDeskewed,
            imageWithMeasurements: exportImageWithMeasurements,
            download: download
        };
    }
]).config(['$provide',
    function($provide) {

        var functionsToDecorate = [
            'imageOnly',
            'imageWithMeasurements'
        ];

        $provide.decorator('captureExportService', ['$delegate', 'promiseProgressDecoratorService',
            function($delegate, promiseProgressDecoratorService) {
                return promiseProgressDecoratorService.decorateDelegateWithProgress($delegate, functionsToDecorate);
            }
        ]);
    }
]);


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(517);
angular.module('ikeweb.spike.capture').directive('captureExportSelector', ['events', 'billingService',

    function(EVENTS, billingService) {

        return {
            restrict: 'E',
            replace: true,
            templateUrl: TEMPLATE_URL,
            scope: {
                capture: '='
            },
            link: function($scope) {
                $scope.dismissEvent = EVENTS.EXPORT.DISMISS_EXPORT_SELECTOR;
                $scope.displayEvent = EVENTS.EXPORT.DISPLAY_EXPORT_SELECTOR;
                $scope.selected = $scope.COMPOSITE = 'COMPOSITE';
                $scope.DESKEWED = 'DESKEWED';
                $scope.IMAGEONLY = 'IMAGEONLY';

                $scope.select = function(value) {
                    $scope.selected = value;
                };


                var canDeskew = false;
                billingService.isOnPremium().then(function(isPro) {
                    canDeskew = isPro;
                });
                $scope.canDeskew = function() {
                    return canDeskew;
                };

                $scope.download = function() {
                    $scope.$emit(EVENTS.EXPORT.DOWNLOAD[$scope.selected]);
                    $scope.$emit(EVENTS.EXPORT.DISMISS_EXPORT_SELECTOR);
                };
            }
        };
    }
]);


/***/ }),
/* 517 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"CaptureExportSelector\">\n<ike-modal title-text=\"{{ 'COMPONENT.CAPTURE_EXPORT_SELECTOR.DOWNLOAD' | translate }}\" display-event=\"{{displayEvent}}\" dismiss-event=\"{{dismissEvent}}\">\n<ike-modal-content class=\"CaptureExportSelector-modalContent\">\n<div class=\"CaptureExportSelector-selections\">\n<div ng-click=\"select('COMPOSITE')\" class=\"CaptureExportSelector-selection CaptureExportSelector-selectComposite\" ng-class=\"{'CaptureExportSelector-selection--selected' : selected === 'COMPOSITE' }\">\n<h3>{{ 'COMPONENT.CAPTURE_EXPORT_SELECTOR.MEASUREMENTS' | translate }}</h3>\n<div class=\"CaptureExportSelector-image\">\n<composite-image capture=\"capture\" scaled=\"y\"/>\n</div>\n</div>\n<div ng-click=\"select('IMAGEONLY')\" class=\"CaptureExportSelector-selection CaptureExportSelector-selectImageOnly\" ng-class=\"{'CaptureExportSelector-selection--selected' : selected === 'IMAGEONLY' }\">\n<h3>{{ 'COMPONENT.CAPTURE_EXPORT_SELECTOR.IMAGE_ONLY' | translate }}</h3>\n<div class=\"CaptureExportSelector-image\">\n<img ng-src=\"{{capture.getScaledImage()}}\"/>\n</div>\n</div>\n<div ng-if=\"canDeskew()\" ng-click=\"select('DESKEWED')\" class=\"CaptureExportSelector-selection CaptureExportSelector-selectDeskewed\" ng-class=\"{'CaptureExportSelector-selection--selected' : selected === 'DESKEWED' }\">\n<div class=\"ProBadgeContainer\">\n<h3>\n{{ 'COMPONENT.CAPTURE_EXPORT_SELECTOR.DESKEWED' | translate }}\n</h3>\n<div class=\"ProBadge ProBadge--TopRight\">pro</div>\n</div>\n<div class=\"CaptureExportSelector-image\">\n<deskewed-image capture=\"capture\" scaled=\"y\"/>\n</div>\n</div>\n<div ng-if=\"!canDeskew()\" class=\"CaptureExportSelector-selection CaptureExportSelector-selectDeskewed\" title=\"SpikePro required to use this feature.\">\n<div class=\"ProBadgeContainer\">\n<h3>\n{{ 'COMPONENT.CAPTURE_EXPORT_SELECTOR.DESKEWED' | translate }}\n</h3>\n<div class=\"ProBadge ProBadge--TopRight\">pro</div>\n</div>\n<div class=\"CaptureExportSelector-image\">\n<div class=\"ProRequired\">\n<i class=\"material-icons pro-lock\">lock_outline</i>\n<deskewed-image capture=\"capture\" scaled=\"y\"/>\n</div>\n</div>\n</div>\n</div>\n</ike-modal-content>\n<ike-modal-footer>\n<ike-button ng-click=\"download()\" class=\"CaptureExportSelector-downloadButton\">{{ 'COMPONENT.CAPTURE_EXPORT_SELECTOR.DOWNLOAD' | translate }}</ike-button>\n</ike-modal-footer>\n</ike-modal>\n</div>\n";
var id1="capture.export.selector.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 518 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.capture').value('CaptureImageExport',
    function CaptureImageExport(capture, offset) {

        var self = this;
        var resolution = capture.resolution;

        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');

        var canvasWidth = offset ? offset.width : resolution.width;
        var canvasHeight = offset ? offset.height : resolution.height;
        var offsetLeft = offset ? offset.left : 0;
        var offsetTop = offset ? offset.top : 0;

        canvas.setAttribute('width', canvasWidth);
        canvas.setAttribute('height', canvasHeight);

        function normalizeSVGforCanvg(svg) {
            // Fix for canvg nested-opacity bug: https://github.com/canvg/canvg/issues/510
            return svg.replace(/opacity\s*=\s*"0"/g, 'display="none"');
        }

        function drawSVG(svg) {
            var normalizedSVG = normalizeSVGforCanvg(svg);

            var svgCanvas = document.createElement('canvas');
            var svgContext = svgCanvas.getContext('2d');
            svgCanvas.setAttribute('width', resolution.width);
            svgCanvas.setAttribute('height', resolution.height);

            svgContext.drawSvg(normalizedSVG, 0, 0, resolution.width, resolution.height);

            return svgCanvas;
        }

        function drawImage(context, image) {
            context.drawImage(image,
                offsetLeft,
                offsetTop,
                canvasWidth,
                canvasHeight,
                0,
                0,
                canvasWidth,
                canvasHeight
            );
        }

        this.addImage = function(image) {
            drawImage(context, image);
            return self;
        };

        this.addMeasurements = function() {
            drawImage(context, drawSVG(capture.getMeasurementsSVGString()));
            return self;
        };

        this.getFilename = function() {
            return capture.getExportFilename() + '.jpg';
        };

        this.getURL = function() {
            return null;
        };

        this.getData = function() {
            var png = canvas.toDataURL('image/jpeg', 0.5).split(',')[1];
            var binStr = atob(png);

            var buf = new ArrayBuffer(binStr.length);
            var view = new Uint8Array(buf);
            for (var i = 0; i < view.length; i++) {
                view[i] = binStr.charCodeAt(i);
            }

            var blob = new Blob([view], {
                type: 'image/jpeg'
            });
            return blob;
        };

    });


/***/ }),
/* 519 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.capture').value('BasicImageExport',
    function BasicImageExport(capture) {

        var self = this;
        var imageUrl = null;

        this.addImage = function(url) {
            imageUrl = url;
            return self;
        };

        this.addMeasurements = function() {
            return self;
        };

        this.getFilename = function() {
            return capture.getExportFilename() + '.jpg';
        };

        this.getURL = function() {
            return imageUrl;
        };

        this.getData = function() {
            return null;
        };
    });


/***/ }),
/* 520 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.measure').service('measurementService', ['measurementFactory', 'photogrammetryToolKit',

    function(measurementFactory, photogrammetryToolKit) {

        var Type = photogrammetryToolKit.Measurement.Shape.Types;

        function add(a, b) {
            return a + b;
        }

        function equal(b) {
            return function(a) {
                return a === b;
            };
        }

        function getter(g) {
            return function(data) {
                return data[g]();
            };
        }

        function compareGetter(getter, pred) {
            return function(data) {
                return pred(data[getter]());
            };
        }

        function sumMeasurementData(measurementData, get, type) {
            return measurementData
                .filter(compareGetter('getType', equal(type)))
                .map(getter(get))
                .reduce(add, 0);
        }

        function getAreaTotal(measurements) {
            return sumMeasurementData(measurements, 'getArea', Type.MAIN);
        }

        function getMainArea(measurements) {
            return measurements.filter(compareGetter('getType', equal('main'))).pop();
        }

        function getAreas(measurements) {
            var mainArea = getMainArea(measurements);
            return measurementFactory.create({
                id: 'areasTotal',
                name: 'Area',
                area: getAreaTotal(measurements),
                dimensions: mainArea ? mainArea.getDimensions() : []
            });
        }

        function getCutoutTotal(measurements) {
            return sumMeasurementData(measurements, 'getArea', Type.CUTOUT);
        }

        function getCutouts(measurements) {
            return measurementFactory.create({
                id: 'cutoutsTotal',
                name: 'Cutouts',
                area: getCutoutTotal(measurements)
            });
        }

        function getAreaMinusCutouts(measurements) {
            return measurementFactory.create({
                id: 'areaMinusCutouts',
                name: 'Area - Cutouts',
                area: getAreaTotal(measurements) - getCutoutTotal(measurements)
            });
        }

        function getLineTotal(measurements) {
            return sumMeasurementData(measurements, 'getPerimeter', Type.LINE);
        }

        function getLines(measurements) {
            return measurementFactory.create({
                id: 'lineTotal',
                name: 'Line Sum',
                totalDimension: getLineTotal(measurements)
            });
        }

        function createMeasurements(measurementData) {
            return measurementData.map(measurementFactory.createMeasurement);
        }

        function createMeasurementsFromStorage(measurementData) {
            return [].concat(measurementData.main_polygons, measurementData.cutout_polygons, measurementData.polylines)
                .map(measurementFactory.createMeasurement);
        }

        function getMeasurement(id, measurements) {
            return measurements
                .concat([getAreas(measurements), getCutouts(measurements), getAreaMinusCutouts(measurements), getLines(measurements)])
                .filter(compareGetter('getId', equal(id)))
                .pop();
        }

        return {
            createMeasurements: createMeasurements,
            createMeasurementsFromStorage: createMeasurementsFromStorage,
            getCutouts: getCutouts,
            getAreaMinusCutouts: getAreaMinusCutouts,
            getLines: getLines,
            getAreas: getAreas,
            getMeasurement: getMeasurement
        };
    }
]);


/***/ }),
/* 521 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.measure').factory('measurementFactory', [

    function() {

        function Measurement(dimensions, _area, perimeter, name, id, type) {

            var area = _area;

            function getDimensions() {
                return dimensions || [];
            }

            function hasArea() {
                return !!area;
            }

            function isQuad() {
                return hasArea() && getDimensions().length === 4;
            }

            function getArea() {
                return hasArea() ? area : 0;
            }

            function setArea(value) {
                area = value;
            }

            function getPerimeter() {
                return perimeter ? perimeter : 0;
            }

            function getName() {
                return name || '';
            }

            function getId() {
                return id;
            }

            function getType() {
                return type;
            }

            function getWidth() {
                return isQuad() ? Math.max(getDimensions()[0], getDimensions()[2]) : 0;
            }

            return {
                getDimensions: getDimensions,
                getArea: getArea,
                getPerimeter: getPerimeter,
                getName: getName,
                getId: getId,
                hasArea: hasArea,
                isQuad: isQuad,
                getType: getType,
                setArea: setArea,
                getWidth: getWidth
            };
        }

        function create(measurementData) {
            return new Measurement(measurementData.dimensions, measurementData.area, measurementData.totalDimension,
                measurementData.name, measurementData.id, measurementData.type);
        }

        function createMeasurement(measurementData) {

            if (!measurementData) {
                throw new Error('Measurement data is required');
            }

            return new Measurement(measurementData.dimensions, measurementData.area, measurementData.totalDimension,
                measurementData.type, measurementData.id, measurementData.type);
        }

        return {
            createMeasurement: createMeasurement,
            create: create
        };
    }
]);


/***/ }),
/* 522 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.measure').factory('measurementFormatterService', ['ikemath', 'unitService', '$filter',
    function(ikemath, unitService, $filter) {

        var INCHES_IN_FEET = 12;
        var NON_BREAKING_SPACE = String.fromCharCode(160);
        var Units = ikemath.Units;

        var Decimals = {
            DEFAULT: 2
        };
        Decimals[Units.METER] = 2;
        Decimals[Units.CENTIMETER] = 1;
        Decimals[Units.FEET] = 1;
        Decimals[Units.INCH] = 1;

        function getDecimals(unit) {
            return Decimals[unit] || Decimals.DEFAULT;
        }

        function formatNumber(number, unit) {
            return $filter('number')(number, getDecimals(unit))
                .replace(new RegExp(NON_BREAKING_SPACE, 'g'), ' ');
        }

        function getSuffix() {
            var unit = unitService.getUnit();
            return Units.DISPLAY[unit];
        }

        function getAreaSuffix() {
            var unit = unitService.getUnit();
            return Units.DISPLAY_AREA[unit];
        }

        function convert(value) {
            var unit = unitService.getUnit();
            return Units.convert(value, Units.METER, unit);
        }

        function convertArea(value) {
            var unit = unitService.getUnit();
            return Units.convertArea(value, Units.METER, unit);
        }

        function separateFeetAndInches(inches) {
            var remainingInches = inches % INCHES_IN_FEET;
            return {
                feet: (inches - remainingInches) / INCHES_IN_FEET,
                inches: remainingInches
            };
        }

        function formatFeetAndInches(meters) {
            var convertedInches = Math.round(Units.convert(meters, Units.INCH, Units.METER));
            var separated = separateFeetAndInches(convertedInches);

            var formatted = separated.feet + Units.DISPLAY[Units.FEET];
            return separated.inches !== 0 ?
                formatted + ' ' + separated.inches + Units.DISPLAY[Units.INCH] :
                formatted;
        }

        function formatDistance(meters, unit) {
            var convertedNumber = Units.convert(meters, unit, Units.METER);
            return formatNumber(convertedNumber, unit) + Units.DISPLAY[unit];
        }

        function format(meters) {
            var unit = unitService.getUnit();
            return unit === Units.FEET ?
                formatFeetAndInches(meters) :
                formatDistance(meters, unit);
        }

        function formatArea(meters) {
            var unit = unitService.getUnit();
            var convertedNumber = Units.convertArea(meters, unit, Units.METER);
            return formatNumber(convertedNumber, unit) + Units.DISPLAY_AREA[unit];
        }

        return {
            format: format,
            formatArea: formatArea,
            convert: convert,
            convertArea: convertArea,
            getSuffix: getSuffix,
            getAreaSuffix: getAreaSuffix
        };
    }
]);


/***/ }),
/* 523 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike').directive('compositeImage', ['spikeCaptureService',
    function(spikeCaptureService) {

        return {
            restrict: 'E',
            replace: true,
            scope: {
                capture: '=',
                scaled: '@'
            },
            link: function($scope, $element, $attrs) {

                $scope.$watch('capture', function() {
                    if (!$scope.capture) {
                        return;
                    }

                    $element.empty();
                    var capture = $scope.capture;

                    spikeCaptureService.getCaptureImage(capture, $attrs.scaled === 'y')
                        .then(function(image) {
                            $(image)
                                .addClass('CompositeImage-image')
                                .appendTo($element);

                            $element.append(capture.getMeasurementsSVG());
                        });
                });
            },
            template: '<div class="CompositeImage"></div>'
        };
    }
]);


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(525);

angular.module('ikeweb.spike')
    .directive('deskewedImage', ['spikeCaptureService',
        function(spikeCaptureService) {

            return {
                restrict: 'E',
                replace: true,
                templateUrl: TEMPLATE_URL,
                scope: {
                    capture: '=',
                    scaled: '@'
                },
                link: function($scope, $element, $attrs) {
                    $scope.$watch('capture', function() {
                        if (!$scope.capture) {
                            return;
                        }

                        var capture = $scope.capture;

                        spikeCaptureService.getCaptureImageDeskewed(capture, $attrs.scaled === 'y')
                            .then(function(url) {
                                $scope.src = url;
                                $scope.$apply();
                            });
                    });
                }
            };
        }
    ]);


/***/ }),
/* 525 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div>\n<loader ng-show=\"src == null\"/>\n<img ng-src=\"{{src}}\"/>\n</div>";
var id1="deskewed.image.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 526 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.gallery').controller('GalleryController', [
    '$scope',
    'spikeCaptureService',
    'SpikeUtil',
    'events',
    'confirmationService',
    '$translate',
    'billingService',
    'notificationService',
    function($scope, $spikeCaptureService, SpikeUtil, EVENTS, confirmationService, $translate, billingService, notificationService) {
        var currentFolder;
        $scope.shownCaptures = [];

        var loadingCaptures = true;

        function inFolder(capture) {
            return capture.isInFolder(currentFolder);
        }

        function filterCapturesInCurrentFolder() {
            $scope.shownCaptures = $scope.shownCaptures.filter(inFolder);
        }

        function refreshCaptureList() {
            loadingCaptures = true;

            var folderId = currentFolder == null ? null : currentFolder.getId();

            return $spikeCaptureService.listCaptures(folderId)
                .then(function(captures) {
                    $scope.shownCaptures = captures;
                    loadingCaptures = false;
                });
        }

        billingService.isOnPremium().then(function(isPro) {
            $scope.isPro = isPro;
        });

        $scope.isLoadingCaptures = function() {
            return loadingCaptures;
        };

        function filterByProperty(by, value) {
            return function(object) {
                return value ? object[by] === value : object[by];
            };
        }

        $scope.refresh = function() {
            refreshCaptureList();
        };

        $scope.selectAll = function() {
            $scope.shownCaptures.forEach(function(capture) {
                capture.$selected = true;
            });
        };

        $scope.deselectAll = function() {
            $scope.shownCaptures.forEach(function(capture) {
                capture.$selected = false;
            });
        };

        $scope.deleteSelectedCaptures = function() {
            var capturesToDelete = $scope.shownCaptures.filter(filterByProperty('$selected'));
            if (capturesToDelete.length === 0) {
                return;
            }

            confirmationService
                .confirm($translate.instant('NOTIFICATION.CAPTURE.DELETE_CAPTURE_TITLE'),
                    $translate.instant('NOTIFICATION.DELETE.CONFIRMATION'),
                    $translate.instant('NOTIFICATION.DELETE.CONFIRM'),
                    $translate.instant('NOTIFICATION.DELETE.CANCEL'))
                .then(function() {
                    $spikeCaptureService.deleteCaptures(capturesToDelete)
                        .then(refreshCaptureList);
                });
        };

        $scope.isEmpty = function() {
            return $scope.shownCaptures.length === 0;
        };

        $scope.$on(EVENTS.FOLDER.SELECTED, function(event, folder) {
            currentFolder = folder;
            $scope.shownCaptures = [];
            refreshCaptureList();
        });

        $scope.$on(EVENTS.FOLDER.CAPTURE.DROPPED, function(evt, data) {
            var targetCaptures = $scope.shownCaptures.filter(filterByProperty('$selected'));
            if (!$scope.isPro && targetCaptures.length > 0) {
                targetCaptures = [];
                notificationService.info('NOTIFICATION.CAPTURE.MULTISELECT_IS_PRO_TITLE', 'NOTIFICATION.CAPTURE.MULTISELECT_IS_PRO')();
            }

            if (targetCaptures.length === 0) {
                targetCaptures.push(data.capture);
            }

            $spikeCaptureService.putCapturesInFolder(targetCaptures, data.folder)
                .then(filterCapturesInCurrentFolder);
        });
    }
]);


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(528);

angular.module('ikeweb.spike.gallery').directive('galleryItem', ['$translate', function($translate) {

    function setSelectable($scope, $element, $attrs) {
        if ($attrs.notselectable !== undefined) {
            $scope.notselectable = true;
            $element.addClass('GalleryItem--noborder');
            $element.addClass('GalleryItem--shadowborder');
        }
    }

    function setDraggable($element, capture) {
        $element
            .data('capture', capture)
            .draggable({
                revert: 'invalid',
                helper: function() {

                    var newElement = $element.clone()
                        .find('.GalleryItem-cover, .GalleryItem-dragHandle')
                        .remove()
                        .end()
                        .addClass('GalleryItem-dragging')
                        .width($element.width())
                        .height($element.height())
                        .data('dropped', false);

                    var elements = $('.GalleryItem--selected');
                    if (elements.length > 0) {
                        var description = $('<div>' + elements.length + ' ' + $translate.instant('COMPONENT.GALLERY_ITEM.CAPTURES') + '</div>');
                        description.addClass('GalleryItem-title');
                        var title = newElement.find('.GalleryItem-title');
                        title.html(description); // change the title to reflect number of captures
                    }

                    newElement.css('zIndex', $element.css('zIndex'));
                    return newElement;
                },
                handle: '.GalleryItem-dragHandle',
                appendTo: 'body',
                containment: 'parent',
                distance: 0,
                delay: 0,
                cursorAt: {
                    left: 12,
                    top: 10
                },
                start: function() {
                    $('.GalleryItem--selected').each(function(i, el) {
                        $(el).fadeTo(200, 0.5);
                    });
                    // select all elements that are selected, fade them
                    // take the count of selected elements
                },
                stop: function(evt, ui) {
                    $('.GalleryItem--selected').each(function(i, el) {
                        $(el).fadeTo(200, 1);
                    });
                }
            });
    }

    function setInputKeybind($element) {
        var $input = $element.find('.GalleryItem-captureName');
        $input
            .bind('keypress', function(event) {
                if (event.which === 13) {
                    $input.blur();
                }
            })
            .bind('dblclick', function() {
                $input.select();
            });
    }

    return {
        restrict: 'E',
        controller: 'GalleryItemController',
        controllerAs: 'ctrl',
        replace: true,
        templateUrl: TEMPLATE_URL,
        scope: {
            capture: '=',
            visibleEvent: '@'
        },
        link: function($scope, $element, $attrs, ctrl) {
            $scope.isReadOnly = true;
            $scope.notdraggable = $attrs.notdraggable !== undefined;

            setSelectable($scope, $element, $attrs);
            setInputKeybind($element);

            if (!$scope.notdraggable) {
                setDraggable($element, $scope.capture);
            }

            ctrl.blurInput = function() {
                $element.find('.GalleryItem-captureName').blur();
            };
        }
    };
}]);


/***/ }),
/* 528 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"GalleryItem\" ng-class=\"{'GalleryItem--selected' : capture.$selected}\">\n<a ng-click=\"capture.$selected = !capture.$selected\" class=\"GalleryItem-selectedbutton\"></a>\n<div class=\"GalleryItem-inner\">\n<lazy-load class=\"GalleryItem-image\" load-event=\"{{visibleEvent}}\">\n<composite-image class=\"GalleryItem-image-composite\" capture=\"capture\" scaled=\"y\"></composite-image>\n</lazy-load>\n<div class=\"GalleryItem-cover\">\n<a class=\"GalleryItem-openbutton\" href=\"#/photoMeasure/{{ capture.id }}\">\n<span>{{ 'COMPONENT.GALLERY_ITEM.MEASURE' | translate }}</span>\n</a>\n<a ng-if=\"!notselectable\" class=\"GalleryItem-selectbutton\" ng-click=\"capture.$selected = !capture.$selected\">\n<span> </span>\n</a>\n<i ng-if=\"!notdraggable\" class=\"GalleryItem-dragHandle\"></i>\n</div>\n<div class=\"GalleryItem-title\">\n<input title=\"{{ 'COMPONENT.GALLERY_ITEM.DOUBLE_CLICK_TO_RENAME' | translate }}\" class=\"GalleryItem-captureName\" ng-dblclick=\"ctrl.enableEditing()\" ng-blur=\"ctrl.rename()\" ng-class=\"{'read-only': isReadOnly}\" ng-readonly=\"isReadOnly\" placeholder=\"{{ 'COMPONENT.CAPTURE.NEW_MEASUREMENT' | translate }}\" ng-model=\"captureName\">\n\n<a class=\"GalleryItem-reportButton\" ng-click=\"ctrl.goToReport()\" title=\"{{ 'COMPONENT.GALLERY_ITEM.OPEN_REPORT' | translate }}\"></a>\n</div>\n</div>\n</div>\n";
var id1="gallery.item.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 529 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.gallery').controller('GalleryItemController', ['$scope', 'spikeCaptureService', '$location', 'promiseFactory',

    function($scope, captureService, $location, promiseFactory) {

        function enableEditing() {
            $scope.isReadOnly = false;
        }

        function disableEditing() {
            $scope.isReadOnly = true;
        }

        function setCaptureName() {
            $scope.captureName = $scope.capture.getName();
        }

        function rename() {
            disableEditing();
            if ($scope.captureName !== $scope.capture.getName()) {
                return captureService.renameCapture($scope.capture, $scope.captureName)
                    .then(setCaptureName);
            }
            return promiseFactory.resolvedPromise();
        }

        function goToReport() {
            this.blurInput();
            rename().then(function() {
                $location.path('photoMeasure/' + $scope.capture.id + '/report');
            });
        }

        setCaptureName();

        this.rename = rename;
        this.goToReport = goToReport;
        this.enableEditing = enableEditing;
        this.disableEditing = disableEditing;
    }
]);


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

angular.module('ikeweb.spike.measure').provider('photogrammetryToolKit', function() {

    var pm = __webpack_require__(531);

    return {
        setStyles: function(styles) {
            Object.keys(styles).forEach(function(item) {
                pm.Measurement.Styles[item] = styles[item];
            });
        },
        $get: function() {
            return pm;
        }
    };
});


/***/ }),
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.measure').value('PhotoMeasure',

    function PhotoMeasure(photogrammetryToolKit, $window, capture, imgElement, svgElement, measurementFormatter, pubSubService, measureTopics, billingService) {
        var Measurement = photogrammetryToolKit.Measurement,
            SVG = photogrammetryToolKit.SVG;
        var canvas, calibratedImage, spikeViewPort;

        var activeMeasurement;
        var isPro;


        billingService.isOnPremium().then(function(pro) {
            isPro = pro;
        });

        function canCorrectPerspective() {
            return isPro;
        }

        function setActiveMeasurement() {
            activeMeasurement = Measurement.application.getActiveMeasurement();
        }

        function activateMeasurement(uuid) {
            Measurement.application.setActiveMeasurement(uuid);
        }

        function getActiveMeasurement() {
            return activeMeasurement;
        }

        function createSVGCanvas() {
            var h, w, nh, nw;
            w = imgElement.width;
            h = imgElement.height;
            nw = imgElement.naturalWidth;
            nh = imgElement.naturalHeight;
            var svg = SVG(svgElement).size(w, h);
            svg.viewbox(0, 0, nw, nh);
            return svg;
        }

        function publishReady() {
            pubSubService.publish(measureTopics.PHOTO_MEASURE.READY);
        }

        function publishUpdate() {
            pubSubService.publish(measureTopics.PHOTO_MEASURE.UPDATE);
        }

        function create() {
            Measurement.Application.EVENTS.emitter.on(Measurement.Application.EVENTS.MEASUREMENT.LOADED, publishReady);

            Measurement.Application.EVENTS.emitter.on(Measurement.Application.EVENTS.MEASUREMENT.UPDATED, publishUpdate);

            Measurement.Application.EVENTS.emitter.on(Measurement.Application.EVENTS.MEASUREMENT.SELECTED, setActiveMeasurement);

            canvas = createSVGCanvas();
            calibratedImage = new Measurement.CalibratedImage(imgElement, capture.hva, capture.vva, capture.distance, 'height');
            spikeViewPort = new Measurement.SpikeViewport(calibratedImage);
            /*eslint-disable */
            var ikeJSBridge = new Measurement.IkeToolsLibraryClientside(canvas, calibratedImage, spikeViewPort, capture.measurements, measurementFormatter);
            /*eslint-enable */

            Measurement.application.wonkingEnabled = true;
        }

        function destroy() {
            Measurement.Application.EVENTS.emitter.off(publishReady);
            Measurement.Application.EVENTS.emitter.off(publishUpdate);
        }

        function updateAllLabels() {
            Measurement.application.updateAllLabels();
        }

        function update() {
            canvas.size(imgElement.width, imgElement.height);
            calibratedImage.updateScale();
            spikeViewPort.notifyNewZoomScale(
                calibratedImage.getImageScaleFactor()
            );
        }

        function drawAreaFromAlignment() {
            Measurement.application.drawAreaFromAlignment();
        }

        function serialize() {
            return Measurement.application.save();
        }

        function showAlignment() {
            Measurement.application.showAlignment();
            Measurement.Layer.activate('alignment');
        }

        function showMeasurement() {
            Measurement.application.showMeasurement();
            Measurement.Layer.activate('main');
        }

        function getActiveLayerKey() {
            return Measurement.application.getActiveLayerKey();
        }

        function deleteActiveHandle() {
            Measurement.application.deleteActiveHandle();
        }

        function deleteActiveMeasurement() {
            Measurement.application.deleteActiveMeasurement();
        }

        function activateLayer(layerName) {
            Measurement.Layer.activate(layerName);
        }

        function getMeasurements() {
            return Measurement.application.getMeasurements();
        }

        function getImgElement() {
            return imgElement;
        }

        function isDrawing() {
            return Measurement.application.isDrawing();
        }

        function drawAlignmentFromPoints(points) {
            Measurement.application.drawAlignmentFromPoints(points);
        }

        function enableDrawing() {
            Measurement.application.enableDrawing();
        }

        function toggleDrawing() {

            if (isDrawing()) {
                Measurement.application.disableDrawing();
            } else {
                Measurement.application.enableDrawing();
            }
        }

        function canLockRectangle() {
            var activeHandle = Measurement.application.activeHandle;
            return activeHandle == null || activeHandle.parent.canWonk();
        }

        function isRectangleLocked() {
            return Measurement.application.wonkingEnabled;
        }

        function toggleRectangleLock() {
            return Measurement.application.wonkingEnabled = !Measurement.application.wonkingEnabled;
        }

        create();

        return {
            updateAllLabels: updateAllLabels,
            update: update,
            drawAreaFromAlignment: drawAreaFromAlignment,
            serialize: serialize,
            showAlignment: showAlignment,
            showMeasurement: showMeasurement,
            getActiveLayerKey: getActiveLayerKey,
            getActiveMeasurement: getActiveMeasurement,
            activateMeasurement: activateMeasurement,
            deleteActiveHandle: deleteActiveHandle,
            deleteActiveMeasurement: deleteActiveMeasurement,
            activateLayer: activateLayer,
            getMeasurements: getMeasurements,
            getImgElement: getImgElement,
            enableDrawing: enableDrawing,
            toggleDrawing: toggleDrawing,
            isDrawing: isDrawing,
            destroy: destroy,
            canLockRectangle: canLockRectangle,
            isRectangleLocked: isRectangleLocked,
            toggleRectangleLock: toggleRectangleLock,
            drawAlignmentFromPoints: drawAlignmentFromPoints,
            canCorrectPerspective: canCorrectPerspective
        };
    });


/***/ }),
/* 569 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.measure').service('PhotoMeasureBuilder', ['PhotoMeasure', 'photogrammetryToolKit', 'promiseFactory', '$window', 'pubSubService', 'measureTopics', 'billingService',

    function(PhotoMeasure, photogrammetryToolKit, promiseFactory, $window, pubSubService, measureTopics, billingService) {

        function PhotoMeasureBuilder(deferredInstance) {

            var _capture, _imgElement, _svgElement, _measurementFormatter;

            function whenInstantiated() {
                return deferredInstance.promise;
            }

            function withCapture(capture) {
                _capture = capture;
                return this;
            }

            function withImgElement(imgElement) {
                _imgElement = imgElement;
                return this;
            }

            function withSVGElement(svgElement) {
                _svgElement = svgElement;
                return this;
            }

            function withMeasurementFormatter(measurementFormatter) {
                _measurementFormatter = measurementFormatter;
                return this;
            }

            function build() {
                var photoMeasure = new PhotoMeasure(photogrammetryToolKit, $window, _capture, _imgElement, _svgElement, _measurementFormatter, pubSubService, measureTopics, billingService);
                deferredInstance.resolve(photoMeasure);
                return deferredInstance.promise;
            }

            return {
                whenInstantiated: whenInstantiated,
                withCapture: withCapture,
                withImgElement: withImgElement,
                withSVGElement: withSVGElement,
                withMeasurementFormatter: withMeasurementFormatter,
                build: build
            };
        }

        this.create = function() {
            return new PhotoMeasureBuilder(promiseFactory.deferredValue());
        };
    }
]);


/***/ }),
/* 570 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.measure').directive('photoMeasure', ['functional', '$timeout', 'spikeImageService', 'billingService',
    function(functional, $timeout, spikeImageService, billingService) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                imageElement: '=',
                photoMeasureBuilder: '=',
                canCorrectPerspective: '='
            },
            link: function($scope, $element) {
                // Used to hide flash of unstyled content during load
                $scope.ready = false;

                var element = $element.get(0);
                var mainImage = element.querySelector('.PhotoMeasure-image');
                var container = element.querySelector('.PhotoMeasure-svgWrapper');
                var observer;



                function buildPhotomeasure(imageEl) {
                    return spikeImageService.setImageSrc(mainImage, imageEl.src)
                        .then(function() {
                            return $scope.photoMeasureBuilder
                                .withImgElement(mainImage)
                                .withSVGElement(container)
                                .build()
                                .then(function(photoMeasure) {
                                    $scope.ready = true;

                                    var debouncedUpdate = functional.debounce(photoMeasure.update, 20, $timeout);

                                    $(window).resize(debouncedUpdate);

                                    observer = new window.MutationObserver(debouncedUpdate)
                                        .observe(element, {
                                            attributes: true,
                                            attributeFilter: ['style']
                                        });

                                    photoMeasure.update();

                                    $scope.$on('$destroy', photoMeasure.destroy);
                                });
                        });
                }

                $scope.$watch('imageElement', function(imageElement) {
                    if (imageElement) {
                        buildPhotomeasure(imageElement);
                    }
                });

                $scope.$on('$destroy', function() {
                    if (observer) {
                        observer.disconnect();
                    }
                });
            },
            template: '<div ng-show="ready" class="PhotoMeasure"><img class="PhotoMeasure-image"></img><div class="PhotoMeasure-svgWrapper"></div></div>'
        };
    }
]);


/***/ }),
/* 571 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.measure').controller('PhotoMeasureViewController', [
    '$scope',
    '$stateParams',
    'spikeCaptureService',
    'unitService',
    'pubSubService',
    'measureTopics',
    'userTopics',
    'measurementService',
    'measurementFormatterService',
    'promiseFactory',
    'STEPS',
    'stepService',
    'PhotoMeasureBuilder',
    'zoomServiceFactory',
    '$location',
    '$timeout',
    'localeTopics',
    'billingService',
    'notificationService',
    '$analytics',
    'photogrammetryToolKit',
    function($scope,
        $stateParams,
        $spikeCaptureService,
        unitService,
        pubSubService,
        measureTopics,
        userTopics,
        measurementService,
        measurementFormatterService,
        promiseFactory,
        STEPS,
        stepService,
        PhotoMeasureBuilder,
        zoomServiceFactory,
        $location,
        $timeout,
        localeTopics,
        billingService,
        notificationService,
        $analytics,
        photogrammetryToolKit) {

        $scope.STEPS = STEPS;
        var LAYERS = {
            ALIGNMENT: 'alignment',
            MAIN: 'main',
            CUTOUT: 'cutout',
            LINE: 'line'
        };

        var EVENT_TYPES = {
            AUTO_ACCEPTED: 'auto_accepted',
            AUTO_REJECTED: 'auto_rejected',
            MANUAL: 'manual',
            UNKNOWN: 'unknown',
            DEFAULT: 'default'
        };
        var perspectiveCorrectionState = EVENT_TYPES.UNKNOWN;
        var Measurement = photogrammetryToolKit.Measurement;

        $scope.LAYERS = LAYERS;
        var captureId = $stateParams.spikeid;

        var photoMeasure;
        var photoMeasureBuilder = PhotoMeasureBuilder
            .create()
            .withMeasurementFormatter(measurementFormatterService);

        function updateState() {
            if (perspectiveCorrectionState === EVENT_TYPES.AUTO_ACCEPTED || perspectiveCorrectionState === EVENT_TYPES.AUTO_REJECTED) {
                perspectiveCorrectionState = EVENT_TYPES.AUTO_REJECTED;
            } else {
                perspectiveCorrectionState = EVENT_TYPES.MANUAL;
            }
        }

        function trackPerspectiveCorrection(eventType, capture) {
            if (!photoMeasure.canCorrectPerspective() || stepService.getCurrentStep() !== STEPS.ALIGN) {
                //don't track event where user doesn't have the option to use perspective correction
                return;
            }
            var event = {
                category: 'perspective',
                action: eventType,
                label: capture && capture.id,
                value: 1
            };
            $analytics.eventTrack(eventType, event);
        }

        function setCapture(capture) {
            photoMeasureBuilder.withCapture(capture);
            $scope.capture = capture;
            $scope.note = capture.getNote();
            return capture;
        }

        function setCaptureImage(image) {
            $scope.photoMeasureImage = image;
        }

        function fetchImage(capture) {
            return $spikeCaptureService.getCaptureImage(capture);
        }

        if (captureId) {
            $spikeCaptureService.getCapture(captureId)
                .then(setCapture)
                .then(fetchImage)
                .then(setCaptureImage)
                .catch(function() {
                    $timeout(function() {
                        $location.path('gallery');
                    }, 1000);
                });
        }

        function isLayerActive(layerName) {
            return photoMeasure && photoMeasure.getActiveLayerKey() === layerName;
        }

        function isPanMode() {
            return !!photoMeasure && !photoMeasure.isDrawing();
        }

        function togglePanMode() {
            photoMeasure.toggleDrawing();
        }

        function setPanModeForEnteringStep(step) {
            if ((step === STEPS.ALIGN && !isPanMode()) || step === STEPS.MEASURE && isPanMode()) {
                togglePanMode();
            }
        }

        function showCorrectLayersFor(step) {

            switch (step) {
                case STEPS.ALIGN:
                    photoMeasure.showAlignment();
                    break;

                case STEPS.MEASURE:
                    photoMeasure.showMeasurement();
                    break;
            }
        }

        function getUserStepOrCaptureStep() {
            return stepService.getCurrentStep() || ($scope.capture.isAlignmentDone() ? STEPS.MEASURE : STEPS.ALIGN);
        }

        function changeStepAndShowCorrectLayer(step) {
            stepService.changeStep(step);
            showCorrectLayersFor(step);
            setPanModeForEnteringStep(step);
        }

        function saveMeasurements() {
            return $spikeCaptureService.saveMeasurementsForCapture($scope.capture, photoMeasure.serialize());
        }

        function saveNote() {
            return $spikeCaptureService.saveNoteForCapture($scope.capture, $scope.note);
        }

        function save() {
            var returnPromise = promiseFactory.promise();

            if (photoMeasure) {
                returnPromise = saveMeasurements();
            }


            return returnPromise.then(saveNote)
                .then(function() {
                    return $scope.capture.save();
                });
        }

        function saveThenChangeStep(step) {
            save()
                .then(function() {
                    return trackPerspectiveCorrection(perspectiveCorrectionState, $scope.capture);
                })
                .then(function() {
                    return changeStepAndShowCorrectLayer(step);
                });
        }

        function getMeasurements() {
            $scope.measurements = measurementService.createMeasurements(photoMeasure.getMeasurements());
        }

        function getNote(notes) {
            $scope.note = notes;
        }

        function updateLabels() {
            photoMeasure.updateAllLabels();
        }

        function photoMeasureInstantiated() {
            return photoMeasure !== undefined;
        }

        function init(photoMeasureInstance) {
            photoMeasure = photoMeasureInstance;
            changeStepAndShowCorrectLayer(getUserStepOrCaptureStep());
            getMeasurements();

            pubSubService.subscribe(measureTopics.NOTE.UPDATE, getNote);
            pubSubService.subscribe(measureTopics.PHOTO_MEASURE.UPDATE, getMeasurements);
            pubSubService.subscribe(userTopics.PREFERENCES.UPDATED, updateLabels);
            pubSubService.subscribe(localeTopics.LOCALE.CHANGED, updateLabels);

            $scope.$on('$destroy', function() {
                pubSubService.unsubscribe(measureTopics.NOTE.UPDATE, getNote);
                pubSubService.unsubscribe(measureTopics.PHOTO_MEASURE.UPDATE, getMeasurements);
                pubSubService.unsubscribe(userTopics.PREFERENCES.UPDATED, updateLabels);
                pubSubService.unsubscribe(localeTopics.LOCALE.CHANGED, updateLabels);
            });
        }

        photoMeasureBuilder.whenInstantiated()
            .then(init);

        this.getAutoAlignmentPolygon = function() {
            if (!photoMeasure.canCorrectPerspective()) {
                notificationService.info('NOTIFICATION.CAPTURE.PERSPECTIVE_CORRECT_IS_PRO_TITLE', 'NOTIFICATION.PERSPECTIVE_CORRECT_IS_PRO')();
                return;
            }
            notificationService.info('NOTIFICATION.CAPTURE.PERSPECTIVE_CORRECT_IN_PROGRESS_TITLE', 'NOTIFICATION.CAPTURE.PERSPECTIVE_CORRECT_IN_PROGRESS')();
            return $spikeCaptureService.getAutoAlignmentPolygon($scope.capture)
                .then(function(aa) {
                    perspectiveCorrectionState = EVENT_TYPES.AUTO_ACCEPTED;
                    photoMeasure.drawAlignmentFromPoints(aa.metaData.alignment);
                    $scope.capture.save();
                });
        };

        this.resetAlignment = function() {
            if (!photoMeasure.canCorrectPerspective()) {
                return;
            }
            if (perspectiveCorrectionState === EVENT_TYPES.AUTO_ACCEPTED) {
                perspectiveCorrectionState = EVENT_TYPES.AUTO_REJECTED;
            } else {
                perspectiveCorrectionState = EVENT_TYPES.DEFAULT;
            }

            photoMeasure.drawAlignmentFromPoints();
            $scope.capture.save();
        };

        this.photoMeasureInstantiated = photoMeasureInstantiated;

        this.getPhotoMeasureBuilder = function() {
            return photoMeasureBuilder;
        };

        this.drawAreaFromAlignment = function() {
            photoMeasure.drawAreaFromAlignment();
        };

        this.save = save;

        this.getActiveMeasurement = function() {
            return photoMeasure ? photoMeasure.getActiveMeasurement() : null;
        };

        this.activateMeasurement = function(uuid) {
            photoMeasure.activateMeasurement(uuid);
        };

        this.deleteActiveHandle = function() {
            photoMeasure.deleteActiveHandle();
        };

        this.deleteActiveMeasurement = function() {
            photoMeasure.deleteActiveMeasurement();
        };

        this.activate = function(layerName) {
            photoMeasure.activateLayer(layerName);
            photoMeasure.enableDrawing();
        };

        this.canLockRectangle = function() {
            return photoMeasure != null && photoMeasure.canLockRectangle();
        };

        this.isRectangleLocked = function() {
            return photoMeasure != null && photoMeasure.isRectangleLocked();
        };

        this.toggleRectangleLock = function() {
            return photoMeasure != null && photoMeasure.toggleRectangleLock();
        };

        this.canCorrectPerspective = function() {
            return photoMeasure != null && photoMeasure.canCorrectPerspective();
        };

        this.isCurrentStep = stepService.isCurrentStep;
        this.isLayerActive = isLayerActive;

        this.saveThenChangeStep = saveThenChangeStep;

        this.isPanMode = isPanMode;
        this.togglePanMode = togglePanMode;

        var exposeZoomServiceMethods = function(zoomService) {
            this.setZoom = zoomService.setZoom;
            this.getZoom = zoomService.getZoom;
            this.zoomIn = zoomService.zoomIn;
            this.zoomOut = zoomService.zoomOut;
            this.setViewPortScaleFactor = zoomService.setViewPortScaleFactor;
        }.bind(this);

        this.zoomService = zoomServiceFactory.create();
        exposeZoomServiceMethods(this.zoomService);
        Measurement.Application.EVENTS.emitter.on(Measurement.Application.EVENTS.DRAWING.STARTED, updateState);
    }
]);


/***/ }),
/* 572 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.measure').controller('MeasurementsDetailController', ['$scope', 'selectedMeasurementService', 'measurementService',
    'pubSubService', 'measureTopics',
    function($scope, selectedMeasurementService, measurementService, pubSubService, measureTopics) {
        var self = this;

        function getMeasurements() {
            return self.measurements || [];
        }

        function isSelectedMeasurement(id) {
            var measurement = selectedMeasurementService.getMeasurement();
            return !!measurement && measurement.getId() === id;
        }

        function isMeasurementActive(id) {
            return !!self.activeMeasurement && self.activeMeasurement.id === id;
        }

        function getAreas() {
            return measurementService.getAreas(getMeasurements());
        }

        function getCutouts() {
            return measurementService.getCutouts(getMeasurements());
        }

        function getAreaMinusCutouts() {
            return measurementService.getAreaMinusCutouts(getMeasurements());
        }

        function getLines() {
            return measurementService.getLines(getMeasurements());
        }

        function setSelected(measurement) {
            selectedMeasurementService.setMeasurement(measurement);
        }

        function updateSelectedMeasurement() {
            var measurement = selectedMeasurementService.getMeasurement();
            if (measurement) {
                var newMeasurement = measurementService.getMeasurement(measurement.getId(), getMeasurements());
                setSelected(newMeasurement);
            }
        }

        function noteUpdated() {
            pubSubService.publish(measureTopics.NOTE.UPDATE, self.note);
        }

        self.getAreas = getAreas;
        self.getCutouts = getCutouts;
        self.getAreaMinusCutouts = getAreaMinusCutouts;
        self.getLines = getLines;
        self.setSelected = setSelected;
        self.isSelectedMeasurement = isSelectedMeasurement;
        self.isMeasurementActive = isMeasurementActive;
        self.getMeasurements = getMeasurements;
        self.updateSelectedMeasurement = updateSelectedMeasurement;
        self.noteUpdated = noteUpdated;
    }
]);


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(574);
angular.module('ikeweb.spike.measure').directive('measurementsDetail', function() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            measurements: '=',
            activeMeasurement: '=',
            activateMeasurement: '=',
            note: '='
        },
        controller: 'MeasurementsDetailController',
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: TEMPLATE_URL,
        link: function($scope, $element, attrs, ctrl) {
            $scope.$watch('ctrl.measurements', ctrl.updateSelectedMeasurement);
            $scope.$watch('ctrl.note', ctrl.noteUpdated);

        }
    };
});


/***/ }),
/* 574 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"MeasurementsDetail\">\n<layout-container direction=\"column\">\n<layout-content>\n<div class=\"MeasurementsDetail-totals\">\n<h4 class=\"MeasurementsDetail-heading\">{{ 'COMPONENT.MEASUREMENTS_DETAIL.CALCULATIONS' | translate }}</h4>\n<div class=\"MeasurementsDetail-measurementTotals\">\n<h6 class=\"MeasurementsDetail-measurementTotalsHeading\">{{ 'COMPONENT.MEASUREMENTS_DETAIL.TOTAL' | translate }}</h6>\n<ul>\n<li class=\"MeasurementsDetail-measurementTotal static\">\n<span>{{ 'COMPONENT.MEASUREMENTS_DETAIL.AREA' | translate }}</span>\n<span>= {{ctrl.getAreas().getArea() | area}}</span>\n</li>\n<li class=\"MeasurementsDetail-measurementTotal static\">\n<span>{{ 'COMPONENT.MEASUREMENTS_DETAIL.CUTOUTS' | translate }}</span>\n<span>= {{ctrl.getCutouts().getArea() | area}}</span>\n</li>\n<li class=\"MeasurementsDetail-measurementTotal static\">\n<span>{{ 'COMPONENT.MEASUREMENTS_DETAIL.AREA' | translate }} <b>-</b> {{ 'COMPONENT.MEASUREMENTS_DETAIL.CUTOUTS' | translate }}</span>\n<span>= {{ctrl.getAreaMinusCutouts().getArea() | area}}</span>\n</li>\n<li class=\"MeasurementsDetail-measurementTotal static\">\n<span>{{ 'COMPONENT.MEASUREMENTS_DETAIL.LINE_SUM' | translate }}</span>\n<span>= {{ctrl.getLines().getPerimeter() | length}}</span>\n</li>\n</ul>\n</div>\n</div>\n</layout-content>\n<layout-content grow=\"true\">\n<scroll class=\"MeasurementsDetail-measurements\">\n<ul>\n<li class=\"MeasurementsDetail-measurement\" ng-repeat=\"measurement in ctrl.getMeasurements()\" title=\"{{ 'COMPONENT.MEASUREMENTS_DETAIL.CLICK_TO_SELECT' | translate }}\">\n<ul ng-class=\"{selected: ctrl.isMeasurementActive(measurement.getId())}\" ng-click=\"ctrl.activateMeasurement(measurement.getId())\">\n<li>\n<h6 class=\"MeasurementsDetail-measurementType\">{{ 'COMPONENT.MEASUREMENTS_DETAIL.' + measurement.getName() | uppercase | translate }}</h6>\n</li>\n<li>\n<span class=\"MeasurementsDetail-measurementValue\">{{measurement.getDimensions() | dimensions}}</span>\n</li>\n<li ng-show=\"measurement.hasArea()\">\n<span class=\"MeasurementsDetail-measurementValue\">{{ 'COMPONENT.MEASUREMENTS_DETAIL.AREA' | translate }} = {{ measurement.getArea() | area }}</span>\n</li>\n<li>\n<span class=\"MeasurementsDetail-measurementValue\">{{ 'COMPONENT.MEASUREMENTS_DETAIL.PERIMETER' | translate }} = {{ measurement.getPerimeter() | length }}</span>\n</li>\n</ul>\n</li>\n</ul>\n</scroll>\n</layout-content>\n<layout-content grow=\"true\">\n<div class=\"MeasurementsDetail-totals\">\n<h4 class=\"MeasurementsDetail-heading\">{{ 'COMPONENT.NOTES.HEADING' | translate }}</h4>\n<ul>\n<notes-listitem note=\"ctrl.note\"></notes-listitem>\n</ul>\n</div>\n</layout-content>\n</layout-container>\n</div>\n";
var id1="measurements.detail.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 575 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.measure').service('selectedMeasurementService', ['pubSubService', 'measureTopics', 'validationService',

    function(pubSubService, measureTopics, validation) {

        var validators = validation.validators,
            aString = validators.aString,
            empty = validators.empty,
            aNumber = validators.aNumber;
        var measurement;

        function setMeasurement(value) {
            return validation
                .validate(value.getId()).is(aString).is.not(empty)
                .validate(value.getName()).is(aString).is.not(empty)
                .validate(value.getArea()).is(aNumber)
                .validate(value.getPerimeter()).is(aNumber)
                .check()
                .then(function() {
                    measurement = value;
                    pubSubService.publish(measureTopics.MEASUREMENT.SELECTED);
                });
        }

        function getMeasurement() {
            return measurement;
        }

        function reset() {
            measurement = undefined;
        }

        return {
            getMeasurement: getMeasurement,
            setMeasurement: setMeasurement,
            reset: reset
        };
    }
]);


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(577);
angular.module('ikeweb.spike.measure').directive('accuracyWindow', ['photogrammetryToolKit',

    function(photogrammetryToolKit) {

        var Measurement = photogrammetryToolKit.Measurement;

        return {
            restrict: 'E',
            replace: true,
            scope: {
                imageElement: '='
            },
            templateUrl: TEMPLATE_URL,
            link: function($scope, $element) {

                function slideTo(x, y) {
                    $element.css({
                        /* 8 & 10  */
                        'background-position': (($element.width() / 2) - x) + 'px ' + (($element.height() / 2) - y) + 'px'
                    });
                }

                function update(coords) {
                    slideTo(coords.x, coords.y);
                }

                $scope.$watch('imageElement', function(imageElement) {

                    if (!imageElement) {
                        return;
                    }

                    $element.css({
                        'background-image': 'url(' + imageElement.src + ')'
                    });

                    Measurement.Application.EVENTS.emitter.on(Measurement.Application.EVENTS.DRAWING.STARTED, update);
                    Measurement.Application.EVENTS.emitter.on(Measurement.Application.EVENTS.DRAWING.UPDATED, update);
                    Measurement.Application.EVENTS.emitter.on(Measurement.Application.EVENTS.DRAWING.FINISHED, update);
                    slideTo(imageElement.naturalWidth / 2, imageElement.naturalHeight / 2);
                });
            }
        };
    }
]);


/***/ }),
/* 577 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"AccuracyWindow\">\n<div class=\"AccuracyWindow-crosshairv\"></div>\n<div class=\"AccuracyWindow-crosshairh\"></div>\n</div>";
var id1="accuracy.window.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 578 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.measure').factory('measureTopics',

    function() {

        return {
            PHOTO_MEASURE: {
                READY: {
                    name: 'photo.measure.ready'
                },
                UPDATE: {
                    name: 'photo.measure.updated'
                }
            },
            MEASUREMENT: {
                SELECTED: {
                    name: 'measurement.selected'
                }
            },
            NOTE: {
                UPDATE: {
                    name: 'measurement.note.updated'
                }
            }
        };
    });


/***/ }),
/* 579 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.report').controller('ReportController', [
    '$scope',
    '$rootElement',
    '$stateParams',
    '$analytics',
    'spikeCaptureService',
    'unitService',
    'measurementService',
    'captureSharingService',
    'events',
    'captureExportService',
    'zoomServiceFactory',
    'printService',
    function($scope,
        $rootElement,
        $stateParams,
        $analytics,
        $spikeCaptureService,
        unitService,
        measurementService,
        captureSharingService,
        EVENTS,
        captureExportService,
        zoomServiceFactory,
        printService) {

        var zoomService = zoomServiceFactory.create();
        var zoomArea,
            capture,
            measurements,
            note,
            shareURL;

        function createExportImage(captureImage) {
            var image = document.createElement('img');
            image.src = URL.createObjectURL(captureImage.getData());
            image.className = 'pages-report-exportImage';
            return image;
        }

        function trackExport(exportType, capture) {
            var event = {
                category: 'Export',
                action: exportType,
                label: capture && capture.id,
                value: 1
            };
            $analytics.eventTrack(exportType, event);
        }

        function createExportReport() {
            var $reportPageClone = $rootElement.find('.pages-report-page').clone();
            var eventType = (capture.note != null && capture.note !== '') ? 'PDFWithNote' : 'PDF';
            trackExport(eventType, capture);
            return captureExportService
                .imageWithMeasurements(capture, zoomArea.serialize())
                .then(createExportImage)
                .then(function(exportImage) {
                    $reportPageClone
                        .find('.pages-report-compositeImage')
                        .replaceWith(exportImage);
                    return $reportPageClone;
                });
        }

        function print() {
            createExportReport()
                .then(printService.printElement);
        }

        function download() {
            $scope.$broadcast(EVENTS.EXPORT.DISPLAY_EXPORT_SELECTOR);
        }

        function imageExport(fn) {
            if (zoomService.getZoom() !== 0) {
                return fn(capture, zoomArea.serialize())
                    .then(captureExportService.download);
            }
            return fn(capture)
                .then(captureExportService.download);
        }

        function shareCaptureURL() {
            return captureSharingService.shareCapture(capture, unitService.getUnit(), zoomArea.serialize())
                .then(function(URL) {
                    shareURL = URL;
                    $scope.$broadcast(EVENTS.SHARING.DISPLAY_SHARE_URL);
                });
        }

        function setZoomArea(value) {
            zoomArea = value;
        }

        function getCapture() {
            return capture;
        }

        function getMeasurements() {
            return measurements;
        }

        function getNote() {
            return note;
        }

        function getShareURL() {
            return shareURL;
        }

        function init() {
            $scope.$on(EVENTS.EXPORT.DOWNLOAD.COMPOSITE, function() {
                imageExport(captureExportService.imageWithMeasurements);
                $scope.$broadcast(EVENTS.EXPORT.DISMISS_EXPORT_SELECTOR);
            });

            $scope.$on(EVENTS.EXPORT.DOWNLOAD.DESKEWED, function() {
                imageExport(captureExportService.deskewed);
                $scope.$broadcast(EVENTS.EXPORT.DISMISS_EXPORT_SELECTOR);
            });

            $scope.$on(EVENTS.EXPORT.DOWNLOAD.IMAGEONLY, function() {
                imageExport(captureExportService.imageOnly);
                $scope.$broadcast(EVENTS.EXPORT.DISMISS_EXPORT_SELECTOR);
            });


            $spikeCaptureService.getCapture($stateParams.spikeid)
                .then(function(value) {
                    capture = value;
                    measurements = measurementService.createMeasurementsFromStorage(capture.measurements);
                    note = capture.note;
                    return capture;
                });
        }

        this.print = print;
        this.download = download;
        this.shareCaptureURL = shareCaptureURL;
        this.setZoomArea = setZoomArea;
        this.zoomIn = zoomService.zoomIn;
        this.zoomOut = zoomService.zoomOut;
        this.getZoom = zoomService.getZoom;
        this.setZoom = zoomService.setZoom;
        this.setViewPortScaleFactor = zoomService.setViewPortScaleFactor;
        this.getCapture = getCapture;
        this.getMeasurements = getMeasurements;
        this.getNote = getNote;
        this.getShareURL = getShareURL;

        init();
    }
]);


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(581);
angular.module('ikeweb.spike.report').directive('reportPage', [

    function() {
        return {
            replace: true,
            restrict: 'E',
            scope: {
                heading: '=',
                measurements: '=',
                units: '=',
                note: '='
            },
            templateUrl: TEMPLATE_URL,
            transclude: true
        };
    }
]);


/***/ }),
/* 581 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<article class=\"ReportPage\">\n<header>\n<h3>{{ heading || 'Photo Measurement'}}</h3>\n<i></i>\n</header>\n<section>\n<h3>{{ 'COMPONENT.REPORT_PAGE.CAPTURE' | translate }}</h3>\n<div class=\"ReportPage-capture\" ng-transclude></div>\n</section>\n<section ng-show=\"measurements.length > 0\" class=\"ReportPage-measurements\">\n<table>\n<caption>\n<h3>{{ 'COMPONENT.REPORT_PAGE.MEASUREMENTS' | translate }}</h3>\n</caption>\n<thead>\n<tr>\n<th>{{ 'COMPONENT.REPORT_PAGE.SHAPE' | translate }}</th>\n<th>{{ 'COMPONENT.REPORT_PAGE.AREA' | translate }}</th>\n<th>{{ 'COMPONENT.REPORT_PAGE.PERIMETER' | translate }}</th>\n<th>{{ 'COMPONENT.REPORT_PAGE.DIMENSIONS' | translate }}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"measurement in measurements\">\n<td>{{ 'COMPONENT.REPORT_PAGE.' + measurement.getName() | uppercase | translate }}</td>\n<td>\n<span ng-show=\"measurement.getArea()\">{{ measurement.getArea() | area }}</span>\n</td>\n<td>{{ measurement.getPerimeter() | length }}</td>\n<td>{{ measurement.getDimensions() | dimensions }}</td>\n</tr>\n</tbody>\n</table>\n</section>\n<section ng-show=\"note != null && note.length > 0\" class=\"ReportPage-measurements\">\n<table>\n<caption>\n<h3>{{ 'COMPONENT.REPORT_PAGE.NOTES' | translate }}</h3>\n</caption>\n<tbody>\n<tr>\n<td>\n<span>{{ note }}</span>\n</td>\n</tr>\n</tbody>\n</table>\n</section>\n</article>";
var id1="report.page.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 582 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.capture').factory('spikeImageService', ['$q', function spikeImageService($q) {
    return {
        setImageSrc: function(imageElement, url) {
            var deferred = $q.defer();

            imageElement.src = url;

            if (imageElement.complete) {
                // Chrome and Firefox will set image immeditaly if the image is already loaded elsewhere on the page
                deferred.resolve(imageElement);
            } else {
                function fulfil() {
                    imageElement.removeEventListener('load', fulfil);
                    imageElement.removeEventListener('error', fulfil);

                    if (imageElement.naturalWidth) {
                        deferred.resolve(imageElement);
                    } else {
                        deferred.reject('Image failed to load');
                    }
                }

                imageElement.addEventListener('load', fulfil);
                imageElement.addEventListener('error', fulfil);
            }

            return deferred.promise;
        }
    };
}]);


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(584);

angular.module('ikeweb.spike')
    .directive('loader', function() {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: TEMPLATE_URL,
            scope: true,
            link: function($scope, $element, $attrs) {}
        };
    });


/***/ }),
/* 584 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"loader\">\n{{ 'PHOTO_MEASURE.LOADING' | translate }}\n</div>";
var id1="loader.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 585 */
/***/ (function(module, exports) {

angular.module('ikeweb.map', [
        'ikeweb.spike.capture',
        'ikeweb.shared.map.leaflet',
        'ikeweb.shared.util',
        'ikeweb.shared.input',
        'ikeweb.shared.layout',
        'ikeweb.shared.messaging',
        'ikeweb.shared.map',
        'LocalStorageModule'
    ])
    .config(['leafletIkeMapFactoryProvider', '$provide', function(leafletIkeMapFactoryProvider, $provide) {
        $provide.provider('ikeMapFactory', leafletIkeMapFactoryProvider);
    }]);


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(587);
angular.module('ikeweb.map').directive('captureMap',
    function() {
        return {
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            replace: true,
            controller: 'CaptureMapController',
            controllerAs: 'ctrl',
            scope: {
                center: '='
            },
            bindToController: true,
            link: function($scope, $element, $attrs, ctrl) {
                ctrl.setElement($element.find('.CaptureMap'));
            }
        };
    }
);


/***/ }),
/* 587 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"CaptureMap-container\">\n<div class=\"CaptureMap\"></div>\n<div class=\"CaptureMap-zoomControls\">\n<ike-zoom-control get-zoom=\"ctrl.getZoom()\" set-zoom=\"ctrl.setZoom(zoom)\" on-zoomin-click=\"ctrl.zoomIn()\" on-zoomout-click=\"ctrl.zoomOut()\" min=\"3\" max=\"18\">\n</ike-zoom-control>\n<a class=\"CaptureMap-zoomFit\" ng-click=\"ctrl.zoomFit()\"></a>\n</div>\n</div>";
var id1="capture.map.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 588 */
/***/ (function(module, exports) {

angular.module('ikeweb.map').controller('CaptureMapController', ['captureMapFactory', 'pubSubService', 'captureMapTopics', 'mapTopics', 'functional', '$timeout',
    function(captureMapFactory, pubSubService, captureMapTopics, mapTopics, f, $timeout) {
        var self = this;
        var map;

        function setZoom(zoom) {
            map.setZoom(zoom);
        }

        function createMap(captures) {
            map = captureMapFactory.create(self.$element, self.center, captures);
            self.setZoom = f.debounce(setZoom, 50, $timeout);
            self.zoomIn = map.zoomIn;
            self.zoomOut = map.zoomOut;
            self.zoomFit = map.zoomToAllMarkers;
        }

        function destroy() {
            pubSubService.unsubscribe(captureMapTopics.MAP.CAPTURES.LOAD, createMap);
        }

        self.setElement = function($element) {
            $element.on('$destroy', destroy);
            self.$element = $element;
        };

        self.getZoom = function() {
            return map ? map.getZoom() : 0;
        };

        pubSubService.subscribe(captureMapTopics.MAP.CAPTURES.LOAD, createMap);
    }
]);


/***/ }),
/* 589 */
/***/ (function(module, exports) {

angular.module('ikeweb.map').service('captureMapFactory', ['CaptureMap', 'ikeMapFactory',
    function(CaptureMap, ikeMapFactory) {
        this.create = function($element, center, captures) {
            return new CaptureMap(ikeMapFactory.create($element), center, captures);
        };
    }
]);


/***/ }),
/* 590 */
/***/ (function(module, exports) {

angular.module('ikeweb.map').value('CaptureMap',
    function CaptureMap(ikemap, center, captures) {

        function addCapture(capture) {
            var location = capture.getTargetLocation();
            if (location == null || !capture.hasPosition()) {
                return;
            }

            ikemap.addMarker(location, capture.getId());
        }

        function loadCapturesAndSetCenter() {
            captures.forEach(addCapture);

            if (center && center.location && center.zoom) {
                ikemap.setCenter(center.location, center.zoom);
            } else {
                ikemap.zoomToAllMarkers();
            }
        }

        this.getZoom = ikemap.getZoom;
        this.setZoom = ikemap.setZoom;
        this.zoomIn = ikemap.zoomIn;
        this.zoomOut = ikemap.zoomOut;
        this.zoomToAllMarkers = ikemap.zoomToAllMarkers;

        loadCapturesAndSetCenter();
    }
);


/***/ }),
/* 591 */
/***/ (function(module, exports) {

angular.module('ikeweb.map').controller('MapViewController', ['$scope', 'spikeCaptureService', 'pubSubService', 'captureMapTopics', 'mapTopics', 'localStorageService',
    function($scope, spikeCaptureService, pubSubService, captureMapTopics, mapTopics, localStorageService) {

        var capturesOnMap = [];
        var selectedCaptureIds = [];

        function storeMapZoom(zoom) {
            localStorageService.set('map.zoom', zoom);
        }

        function storeMapLocation(location) {
            localStorageService.set('map.location', JSON.stringify(location));
        }

        function setSelectedCaptures(data) {
            selectedCaptureIds = data;
        }

        this.center = {
            location: JSON.parse(localStorageService.get('map.location')),
            zoom: localStorageService.get('map.zoom')
        };

        this.getSelectedCaptures = function() {
            return capturesOnMap.filter(function(capture) {
                return selectedCaptureIds.indexOf(capture.getId()) > -1;
            });
        };

        pubSubService.subscribe(mapTopics.MAP.ZOOM.CHANGE, storeMapZoom);
        pubSubService.subscribe(mapTopics.MAP.LOCATION.CHANGE, storeMapLocation);
        pubSubService.subscribe(mapTopics.MAP.MARKER.SELECTED, setSelectedCaptures);

        $scope.$on('$destroy', function() {
            pubSubService.unsubscribe(mapTopics.MAP.ZOOM.CHANGE, storeMapZoom);
            pubSubService.unsubscribe(mapTopics.MAP.LOCATION.CHANGE, storeMapLocation);
            pubSubService.unsubscribe(mapTopics.MAP.MARKER.SELECTED, setSelectedCaptures);
        });

        function setCapturesOnMap(captures) {
            capturesOnMap = captures;
            pubSubService.publish(captureMapTopics.MAP.CAPTURES.LOAD, capturesOnMap);
        }

        spikeCaptureService.listCaptures().then(setCapturesOnMap);
    }
]);


/***/ }),
/* 592 */
/***/ (function(module, exports) {

angular.module('ikeweb.map').factory('captureMapTopics', ['validationService',

    function(validation) {

        var validators = validation.validators;

        return {
            MAP: {
                CAPTURES: {
                    LOAD: {
                        name: 'map.captures.load',
                        validation: function(captures) {
                            validation
                                .validate(captures).is(validators.anArray)
                                .throwIfErrors();
                        }
                    }
                }
            }
        };
    }
]);


/***/ }),
/* 593 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.sharing').factory('captureSharingService', ['$window', 'captureFactory',

    function($window, captureFactory) {

        var SHARE_CAPTURE_FUNCTION = 'shareCapture',
            IMPORT_SHARED_CAPTURE_FUNCTION = 'importSharedCapture',
            SharedCapture = captureFactory.SharedCapture;

        function makeShareUrl(sharedCapture) {
            return $window.location.origin + '/#/measureView/' + sharedCapture.id;
        }

        function shareCapture(capture, units, zoomArea) {
            return Parse.Cloud.run(SHARE_CAPTURE_FUNCTION, {
                captureid: capture.id,
                units: units,
                zoomArea: zoomArea
            }).then(makeShareUrl);
        }

        function query() {
            return new Parse.Query(SharedCapture);
        }

        function getSharedCapture(id) {
            return query().get(id).then(function(capture) {
                capture.populate();
                return capture;
            });
        }

        function importSharedCapture(sharedCapture) {
            return Parse.Cloud.run(IMPORT_SHARED_CAPTURE_FUNCTION, {
                sharedcaptureid: sharedCapture.id
            });
        }

        return {
            shareCapture: shareCapture,
            getSharedCapture: getSharedCapture,
            importSharedCapture: importSharedCapture
        };
    }
]).config(['$provide',

    function($provide) {

        var functionsToDecorate = [
            'shareCapture',
            'getSharedCapture',
            'importSharedCapture'
        ];

        $provide.decorator('captureSharingService', ['$delegate', 'qPromiseDecoratorService',
            function($delegate, qPromiseDecoratorService) {
                return qPromiseDecoratorService
                    .decorateDelegateWithPromise($delegate, functionsToDecorate);
            }
        ]);

        $provide.decorator('captureSharingService', ['$delegate', 'parseErrorDecoratorService',
            function($delegate, parseErrorDecoratorService) {
                return parseErrorDecoratorService.decorateDelegatePromiseErrors($delegate, functionsToDecorate, {
                    101: 'CAPTURE_NOT_FOUND'
                });
            }
        ]);

        $provide.decorator('captureSharingService', ['$delegate', 'promiseProgressDecoratorService',
            function($delegate, promiseProgressDecoratorService) {
                return promiseProgressDecoratorService
                    .decorateDelegateWithProgress($delegate, functionsToDecorate);
            }
        ]);

        $provide.decorator('captureSharingService', ['$delegate', 'decoratedPromiseBuilder', 'notificationService',
            function($delegate, decoratedPromiseBuilder, notificationService) {

                return decoratedPromiseBuilder
                    .forDelegate($delegate)
                    .decorate('importSharedCapture')
                    .onSuccess(notificationService.success('NOTIFICATION.SHARING.IMPORT_CAPTURE', 'NOTIFICATION.SHARING.IMPORT_COMPLETE'))
                    .onError(notificationService.error('NOTIFICATION.SHARING.IMPORT_CAPTURE', 'NOTIFICATION.SHARING.IMPORT_PROBLEM'))
                    .fork();
            }
        ]);

        $provide.decorator('captureSharingService', ['$delegate', 'loggingDecorator',
            function($delegate, loggingDecorator) {
                return loggingDecorator.decorateDelegateWithLogging($delegate, functionsToDecorate);
            }
        ]);
    }
]);


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(595);
angular.module('ikeweb.spike.sharing').directive('shareUrl', ['events',

    function(EVENTS) {

        return {
            restrict: 'E',
            replace: true,
            templateUrl: TEMPLATE_URL,
            scope: {
                url: '@'
            },
            link: function($scope) {
                $scope.displayEvent = EVENTS.SHARING.DISPLAY_SHARE_URL;
                $scope.dismissEvent = EVENTS.SHARING.DISMISS_SHARE_URL;
            }
        };
    }
]);


/***/ }),
/* 595 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"ShareURL\">\n<ike-modal class=\"ShareURL\" title-text=\"{{ 'COMPONENT.SHARE_URL.SHARE_URL' | translate }}\" display-event=\"{{displayEvent}}\" dismiss-event=\"{{dismissEvent}}\">\n<ike-modal-content>\n<section class=\"ShareURL-section\">\n<p>{{ 'COMPONENT.SHARE_URL.HELP1' | translate }}</p>\n</section>\n<section class=\"ShareURL-section\">\n<div class=\"ShareURL-urlWrapper\">\n<label class=\"ShareURL-label\" for=\"ShareURL-url\">URL</label>\n<ike-input-text id=\"ShareURL-url\" class=\"ShareURL-url\" ng-model=\"url\" is-readonly=\"true\" autoselect=\"true\"></ike-input-text>\n</div>\n</section>\n<section class=\"ShareURL-section\">\n<p ng-bind-html=\"'COMPONENT.SHARE_URL.HELP2' | translate | html\"></p>\n</section>\n</ike-modal-content>\n<ike-modal-footer>\n<ike-button ng-click=\"$emit(dismissEvent)\" class=\"ShareURL-dismiss\">{{ 'COMPONENT.SHARE_URL.FINISH' | translate }}</ike-button>\n</ike-modal-footer>\n</ike-modal>\n</div>\n";
var id1="share.url.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 596 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.sharing').controller('MeasureViewController', [
    '$scope',
    '$rootElement',
    '$stateParams',
    'measurementService',
    'captureSharingService',
    '$location',
    'printService',
    'captureExportService',
    'loginService',

    function($scope, $rootElement, $stateParams, measurementService, captureSharingService, $location, printService, captureExportService, loginService) {
        var sharedCaptureId = $stateParams.sharedCaptureId;

        var ERROR_PATH = '/error/sharedCaptureNotFound';

        function redirectToErrorPage() {
            $location.path(ERROR_PATH);
        }

        if (!sharedCaptureId) {
            redirectToErrorPage();
        }

        function createImage(captureImage) {
            var image = document.createElement('img');
            image.src = URL.createObjectURL(captureImage.getData());
            return image;
        }

        function displayImage(image) {
            $rootElement.find('.pages-measureview-exportImageWrapper')
                .append(image);
        }

        captureSharingService.getSharedCapture(sharedCaptureId)
            .then(function(sharedCapture) {
                $scope.sharedCapture = sharedCapture;
                $scope.sharedMeasurements = measurementService.createMeasurementsFromStorage(sharedCapture.measurements);
                $scope.sharedNote = sharedCapture.note;
                return captureExportService.imageWithMeasurements(sharedCapture, sharedCapture.getZoomArea());
            }, redirectToErrorPage)
            .then(createImage)
            .then(displayImage);

        function print() {
            printService.printElement($rootElement.find('.pages-measureview-report-page'));
        }

        function canImportSharedCapture() {
            return loginService.isLoggedIn();
        }

        this.print = print;
        this.canImportSharedCapture = canImportSharedCapture;
        this.importSharedCapture = captureSharingService.importSharedCapture;
    }
]);


/***/ }),
/* 597 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.step', ['ikeweb.routes']);


/***/ }),
/* 598 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.step').value('STEPS', function() {
    var STEPS = {
        ALIGN: 'align',
        MEASURE: 'measure',
        REPORT: 'report'
    };

    STEPS.values = Object.keys(STEPS).map(function(key) {
        return STEPS[key];
    });

    return STEPS;
}());


/***/ }),
/* 599 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.step').factory('stepService', ['$stateParams', '$location', 'STEPS',
    function($stateParams, $location, STEPS) {

        function getLastPartOfPath() {
            return $location.path().split('/').pop();
        }

        function isAStep(value) {
            return STEPS.values.filter(function(step) {
                return step === value;
            }).length > 0;
        }

        function getCurrentStep() {
            return isAStep(getLastPartOfPath()) ?
                getLastPartOfPath() :
                undefined;
        }

        function isTransitionForbidden(step) {
            return getCurrentStep() === STEPS.ALIGN && step === STEPS.REPORT;
        }

        function isCurrentStep(step) {
            return !!(step && getCurrentStep() === step);
        }

        function changeStep(step) {
            if (isTransitionForbidden(step)) {
                return;
            }

            $location.path('/photoMeasure/' + $stateParams.spikeid + '/' + step);
        }

        return {
            isCurrentStep: isCurrentStep,
            changeStep: changeStep,
            getCurrentStep: getCurrentStep,
            isTransitionForbidden: isTransitionForbidden
        };
    }
]);


/***/ }),
/* 600 */
/***/ (function(module, exports) {

angular.module('ikeweb.spike.step').controller('BreadcrumbController', ['STEPS', 'stepService',
    function(STEPS, stepService) {
        this.STEPS = STEPS;

        this.changeStep = this.changeStep || stepService.changeStep;

        this.activeIfStepIs = function(step) {
            return stepService.isCurrentStep(step) ? 'active' : '';
        };

        this.isAlignmentDone = function() {
            return this.capture && this.capture.isAlignmentDone();
        };

        this.isTransitionForbidden = stepService.isTransitionForbidden;
    }
]);


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var TEMPLATE_URL = __webpack_require__(602);
angular.module('ikeweb.spike.step').directive('ikeBreadcrumb',
    function() {
        return {
            scope: {
                capture: '=',
                changeStep: '=?'
            },
            templateUrl: TEMPLATE_URL,
            controller: 'BreadcrumbController',
            controllerAs: 'ctrl',
            bindToController: true,
            replace: true
        };
    }
);


/***/ }),
/* 602 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"IkeBreadcrumb\">\n<button class=\"IkeBreadcrumb-button\" ng-class=\"ctrl.activeIfStepIs(ctrl.STEPS.ALIGN)\" ng-click=\"ctrl.changeStep(ctrl.STEPS.ALIGN)\" ng-disabled=\"ctrl.isTransitionForbidden(ctrl.STEPS.ALIGN)\">\n<div class=\"IkeBreadcrumb-buttoncontents\">\n<span>{{ 'COMPONENT.BREADCRUMB.ALIGN' | translate }}</span>\n<i class=\"IkeSidebar-alignmentDone glyphicon-tick-white-small\" ng-show=\"ctrl.isAlignmentDone()\"></i>\n</div>\n</button>\n<button class=\"IkeBreadcrumb-button\" ng-class=\"ctrl.activeIfStepIs(ctrl.STEPS.MEASURE)\" ng-click=\"ctrl.changeStep(ctrl.STEPS.MEASURE)\" ng-disabled=\"ctrl.isTransitionForbidden(ctrl.STEPS.MEASURE)\">\n<div class=\"IkeBreadcrumb-buttoncontents\">\n<span>{{ 'COMPONENT.BREADCRUMB.MEASURE' | translate }}</span>\n</div>\n</button>\n<button class=\"IkeBreadcrumb-button\" ng-class=\"ctrl.activeIfStepIs(ctrl.STEPS.REPORT)\" ng-click=\"ctrl.changeStep(ctrl.STEPS.REPORT)\" ng-disabled=\"ctrl.isTransitionForbidden(ctrl.STEPS.REPORT)\">\n<div class=\"IkeBreadcrumb-buttoncontents\">\n<span>{{ 'COMPONENT.BREADCRUMB.REPORT' | translate }}</span>\n</div>\n</button>\n</div>";
var id1="breadcrumb.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;

/***/ }),
/* 603 */
/***/ (function(module, exports) {

angular.module('ikeweb.user').factory('userHashService', ['sha1', 'loginService',

    function(hash, loginService) {

        function hashWithCurrentUser(s) {
            var stringToHash = s;
            if (loginService.getLoggedInUser()) {
                stringToHash += loginService.getLoggedInUser().getSessionToken();
            }
            return hash(stringToHash);
        }

        return {
            hash: hashWithCurrentUser
        };
    }
]);


/***/ }),
/* 604 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[164]);


// WEBPACK FOOTER //
// assets/4.0/application-66052d320601f303523a.js